var uf = Object.defineProperty;
var cf = (e, t, r) => t in e ? uf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Ki = (e, t, r) => (cf(e, typeof t != "symbol" ? t + "" : t, r), r);
import * as Ft from "react";
import Dr, { useState as Er, useCallback as ae, useEffect as oi, useMemo as Ar, lazy as ff, createContext as gi, Component as lf, isValidElement as hf, createElement as ai, useContext as dn, forwardRef as df, useRef as Ga, Suspense as pf, useLayoutEffect as Va, Fragment as vf } from "react";
import { TimestampUnit as Ya, DateTimeRange as yf, DateTime as or } from "@bimone/bimtrack-dates";
import { useTranslation as gf, I18nextProvider as mf } from "react-i18next";
import ui from "i18next";
class _f extends Error {
  constructor() {
    super("The requested has timed out"), this.name = "RequestTimeoutError";
  }
}
class bf extends Error {
  constructor() {
    super("The request was actively canceled"), this.name = "RequestCanceledError";
  }
}
var Wr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gs = { exports: {} }, Fo = Object.hasOwnProperty, wf = Object.getPrototypeOf, Lo = Error.captureStackTrace, Ef = ci;
function ci(e, t) {
  if (e && typeof e == "object" ? (t = e, e = void 0) : this.message = e, t)
    for (var r in t)
      this[r] = t[r];
  Fo.call(this, "name") || (this.name = Fo.call(wf(this), "name") ? this.name : this.constructor.name), Lo && !("stack" in this) && Lo(this, this.constructor);
}
ci.prototype = Object.create(Error.prototype, {
  constructor: { value: ci, configurable: !0, writable: !0 }
});
ci.prototype.name = "StandardError";
const Sf = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
(function(e, t) {
  t = e.exports = s;
  var r = Ef, n = Sf, i = t;
  function s(u, f, l) {
    if (typeof u == "string" && (u = i[u]), typeof u != "number")
      throw new TypeError("Non-numeric HTTP code");
    typeof f == "object" && f != null && (l = f, f = null), r.call(this, f || n[u], l), this.code = u;
  }
  s.prototype = Object.create(r.prototype, {
    constructor: { value: s, configurable: !0, writable: !0 }
  }), s.prototype.name = "HttpError", Object.defineProperties(s.prototype, {
    statusCode: c("code"),
    statusMessage: c("message"),
    status: {
      configurable: !0,
      get: function() {
        return this.code;
      },
      set: function(u) {
        Object.defineProperty(this, "status", {
          value: u,
          configurable: !0,
          enumerable: !0,
          writable: !0
        });
      }
    }
  }), s.prototype.toString = function() {
    return this.name + ": " + this.code + " " + this.message;
  };
  for (var o in n) {
    var a = n[o];
    t[a.replace("'", "").replace(/[- ]/g, "_").toUpperCase()] = +o;
  }
  function c(u) {
    return {
      configurable: !0,
      get: function() {
        return this[u];
      },
      set: function(f) {
        return this[u] = f;
      }
    };
  }
})(gs, gs.exports);
var Of = gs.exports;
const mi = /* @__PURE__ */ Fs(Of);
var fi = { exports: {} };
fi.exports;
(function(e, t) {
  var r = 200, n = "Expected a function", i = "__lodash_hash_undefined__", s = 1, o = 2, a = 1 / 0, c = 9007199254740991, u = "[object Arguments]", f = "[object Array]", l = "[object Boolean]", d = "[object Date]", p = "[object Error]", y = "[object Function]", m = "[object GeneratorFunction]", _ = "[object Map]", b = "[object Number]", w = "[object Object]", R = "[object Promise]", A = "[object RegExp]", F = "[object Set]", k = "[object String]", O = "[object Symbol]", x = "[object WeakMap]", I = "[object ArrayBuffer]", N = "[object DataView]", H = "[object Float32Array]", nt = "[object Float64Array]", G = "[object Int8Array]", ft = "[object Int16Array]", ot = "[object Int32Array]", He = "[object Uint8Array]", ne = "[object Uint8ClampedArray]", be = "[object Uint16Array]", Ke = "[object Uint32Array]", Qe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ge = /^\w*$/, Ve = /^\./, Te = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, he = /[\\^$.*+?()[\]{}|]/g, dr = /\\(\\)?/g, we = /^\[object .+?Constructor\]$/, Qt = /^(?:0|[1-9]\d*)$/, J = {};
  J[H] = J[nt] = J[G] = J[ft] = J[ot] = J[He] = J[ne] = J[be] = J[Ke] = !0, J[u] = J[f] = J[I] = J[l] = J[N] = J[d] = J[p] = J[y] = J[_] = J[b] = J[w] = J[A] = J[F] = J[k] = J[x] = !1;
  var de = typeof Wr == "object" && Wr && Wr.Object === Object && Wr, pe = typeof self == "object" && self && self.Object === Object && self, zt = de || pe || Function("return this")(), ie = t && !t.nodeType && t, De = ie && !0 && e && !e.nodeType && e, En = De && De.exports === ie, S = En && de.process, T = function() {
    try {
      return S && S.binding("util");
    } catch {
    }
  }(), P = T && T.isTypedArray;
  function V(h, v) {
    for (var E = -1, D = h ? h.length : 0; ++E < D; )
      if (v(h[E], E, h))
        return !0;
    return !1;
  }
  function Y(h) {
    return function(v) {
      return v == null ? void 0 : v[h];
    };
  }
  function it(h, v) {
    for (var E = -1, D = Array(h); ++E < h; )
      D[E] = v(E);
    return D;
  }
  function X(h) {
    return function(v) {
      return h(v);
    };
  }
  function gt(h, v) {
    return h == null ? void 0 : h[v];
  }
  function jr(h) {
    var v = !1;
    if (h != null && typeof h.toString != "function")
      try {
        v = !!(h + "");
      } catch {
      }
    return v;
  }
  function ki(h) {
    var v = -1, E = Array(h.size);
    return h.forEach(function(D, $) {
      E[++v] = [$, D];
    }), E;
  }
  function Sn(h, v) {
    return function(E) {
      return h(v(E));
    };
  }
  function On(h) {
    var v = -1, E = Array(h.size);
    return h.forEach(function(D) {
      E[++v] = D;
    }), E;
  }
  var Ye = Array.prototype, Fi = Function.prototype, We = Object.prototype, pr = zt["__core-js_shared__"], vr = function() {
    var h = /[^.]+$/.exec(pr && pr.keys && pr.keys.IE_PROTO || "");
    return h ? "Symbol(src)_1." + h : "";
  }(), In = Fi.toString, se = We.hasOwnProperty, Ae = We.toString, Li = RegExp(
    "^" + In.call(se).replace(he, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Cn = zt.Symbol, Pn = zt.Uint8Array, Ni = We.propertyIsEnumerable, $r = Ye.splice, Rn = Sn(Object.keys, Object), ve = gr(zt, "DataView"), Ee = gr(zt, "Map"), Je = gr(zt, "Promise"), yr = gr(zt, "Set"), zr = gr(zt, "WeakMap"), xe = gr(Object, "create"), Mi = Ze(ve), Tn = Ze(Ee), Dn = Ze(Je), qi = Ze(yr), Ui = Ze(zr), Xe = Cn ? Cn.prototype : void 0, Br = Xe ? Xe.valueOf : void 0, An = Xe ? Xe.toString : void 0;
  function Se(h) {
    var v = -1, E = h ? h.length : 0;
    for (this.clear(); ++v < E; ) {
      var D = h[v];
      this.set(D[0], D[1]);
    }
  }
  function ji() {
    this.__data__ = xe ? xe(null) : {};
  }
  function g(h) {
    return this.has(h) && delete this.__data__[h];
  }
  function C(h) {
    var v = this.__data__;
    if (xe) {
      var E = v[h];
      return E === i ? void 0 : E;
    }
    return se.call(v, h) ? v[h] : void 0;
  }
  function L(h) {
    var v = this.__data__;
    return xe ? v[h] !== void 0 : se.call(v, h);
  }
  function q(h, v) {
    var E = this.__data__;
    return E[h] = xe && v === void 0 ? i : v, this;
  }
  Se.prototype.clear = ji, Se.prototype.delete = g, Se.prototype.get = C, Se.prototype.has = L, Se.prototype.set = q;
  function B(h) {
    var v = -1, E = h ? h.length : 0;
    for (this.clear(); ++v < E; ) {
      var D = h[v];
      this.set(D[0], D[1]);
    }
  }
  function rt() {
    this.__data__ = [];
  }
  function Q(h) {
    var v = this.__data__, E = Fn(v, h);
    if (E < 0)
      return !1;
    var D = v.length - 1;
    return E == D ? v.pop() : $r.call(v, E, 1), !0;
  }
  function K(h) {
    var v = this.__data__, E = Fn(v, h);
    return E < 0 ? void 0 : v[E][1];
  }
  function Ot(h) {
    return Fn(this.__data__, h) > -1;
  }
  function vt(h, v) {
    var E = this.__data__, D = Fn(E, h);
    return D < 0 ? E.push([h, v]) : E[D][1] = v, this;
  }
  B.prototype.clear = rt, B.prototype.delete = Q, B.prototype.get = K, B.prototype.has = Ot, B.prototype.set = vt;
  function tt(h) {
    var v = -1, E = h ? h.length : 0;
    for (this.clear(); ++v < E; ) {
      var D = h[v];
      this.set(D[0], D[1]);
    }
  }
  function Nt() {
    this.__data__ = {
      hash: new Se(),
      map: new (Ee || B)(),
      string: new Se()
    };
  }
  function ke(h) {
    return Ln(this, h).delete(h);
  }
  function xn(h) {
    return Ln(this, h).get(h);
  }
  function oe(h) {
    return Ln(this, h).has(h);
  }
  function wc(h, v) {
    return Ln(this, h).set(h, v), this;
  }
  tt.prototype.clear = Nt, tt.prototype.delete = ke, tt.prototype.get = xn, tt.prototype.has = oe, tt.prototype.set = wc;
  function kn(h) {
    var v = -1, E = h ? h.length : 0;
    for (this.__data__ = new tt(); ++v < E; )
      this.add(h[v]);
  }
  function Ec(h) {
    return this.__data__.set(h, i), this;
  }
  function Sc(h) {
    return this.__data__.has(h);
  }
  kn.prototype.add = kn.prototype.push = Ec, kn.prototype.has = Sc;
  function Oe(h) {
    this.__data__ = new B(h);
  }
  function Oc() {
    this.__data__ = new B();
  }
  function Ic(h) {
    return this.__data__.delete(h);
  }
  function Cc(h) {
    return this.__data__.get(h);
  }
  function Pc(h) {
    return this.__data__.has(h);
  }
  function Rc(h, v) {
    var E = this.__data__;
    if (E instanceof B) {
      var D = E.__data__;
      if (!Ee || D.length < r - 1)
        return D.push([h, v]), this;
      E = this.__data__ = new tt(D);
    }
    return E.set(h, v), this;
  }
  Oe.prototype.clear = Oc, Oe.prototype.delete = Ic, Oe.prototype.get = Cc, Oe.prototype.has = Pc, Oe.prototype.set = Rc;
  function Tc(h, v) {
    var E = tr(h) || Do(h) ? it(h.length, String) : [], D = E.length, $ = !!D;
    for (var M in h)
      (v || se.call(h, M)) && !($ && (M == "length" || Co(M, D))) && E.push(M);
    return E;
  }
  function Fn(h, v) {
    for (var E = h.length; E--; )
      if (To(h[E][0], v))
        return E;
    return -1;
  }
  var Dc = Hc();
  function Ac(h, v) {
    return h && Dc(h, v, jn);
  }
  function So(h, v) {
    v = Nn(v, h) ? [v] : Oo(v);
    for (var E = 0, D = v.length; h != null && E < D; )
      h = h[Mn(v[E++])];
    return E && E == D ? h : void 0;
  }
  function xc(h) {
    return Ae.call(h);
  }
  function kc(h, v) {
    return h != null && v in Object(h);
  }
  function $i(h, v, E, D, $) {
    return h === v ? !0 : h == null || v == null || !qn(h) && !Un(v) ? h !== h && v !== v : Fc(h, v, $i, E, D, $);
  }
  function Fc(h, v, E, D, $, M) {
    var et = tr(h), at = tr(v), yt = f, Et = f;
    et || (yt = Fe(h), yt = yt == u ? w : yt), at || (Et = Fe(v), Et = Et == u ? w : Et);
    var xt = yt == w && !jr(h), Mt = Et == w && !jr(v), St = yt == Et;
    if (St && !xt)
      return M || (M = new Oe()), et || tf(h) ? Io(h, v, E, D, $, M) : Kc(h, v, yt, E, D, $, M);
    if (!($ & o)) {
      var Gt = xt && se.call(h, "__wrapped__"), Vt = Mt && se.call(v, "__wrapped__");
      if (Gt || Vt) {
        var Le = Gt ? h.value() : h, Ie = Vt ? v.value() : v;
        return M || (M = new Oe()), E(Le, Ie, D, $, M);
      }
    }
    return St ? (M || (M = new Oe()), Qc(h, v, E, D, $, M)) : !1;
  }
  function Lc(h, v, E, D) {
    var $ = E.length, M = $, et = !D;
    if (h == null)
      return !M;
    for (h = Object(h); $--; ) {
      var at = E[$];
      if (et && at[2] ? at[1] !== h[at[0]] : !(at[0] in h))
        return !1;
    }
    for (; ++$ < M; ) {
      at = E[$];
      var yt = at[0], Et = h[yt], xt = at[1];
      if (et && at[2]) {
        if (Et === void 0 && !(yt in h))
          return !1;
      } else {
        var Mt = new Oe();
        if (D)
          var St = D(Et, xt, yt, h, v, Mt);
        if (!(St === void 0 ? $i(xt, Et, D, s | o, Mt) : St))
          return !1;
      }
    }
    return !0;
  }
  function Nc(h) {
    if (!qn(h) || Wc(h))
      return !1;
    var v = xo(h) || jr(h) ? Li : we;
    return v.test(Ze(h));
  }
  function Mc(h) {
    return Un(h) && Bi(h.length) && !!J[Ae.call(h)];
  }
  function qc(h) {
    return typeof h == "function" ? h : h == null ? of : typeof h == "object" ? tr(h) ? $c(h[0], h[1]) : jc(h) : af(h);
  }
  function Uc(h) {
    if (!Jc(h))
      return Rn(h);
    var v = [];
    for (var E in Object(h))
      se.call(h, E) && E != "constructor" && v.push(E);
    return v;
  }
  function jc(h) {
    var v = Gc(h);
    return v.length == 1 && v[0][2] ? Ro(v[0][0], v[0][1]) : function(E) {
      return E === h || Lc(E, h, v);
    };
  }
  function $c(h, v) {
    return Nn(h) && Po(v) ? Ro(Mn(h), v) : function(E) {
      var D = rf(E, h);
      return D === void 0 && D === v ? nf(E, h) : $i(v, D, void 0, s | o);
    };
  }
  function zc(h) {
    return function(v) {
      return So(v, h);
    };
  }
  function Bc(h) {
    if (typeof h == "string")
      return h;
    if (Hi(h))
      return An ? An.call(h) : "";
    var v = h + "";
    return v == "0" && 1 / h == -a ? "-0" : v;
  }
  function Oo(h) {
    return tr(h) ? h : Xc(h);
  }
  function Hc(h) {
    return function(v, E, D) {
      for (var $ = -1, M = Object(v), et = D(v), at = et.length; at--; ) {
        var yt = et[h ? at : ++$];
        if (E(M[yt], yt, M) === !1)
          break;
      }
      return v;
    };
  }
  function Io(h, v, E, D, $, M) {
    var et = $ & o, at = h.length, yt = v.length;
    if (at != yt && !(et && yt > at))
      return !1;
    var Et = M.get(h);
    if (Et && M.get(v))
      return Et == v;
    var xt = -1, Mt = !0, St = $ & s ? new kn() : void 0;
    for (M.set(h, v), M.set(v, h); ++xt < at; ) {
      var Gt = h[xt], Vt = v[xt];
      if (D)
        var Le = et ? D(Vt, Gt, xt, v, h, M) : D(Gt, Vt, xt, h, v, M);
      if (Le !== void 0) {
        if (Le)
          continue;
        Mt = !1;
        break;
      }
      if (St) {
        if (!V(v, function(Ie, er) {
          if (!St.has(er) && (Gt === Ie || E(Gt, Ie, D, $, M)))
            return St.add(er);
        })) {
          Mt = !1;
          break;
        }
      } else if (!(Gt === Vt || E(Gt, Vt, D, $, M))) {
        Mt = !1;
        break;
      }
    }
    return M.delete(h), M.delete(v), Mt;
  }
  function Kc(h, v, E, D, $, M, et) {
    switch (E) {
      case N:
        if (h.byteLength != v.byteLength || h.byteOffset != v.byteOffset)
          return !1;
        h = h.buffer, v = v.buffer;
      case I:
        return !(h.byteLength != v.byteLength || !D(new Pn(h), new Pn(v)));
      case l:
      case d:
      case b:
        return To(+h, +v);
      case p:
        return h.name == v.name && h.message == v.message;
      case A:
      case k:
        return h == v + "";
      case _:
        var at = ki;
      case F:
        var yt = M & o;
        if (at || (at = On), h.size != v.size && !yt)
          return !1;
        var Et = et.get(h);
        if (Et)
          return Et == v;
        M |= s, et.set(h, v);
        var xt = Io(at(h), at(v), D, $, M, et);
        return et.delete(h), xt;
      case O:
        if (Br)
          return Br.call(h) == Br.call(v);
    }
    return !1;
  }
  function Qc(h, v, E, D, $, M) {
    var et = $ & o, at = jn(h), yt = at.length, Et = jn(v), xt = Et.length;
    if (yt != xt && !et)
      return !1;
    for (var Mt = yt; Mt--; ) {
      var St = at[Mt];
      if (!(et ? St in v : se.call(v, St)))
        return !1;
    }
    var Gt = M.get(h);
    if (Gt && M.get(v))
      return Gt == v;
    var Vt = !0;
    M.set(h, v), M.set(v, h);
    for (var Le = et; ++Mt < yt; ) {
      St = at[Mt];
      var Ie = h[St], er = v[St];
      if (D)
        var ko = et ? D(er, Ie, St, v, h, M) : D(Ie, er, St, h, v, M);
      if (!(ko === void 0 ? Ie === er || E(Ie, er, D, $, M) : ko)) {
        Vt = !1;
        break;
      }
      Le || (Le = St == "constructor");
    }
    if (Vt && !Le) {
      var $n = h.constructor, zn = v.constructor;
      $n != zn && "constructor" in h && "constructor" in v && !(typeof $n == "function" && $n instanceof $n && typeof zn == "function" && zn instanceof zn) && (Vt = !1);
    }
    return M.delete(h), M.delete(v), Vt;
  }
  function Ln(h, v) {
    var E = h.__data__;
    return Yc(v) ? E[typeof v == "string" ? "string" : "hash"] : E.map;
  }
  function Gc(h) {
    for (var v = jn(h), E = v.length; E--; ) {
      var D = v[E], $ = h[D];
      v[E] = [D, $, Po($)];
    }
    return v;
  }
  function gr(h, v) {
    var E = gt(h, v);
    return Nc(E) ? E : void 0;
  }
  var Fe = xc;
  (ve && Fe(new ve(new ArrayBuffer(1))) != N || Ee && Fe(new Ee()) != _ || Je && Fe(Je.resolve()) != R || yr && Fe(new yr()) != F || zr && Fe(new zr()) != x) && (Fe = function(h) {
    var v = Ae.call(h), E = v == w ? h.constructor : void 0, D = E ? Ze(E) : void 0;
    if (D)
      switch (D) {
        case Mi:
          return N;
        case Tn:
          return _;
        case Dn:
          return R;
        case qi:
          return F;
        case Ui:
          return x;
      }
    return v;
  });
  function Vc(h, v, E) {
    v = Nn(v, h) ? [v] : Oo(v);
    for (var D, $ = -1, et = v.length; ++$ < et; ) {
      var M = Mn(v[$]);
      if (!(D = h != null && E(h, M)))
        break;
      h = h[M];
    }
    if (D)
      return D;
    var et = h ? h.length : 0;
    return !!et && Bi(et) && Co(M, et) && (tr(h) || Do(h));
  }
  function Co(h, v) {
    return v = v ?? c, !!v && (typeof h == "number" || Qt.test(h)) && h > -1 && h % 1 == 0 && h < v;
  }
  function Nn(h, v) {
    if (tr(h))
      return !1;
    var E = typeof h;
    return E == "number" || E == "symbol" || E == "boolean" || h == null || Hi(h) ? !0 : Ge.test(h) || !Qe.test(h) || v != null && h in Object(v);
  }
  function Yc(h) {
    var v = typeof h;
    return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? h !== "__proto__" : h === null;
  }
  function Wc(h) {
    return !!vr && vr in h;
  }
  function Jc(h) {
    var v = h && h.constructor, E = typeof v == "function" && v.prototype || We;
    return h === E;
  }
  function Po(h) {
    return h === h && !qn(h);
  }
  function Ro(h, v) {
    return function(E) {
      return E == null ? !1 : E[h] === v && (v !== void 0 || h in Object(E));
    };
  }
  var Xc = zi(function(h) {
    h = ef(h);
    var v = [];
    return Ve.test(h) && v.push(""), h.replace(Te, function(E, D, $, M) {
      v.push($ ? M.replace(dr, "$1") : D || E);
    }), v;
  });
  function Mn(h) {
    if (typeof h == "string" || Hi(h))
      return h;
    var v = h + "";
    return v == "0" && 1 / h == -a ? "-0" : v;
  }
  function Ze(h) {
    if (h != null) {
      try {
        return In.call(h);
      } catch {
      }
      try {
        return h + "";
      } catch {
      }
    }
    return "";
  }
  function zi(h, v) {
    if (typeof h != "function" || v && typeof v != "function")
      throw new TypeError(n);
    var E = function() {
      var D = arguments, $ = v ? v.apply(this, D) : D[0], M = E.cache;
      if (M.has($))
        return M.get($);
      var et = h.apply(this, D);
      return E.cache = M.set($, et), et;
    };
    return E.cache = new (zi.Cache || tt)(), E;
  }
  zi.Cache = tt;
  function To(h, v) {
    return h === v || h !== h && v !== v;
  }
  function Do(h) {
    return Zc(h) && se.call(h, "callee") && (!Ni.call(h, "callee") || Ae.call(h) == u);
  }
  var tr = Array.isArray;
  function Ao(h) {
    return h != null && Bi(h.length) && !xo(h);
  }
  function Zc(h) {
    return Un(h) && Ao(h);
  }
  function xo(h) {
    var v = qn(h) ? Ae.call(h) : "";
    return v == y || v == m;
  }
  function Bi(h) {
    return typeof h == "number" && h > -1 && h % 1 == 0 && h <= c;
  }
  function qn(h) {
    var v = typeof h;
    return !!h && (v == "object" || v == "function");
  }
  function Un(h) {
    return !!h && typeof h == "object";
  }
  function Hi(h) {
    return typeof h == "symbol" || Un(h) && Ae.call(h) == O;
  }
  var tf = P ? X(P) : Mc;
  function ef(h) {
    return h == null ? "" : Bc(h);
  }
  function rf(h, v, E) {
    var D = h == null ? void 0 : So(h, v);
    return D === void 0 ? E : D;
  }
  function nf(h, v) {
    return h != null && Vc(h, v, kc);
  }
  function jn(h) {
    return Ao(h) ? Tc(h) : Uc(h);
  }
  function sf(h, v) {
    var E = {};
    return v = qc(v), Ac(h, function(D, $, M) {
      E[v(D, $, M)] = D;
    }), E;
  }
  function of(h) {
    return h;
  }
  function af(h) {
    return Nn(h) ? Y(Mn(h)) : zc(h);
  }
  e.exports = sf;
})(fi, fi.exports);
var If = fi.exports;
const Cf = /* @__PURE__ */ Fs(If), Pf = 6e4;
var Wa = /* @__PURE__ */ ((e) => (e.OMIT = "omit", e.SAME_ORIGIN = "same-origin", e.INCLUDE = "include", e))(Wa || {}), Ne = /* @__PURE__ */ ((e) => (e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.DELETE = "DELETE", e.PATCH = "PATCH", e))(Ne || {});
class ar {
  constructor({
    baseUrl: t = "",
    endpoint: r,
    token: n,
    body: i,
    credentials: s = Wa.SAME_ORIGIN,
    queryParams: o = {},
    headers: a = {},
    captchaToken: c,
    signal: u,
    timeOutMs: f = Pf
  }) {
    this.baseUrl = t, this.endpoint = r, this.token = n, this.body = i, this.queryParams = o, this.currentHeaders = a, this.credentials = s, this.captchaToken = c, this.signal = u, this.timeOutMs = f;
  }
  get headers() {
    return this.currentHeaders;
  }
  async performRequest(t) {
    var c;
    const r = this.buildRequestUrl(), n = this.buildRequestHeaders(), i = new AbortController();
    let s;
    const o = this.body ? { method: t, headers: n, credentials: this.credentials, body: this.buildBody(), signal: i == null ? void 0 : i.signal } : { method: t, headers: n, credentials: this.credentials, signal: i == null ? void 0 : i.signal };
    (c = this.signal) == null || c.addEventListener("abort", () => {
      s = new bf(), i.abort();
    });
    const a = setTimeout(() => {
      s = new _f(), i.abort();
    }, this.timeOutMs);
    try {
      return await fetch(r, o);
    } catch (u) {
      throw s ?? u;
    } finally {
      clearTimeout(a);
    }
  }
  buildRequestUrl() {
    const t = Object.keys(this.queryParams).filter((n) => this.queryParams[n] !== void 0 && this.queryParams[n] !== null).map((n) => [n, this.queryParams[n]].map((i) => encodeURIComponent(String(i))).join("=")).join("&"), r = `${ar.stripTrailingSlash(this.baseUrl)}/${this.endpoint}`;
    return t.length > 0 ? `${r}?${t}` : r;
  }
  buildRequestHeaders() {
    const t = this.isBodyContainsAFile() ? this.headers : { Accept: "application/json", ...this.headers }, r = this.body && !this.isBodyContainsAFile() ? { "Content-Type": "application/json" } : void 0, n = this.token ? { Authorization: `Bearer ${this.token}` } : void 0, i = this.captchaToken ? { "X-Captcha-Token": this.captchaToken } : void 0;
    return {
      ...t,
      ...n,
      ...r,
      ...i
    };
  }
  setupHeaderForGetRequest() {
    this.currentHeaders = {
      Pragma: "no-cache",
      "Cache-Control": "no-cache",
      ...this.currentHeaders
    };
  }
  static async processErrorInResponse(t) {
    const r = await t.json(), n = Cf(r, (i, s) => s.charAt(0).toLowerCase() + s.slice(1));
    return new mi(t.status, n.message ?? n.title, {
      errorCode: n.code,
      //Can't call just "code" as it's already used by HttpError for HTTP status
      data: n.data,
      type: n.type
    });
  }
  isBodyContainsAFile() {
    return this.body instanceof FormData;
  }
  buildBody() {
    return this.body ? this.isBodyContainsAFile() ? this.body : JSON.stringify(this.body) : null;
  }
  static stripTrailingSlash(t) {
    return t.replace(/\/+$/, "");
  }
}
class Ja extends ar {
  async getBlob() {
    return await this.sendBlobRequest(Ne.GET);
  }
  async sendBlobRequest(t) {
    const r = await this.performRequest(t);
    return await Ja.handleBlobResponse(r);
  }
  static async handleBlobResponse(t) {
    if (t.ok)
      return await t.blob();
    throw new mi(t.status, t.statusText);
  }
}
class Ls extends ar {
  async get() {
    return await this.sendRequest(Ne.GET);
  }
  async post() {
    return await this.sendRequest(Ne.POST);
  }
  async put() {
    return await this.sendRequest(Ne.PUT);
  }
  async delete() {
    return await this.sendRequest(Ne.DELETE);
  }
  async patch() {
    return await this.sendRequest(Ne.PATCH);
  }
  async sendRequest(t) {
    t === Ne.GET && this.setupHeaderForGetRequest();
    const r = await this.performRequest(t);
    return await Ls.handleResponse(r);
  }
  static async handleResponse(t) {
    if (!t.ok)
      throw await ar.processErrorInResponse(t);
    if (t.body && t.status !== 204)
      return t.json();
  }
}
const ms = class extends ar {
  async head() {
    const e = await this.performRequest(ms.HEAD_METHOD);
    return await ms.handleHeadResponse(e);
  }
  static async handleHeadResponse(e) {
    if (e.ok)
      return e.headers;
    throw await ar.processErrorInResponse(e);
  }
};
let Rf = ms;
Rf.HEAD_METHOD = "HEAD";
var br = /* @__PURE__ */ ((e) => (e[e.PENDING = 0] = "PENDING", e[e.READY = 1] = "READY", e[e.FAILED = 2] = "FAILED", e))(br || {});
const Xa = window, Tf = "default", Df = "default";
function Af(e) {
  return Array.from(document.querySelectorAll("script")).find((t) => t.src === e ? t : void 0);
}
const rr = /* @__PURE__ */ new Map();
function xf(e, t, r = !0, n = !1) {
  const i = rr.get(t);
  if (i)
    return i;
  const s = new Promise((o, a) => {
    try {
      if (t && Xa[t]) {
        o(), rr.delete(t);
        return;
      }
      let c = Af(e);
      if (c) {
        o(), rr.delete(t);
        return;
      }
      c = document.createElement("script"), c.src = e, c.type = "text/javascript", c.async = n, c.defer = r, c.onload = () => {
        o(), rr.delete(t);
      }, c.onerror = () => {
        a(new Error("Unable to load the remote module's script!")), rr.delete(t);
      }, document.head.appendChild(c);
    } catch (c) {
      throw rr.delete(t), c;
    }
  });
  return rr.set(t, s), s;
}
const Zn = /* @__PURE__ */ new Map();
function No(e, t, r, n) {
  return `${e}:${t}:${r}/${n}`;
}
async function kf({ url: e, scope: t, module: r, namedExport: n, defer: i = !0, async: s = !1 }, o = !0) {
  const a = n ?? Df, c = No(e, t, r, a);
  let u;
  if (!o || !Zn.has(c)) {
    await xf(e, t, i, s), await __webpack_init_sharing__(Tf);
    const f = Xa[t];
    await f.init(__webpack_share_scopes__.default), u = (await f.get(r))()[a], o && Zn.set(No(e, t, r, a), u);
  } else
    u = Zn.get(c);
  if (!u)
    throw new Error(`'${a}' export is not defined in module`);
  return u;
}
function Vp() {
  Zn.clear();
}
function Ff({ url: e, scope: t, module: r, namedExport: n, defer: i = !0, async: s = !1 }, o = !1, a = !0) {
  const [c, u] = Er(void 0), f = ae(async () => {
    const l = await kf({ url: e, scope: t, module: r, namedExport: n, defer: i, async: s }, a);
    return u(() => l), l;
  }, [s, a, i, r, n, t, e]);
  return oi(() => {
    o && f().then();
  }, [o, f]), { exportedValue: c, load: f };
}
var _s = { exports: {} }, Hr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mo;
function Lf() {
  if (Mo)
    return Hr;
  Mo = 1;
  var e = Dr, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, u) {
    var f, l = {}, d = null, p = null;
    u !== void 0 && (d = "" + u), c.key !== void 0 && (d = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (f in c)
      n.call(c, f) && !s.hasOwnProperty(f) && (l[f] = c[f]);
    if (a && a.defaultProps)
      for (f in c = a.defaultProps, c)
        l[f] === void 0 && (l[f] = c[f]);
    return { $$typeof: t, type: a, key: d, ref: p, props: l, _owner: i.current };
  }
  return Hr.Fragment = r, Hr.jsx = o, Hr.jsxs = o, Hr;
}
var Kr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qo;
function Nf() {
  return qo || (qo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Dr, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y = Symbol.iterator, m = "@@iterator";
    function _(g) {
      if (g === null || typeof g != "object")
        return null;
      var C = y && g[y] || g[m];
      return typeof C == "function" ? C : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(g) {
      {
        for (var C = arguments.length, L = new Array(C > 1 ? C - 1 : 0), q = 1; q < C; q++)
          L[q - 1] = arguments[q];
        R("error", g, L);
      }
    }
    function R(g, C, L) {
      {
        var q = b.ReactDebugCurrentFrame, B = q.getStackAddendum();
        B !== "" && (C += "%s", L = L.concat([B]));
        var rt = L.map(function(Q) {
          return String(Q);
        });
        rt.unshift("Warning: " + C), Function.prototype.apply.call(console[g], console, rt);
      }
    }
    var A = !1, F = !1, k = !1, O = !1, x = !1, I;
    I = Symbol.for("react.module.reference");
    function N(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === n || g === s || x || g === i || g === u || g === f || O || g === p || A || F || k || typeof g == "object" && g !== null && (g.$$typeof === d || g.$$typeof === l || g.$$typeof === o || g.$$typeof === a || g.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === I || g.getModuleId !== void 0));
    }
    function H(g, C, L) {
      var q = g.displayName;
      if (q)
        return q;
      var B = C.displayName || C.name || "";
      return B !== "" ? L + "(" + B + ")" : L;
    }
    function nt(g) {
      return g.displayName || "Context";
    }
    function G(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case a:
            var C = g;
            return nt(C) + ".Consumer";
          case o:
            var L = g;
            return nt(L._context) + ".Provider";
          case c:
            return H(g, g.render, "ForwardRef");
          case l:
            var q = g.displayName || null;
            return q !== null ? q : G(g.type) || "Memo";
          case d: {
            var B = g, rt = B._payload, Q = B._init;
            try {
              return G(Q(rt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ft = Object.assign, ot = 0, He, ne, be, Ke, Qe, Ge, Ve;
    function Te() {
    }
    Te.__reactDisabledLog = !0;
    function he() {
      {
        if (ot === 0) {
          He = console.log, ne = console.info, be = console.warn, Ke = console.error, Qe = console.group, Ge = console.groupCollapsed, Ve = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: Te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        ot++;
      }
    }
    function dr() {
      {
        if (ot--, ot === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ft({}, g, {
              value: He
            }),
            info: ft({}, g, {
              value: ne
            }),
            warn: ft({}, g, {
              value: be
            }),
            error: ft({}, g, {
              value: Ke
            }),
            group: ft({}, g, {
              value: Qe
            }),
            groupCollapsed: ft({}, g, {
              value: Ge
            }),
            groupEnd: ft({}, g, {
              value: Ve
            })
          });
        }
        ot < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = b.ReactCurrentDispatcher, Qt;
    function J(g, C, L) {
      {
        if (Qt === void 0)
          try {
            throw Error();
          } catch (B) {
            var q = B.stack.trim().match(/\n( *(at )?)/);
            Qt = q && q[1] || "";
          }
        return `
` + Qt + g;
      }
    }
    var de = !1, pe;
    {
      var zt = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new zt();
    }
    function ie(g, C) {
      if (!g || de)
        return "";
      {
        var L = pe.get(g);
        if (L !== void 0)
          return L;
      }
      var q;
      de = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var rt;
      rt = we.current, we.current = null, he();
      try {
        if (C) {
          var Q = function() {
            throw Error();
          };
          if (Object.defineProperty(Q.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Q, []);
            } catch (oe) {
              q = oe;
            }
            Reflect.construct(g, [], Q);
          } else {
            try {
              Q.call();
            } catch (oe) {
              q = oe;
            }
            g.call(Q.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            q = oe;
          }
          g();
        }
      } catch (oe) {
        if (oe && q && typeof oe.stack == "string") {
          for (var K = oe.stack.split(`
`), Ot = q.stack.split(`
`), vt = K.length - 1, tt = Ot.length - 1; vt >= 1 && tt >= 0 && K[vt] !== Ot[tt]; )
            tt--;
          for (; vt >= 1 && tt >= 0; vt--, tt--)
            if (K[vt] !== Ot[tt]) {
              if (vt !== 1 || tt !== 1)
                do
                  if (vt--, tt--, tt < 0 || K[vt] !== Ot[tt]) {
                    var Nt = `
` + K[vt].replace(" at new ", " at ");
                    return g.displayName && Nt.includes("<anonymous>") && (Nt = Nt.replace("<anonymous>", g.displayName)), typeof g == "function" && pe.set(g, Nt), Nt;
                  }
                while (vt >= 1 && tt >= 0);
              break;
            }
        }
      } finally {
        de = !1, we.current = rt, dr(), Error.prepareStackTrace = B;
      }
      var ke = g ? g.displayName || g.name : "", xn = ke ? J(ke) : "";
      return typeof g == "function" && pe.set(g, xn), xn;
    }
    function De(g, C, L) {
      return ie(g, !1);
    }
    function En(g) {
      var C = g.prototype;
      return !!(C && C.isReactComponent);
    }
    function S(g, C, L) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return ie(g, En(g));
      if (typeof g == "string")
        return J(g);
      switch (g) {
        case u:
          return J("Suspense");
        case f:
          return J("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case c:
            return De(g.render);
          case l:
            return S(g.type, C, L);
          case d: {
            var q = g, B = q._payload, rt = q._init;
            try {
              return S(rt(B), C, L);
            } catch {
            }
          }
        }
      return "";
    }
    var T = Object.prototype.hasOwnProperty, P = {}, V = b.ReactDebugCurrentFrame;
    function Y(g) {
      if (g) {
        var C = g._owner, L = S(g.type, g._source, C ? C.type : null);
        V.setExtraStackFrame(L);
      } else
        V.setExtraStackFrame(null);
    }
    function it(g, C, L, q, B) {
      {
        var rt = Function.call.bind(T);
        for (var Q in g)
          if (rt(g, Q)) {
            var K = void 0;
            try {
              if (typeof g[Q] != "function") {
                var Ot = Error((q || "React class") + ": " + L + " type `" + Q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[Q] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ot.name = "Invariant Violation", Ot;
              }
              K = g[Q](C, Q, q, L, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (vt) {
              K = vt;
            }
            K && !(K instanceof Error) && (Y(B), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", L, Q, typeof K), Y(null)), K instanceof Error && !(K.message in P) && (P[K.message] = !0, Y(B), w("Failed %s type: %s", L, K.message), Y(null));
          }
      }
    }
    var X = Array.isArray;
    function gt(g) {
      return X(g);
    }
    function jr(g) {
      {
        var C = typeof Symbol == "function" && Symbol.toStringTag, L = C && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return L;
      }
    }
    function ki(g) {
      try {
        return Sn(g), !1;
      } catch {
        return !0;
      }
    }
    function Sn(g) {
      return "" + g;
    }
    function On(g) {
      if (ki(g))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", jr(g)), Sn(g);
    }
    var Ye = b.ReactCurrentOwner, Fi = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, We, pr, vr;
    vr = {};
    function In(g) {
      if (T.call(g, "ref")) {
        var C = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function se(g) {
      if (T.call(g, "key")) {
        var C = Object.getOwnPropertyDescriptor(g, "key").get;
        if (C && C.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function Ae(g, C) {
      if (typeof g.ref == "string" && Ye.current && C && Ye.current.stateNode !== C) {
        var L = G(Ye.current.type);
        vr[L] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(Ye.current.type), g.ref), vr[L] = !0);
      }
    }
    function Li(g, C) {
      {
        var L = function() {
          We || (We = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        L.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: L,
          configurable: !0
        });
      }
    }
    function Cn(g, C) {
      {
        var L = function() {
          pr || (pr = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", C));
        };
        L.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: L,
          configurable: !0
        });
      }
    }
    var Pn = function(g, C, L, q, B, rt, Q) {
      var K = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: C,
        ref: L,
        props: Q,
        // Record the component responsible for creating this element.
        _owner: rt
      };
      return K._store = {}, Object.defineProperty(K._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(K, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(K, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.freeze && (Object.freeze(K.props), Object.freeze(K)), K;
    };
    function Ni(g, C, L, q, B) {
      {
        var rt, Q = {}, K = null, Ot = null;
        L !== void 0 && (On(L), K = "" + L), se(C) && (On(C.key), K = "" + C.key), In(C) && (Ot = C.ref, Ae(C, B));
        for (rt in C)
          T.call(C, rt) && !Fi.hasOwnProperty(rt) && (Q[rt] = C[rt]);
        if (g && g.defaultProps) {
          var vt = g.defaultProps;
          for (rt in vt)
            Q[rt] === void 0 && (Q[rt] = vt[rt]);
        }
        if (K || Ot) {
          var tt = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          K && Li(Q, tt), Ot && Cn(Q, tt);
        }
        return Pn(g, K, Ot, B, q, Ye.current, Q);
      }
    }
    var $r = b.ReactCurrentOwner, Rn = b.ReactDebugCurrentFrame;
    function ve(g) {
      if (g) {
        var C = g._owner, L = S(g.type, g._source, C ? C.type : null);
        Rn.setExtraStackFrame(L);
      } else
        Rn.setExtraStackFrame(null);
    }
    var Ee;
    Ee = !1;
    function Je(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function yr() {
      {
        if ($r.current) {
          var g = G($r.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function zr(g) {
      {
        if (g !== void 0) {
          var C = g.fileName.replace(/^.*[\\\/]/, ""), L = g.lineNumber;
          return `

Check your code at ` + C + ":" + L + ".";
        }
        return "";
      }
    }
    var xe = {};
    function Mi(g) {
      {
        var C = yr();
        if (!C) {
          var L = typeof g == "string" ? g : g.displayName || g.name;
          L && (C = `

Check the top-level render call using <` + L + ">.");
        }
        return C;
      }
    }
    function Tn(g, C) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var L = Mi(C);
        if (xe[L])
          return;
        xe[L] = !0;
        var q = "";
        g && g._owner && g._owner !== $r.current && (q = " It was passed a child from " + G(g._owner.type) + "."), ve(g), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', L, q), ve(null);
      }
    }
    function Dn(g, C) {
      {
        if (typeof g != "object")
          return;
        if (gt(g))
          for (var L = 0; L < g.length; L++) {
            var q = g[L];
            Je(q) && Tn(q, C);
          }
        else if (Je(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var B = _(g);
          if (typeof B == "function" && B !== g.entries)
            for (var rt = B.call(g), Q; !(Q = rt.next()).done; )
              Je(Q.value) && Tn(Q.value, C);
        }
      }
    }
    function qi(g) {
      {
        var C = g.type;
        if (C == null || typeof C == "string")
          return;
        var L;
        if (typeof C == "function")
          L = C.propTypes;
        else if (typeof C == "object" && (C.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        C.$$typeof === l))
          L = C.propTypes;
        else
          return;
        if (L) {
          var q = G(C);
          it(L, g.props, "prop", q, g);
        } else if (C.PropTypes !== void 0 && !Ee) {
          Ee = !0;
          var B = G(C);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", B || "Unknown");
        }
        typeof C.getDefaultProps == "function" && !C.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ui(g) {
      {
        for (var C = Object.keys(g.props), L = 0; L < C.length; L++) {
          var q = C[L];
          if (q !== "children" && q !== "key") {
            ve(g), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), ve(null);
            break;
          }
        }
        g.ref !== null && (ve(g), w("Invalid attribute `ref` supplied to `React.Fragment`."), ve(null));
      }
    }
    function Xe(g, C, L, q, B, rt) {
      {
        var Q = N(g);
        if (!Q) {
          var K = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (K += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ot = zr(B);
          Ot ? K += Ot : K += yr();
          var vt;
          g === null ? vt = "null" : gt(g) ? vt = "array" : g !== void 0 && g.$$typeof === t ? (vt = "<" + (G(g.type) || "Unknown") + " />", K = " Did you accidentally export a JSX literal instead of a component?") : vt = typeof g, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", vt, K);
        }
        var tt = Ni(g, C, L, B, rt);
        if (tt == null)
          return tt;
        if (Q) {
          var Nt = C.children;
          if (Nt !== void 0)
            if (q)
              if (gt(Nt)) {
                for (var ke = 0; ke < Nt.length; ke++)
                  Dn(Nt[ke], g);
                Object.freeze && Object.freeze(Nt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dn(Nt, g);
        }
        return g === n ? Ui(tt) : qi(tt), tt;
      }
    }
    function Br(g, C, L) {
      return Xe(g, C, L, !0);
    }
    function An(g, C, L) {
      return Xe(g, C, L, !1);
    }
    var Se = An, ji = Br;
    Kr.Fragment = n, Kr.jsx = Se, Kr.jsxs = ji;
  }()), Kr;
}
process.env.NODE_ENV === "production" ? _s.exports = Lf() : _s.exports = Nf();
var ut = _s.exports;
function Mf(e, t = !0) {
  const { url: r, module: n } = e, [i, s] = Er(br.PENDING), { load: o } = Ff(e, t), a = ae(async () => {
    try {
      s(br.PENDING);
      const u = await o();
      return s(br.READY), { default: u };
    } catch (u) {
      return s(br.FAILED), console.error(`Unable to load the remote module ${n}' @ '${r} for the following reason:`, u), { default: () => /* @__PURE__ */ ut.jsx(ut.Fragment, {}) };
    }
  }, [o, n, r]), c = Ar(() => ff(a), [a]);
  return {
    status: i,
    remoteComponent: c
  };
}
function _i(e, t, r, n) {
  Object.defineProperty(e, t, { get: r, set: n, enumerable: !0, configurable: !0 });
}
var qf = {};
_i(qf, "ErrorBoundary", () => Ms);
var Uf = {};
_i(Uf, "ErrorBoundaryContext", () => Ns);
const Ns = gi(null), Qi = {
  didCatch: !1,
  error: null
};
class Ms extends lf {
  constructor() {
    super(...arguments);
    Ki(this, "state", Qi);
    Ki(this, "resetErrorBoundary", (...r) => {
      var i, s;
      const { error: n } = this.state;
      n !== null && ((s = (i = this.props).onReset) == null || s.call(i, {
        args: r,
        reason: "imperative-api"
      }), this.setState(Qi));
    });
  }
  static getDerivedStateFromError(r) {
    return {
      didCatch: !0,
      error: r
    };
  }
  componentDidCatch(r, n) {
    var i, s;
    (s = (i = this.props).onError) == null || s.call(i, r, n);
  }
  componentDidUpdate(r, n) {
    var o, a;
    const { didCatch: i } = this.state, { resetKeys: s } = this.props;
    i && n.error !== null && jf(r.resetKeys, s) && ((a = (o = this.props).onReset) == null || a.call(o, {
      next: s,
      prev: r.resetKeys,
      reason: "keys"
    }), this.setState(Qi));
  }
  render() {
    const { children: r, fallbackRender: n, FallbackComponent: i, fallback: s } = this.props, { didCatch: o, error: a } = this.state;
    let c = r;
    if (o) {
      const u = {
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (hf(s))
        c = s;
      else if (typeof n == "function")
        c = n(u);
      else if (i)
        c = ai(i, u);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return ai(Ns.Provider, {
      value: {
        didCatch: o,
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, c);
  }
}
function jf(e = [], t = []) {
  return e.length !== t.length || e.some((r, n) => !Object.is(r, t[n]));
}
var $f = {};
_i($f, "useErrorBoundary", () => Bf);
function zf(e) {
  if (e == null || typeof e.didCatch != "boolean" || typeof e.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
  return !0;
}
function Bf() {
  const e = dn(Ns);
  zf(e);
  const [t, r] = Er({
    error: null,
    hasError: !1
  }), n = Ar(() => ({
    resetBoundary: () => {
      e == null || e.resetErrorBoundary(), r({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (i) => r({
      error: i,
      hasError: !0
    })
  }), [
    e == null ? void 0 : e.resetErrorBoundary
  ]);
  if (t.hasError)
    throw t.error;
  return n;
}
var Hf = {};
_i(Hf, "withErrorBoundary", () => Kf);
function Kf(e, t) {
  const r = df((i, s) => ai(Ms, t, ai(e, {
    ...i,
    ref: s
  }))), n = e.displayName || e.name || "Unknown";
  return r.displayName = `withErrorBoundary(${n})`, r;
}
function Qf({ children: e, onFirstRenderRef: t }) {
  return oi(() => () => {
    var r;
    (r = t.current) == null || r.call(t), t.current = void 0;
  }, [t]), /* @__PURE__ */ ut.jsx(ut.Fragment, { children: e });
}
function Gf(e, t) {
  console.error(`Stack: ${e.stack}`), console.error(`Component Stack: ${t.componentStack}`);
}
function Vf({
  remoteEntry: e,
  innerProps: t,
  loadingComponent: r,
  errorComponent: n,
  cached: i,
  onFirstRender: s,
  fallbackRender: o
}) {
  const { status: a, remoteComponent: c } = Mf(e, i), u = Ga(s), f = ae(
    (l) => /* @__PURE__ */ ut.jsx(ut.Fragment, { children: n }),
    [n]
  );
  return a === br.FAILED ? /* @__PURE__ */ ut.jsx(ut.Fragment, { children: n }) : /* @__PURE__ */ ut.jsx(
    Ms,
    {
      fallbackRender: o ?? f,
      onError: Gf,
      children: /* @__PURE__ */ ut.jsx(
        pf,
        {
          fallback: /* @__PURE__ */ ut.jsx(Qf, { onFirstRenderRef: u, children: r }),
          children: /* @__PURE__ */ ut.jsx(c, { ...t ?? {} })
        }
      )
    }
  );
}
Vf.displayName = "FederatedComponent";
const nr = window, Yf = "https://web-sdk.aptrinsic.com/api/aptrinsic.js", Uo = "gainSightScript", Za = gi({
  productKey: void 0,
  locationPathName: "",
  setLocationPathName: () => {
  },
  aptrinsic: () => {
  },
  logDebug: () => {
  },
  isInitialized: !1,
  initialize: () => {
  }
});
function Wf({
  debug: e = !1,
  productKey: t,
  children: r
}) {
  const [n, i] = Er(!1), [s, o] = Er("");
  nr.aptrinsic = nr.aptrinsic || ((...u) => {
    var f, l;
    (l = (f = nr.aptrinsic) == null ? void 0 : f.q) == null || l.push(u);
  }), nr.aptrinsic.q = nr.aptrinsic.q || [], nr.aptrinsic.p = t;
  const a = ae(
    (...u) => {
      e && console.log(...u);
    },
    [e]
  ), c = ae(() => {
    if (n)
      return;
    let u = document.getElementById(Uo);
    if (u) {
      i(!0);
      return;
    }
    if (!t)
      return;
    a("initialize:createElement"), u = document.createElement("script"), u.id = Uo, u.src = Yf + "?a=" + t, u.async = !0;
    const f = document.getElementsByTagName("script")[0];
    ((f == null ? void 0 : f.parentNode) ?? document.head ?? document.body).insertBefore(u, f), i(!0);
  }, [n, a, t]);
  return /* @__PURE__ */ ut.jsx(
    Za.Provider,
    {
      value: {
        productKey: t,
        locationPathName: s,
        setLocationPathName: o,
        aptrinsic: nr.aptrinsic,
        logDebug: a,
        isInitialized: n,
        initialize: c
      },
      children: r
    }
  );
}
Wf.displayName = "GainSightProvider";
function Jf(e) {
  return Ar(() => {
    var t, r, n;
    if (e)
      return {
        id: e.globalId,
        hubId: e.localId.toFixed(1),
        name: e.name,
        hubCreationDate: (t = e.creationDate) == null ? void 0 : t.toTimestampAsString(Ya.SECONDS),
        hubDataCenter: e.dataCenterInfo.name,
        isTrial: (r = e.subscription) == null ? void 0 : r.isTrial,
        hubUserCount: ((n = e.metrics) == null ? void 0 : n.totalUsers) ?? 0
      };
  }, [e]);
}
function Xf(e) {
  return Ar(() => {
    var t, r, n, i;
    if (e)
      return {
        id: e.globalId,
        email: e.email,
        firstName: e.profile.firstName,
        lastName: e.profile.lastName,
        signUpDate: (t = e.activationDate) == null ? void 0 : t.toTimestampAsString(Ya.SECONDS),
        lang: (r = e.profile.language) == null ? void 0 : r.id,
        title: e.profile.title,
        timeZone: (n = e.profile.timeZone) == null ? void 0 : n.nameIana,
        countryCode: (i = e.profile.country) == null ? void 0 : i.id
      };
  }, [e]);
}
function Zf({ user: e, hub: t }) {
  const { productKey: r, aptrinsic: n, logDebug: i, setLocationPathName: s, isInitialized: o, initialize: a } = dn(Za), c = Jf(t), u = Xf(e), f = ae(() => !!u && !!c, [c, u]), l = ae(() => {
    f() && a();
  }, [f, a]), d = ae(
    (m, _) => {
      s(m), f() && (i("configureProduct", _ ?? r, " on ", m), n("config", "tagKey", _ ?? r));
    },
    [n, f, i, r, s]
  ), p = ae(() => {
    f() && (i("identity", u, c), n("identify", u, c), i("set:globalContext", c), n("set", "globalContext", c));
  }, [n, f, c, i, u]), y = ae(
    (m, _) => {
      if (!f())
        return;
      const b = { "Event Date": (/* @__PURE__ */ new Date()).toISOString(), ..._ };
      i(`track:${m}`, b), n("track", m, b);
    },
    [n, f, i]
  );
  return {
    isInitialized: o,
    initialize: l,
    canIdentify: f,
    configureProduct: d,
    identify: p,
    logEvent: y
  };
}
function tl({ children: e, hub: t, locationPathName: r, user: n }) {
  const { initialize: i, configureProduct: s, canIdentify: o, identify: a } = Zf({ hub: t, user: n });
  return Va(() => {
    s(r), a(), i();
  }, [o, s, a, i, r]), /* @__PURE__ */ ut.jsx(ut.Fragment, { children: e });
}
tl.displayName = "GainSightGate";
var Ce = /* @__PURE__ */ ((e) => (e.EN = "en", e.FR = "fr", e))(Ce || {});
class jo {
  static getPreferredLanguage() {
    const r = (window.navigator.languages || [
      window.navigator.language || window.navigator.userLanguage
    ])[0].toLowerCase();
    for (const n in Ce)
      if (r.startsWith(n.toLowerCase()))
        return Ce[n];
    return Ce.EN;
  }
  static getPreferredTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
function el({
  children: e,
  user: t,
  localeSettings: r,
  fallbackComponent: n
}) {
  const [i, s] = Er(), o = (t == null ? void 0 : t.profile.language.id) ?? jo.getPreferredLanguage(), a = (t == null ? void 0 : t.profile.timeZone.nameIana) ?? jo.getPreferredTimeZone();
  return Va(() => {
    r && (r.setCurrentLocale(o), r.setCurrentTimeZone(a), s(`${o}, ${a}`));
  }, [r, o, a]), i ? /* @__PURE__ */ ut.jsx(vf, { children: e }, i) : n ?? null;
}
el.displayName = "LocaleSetup";
class pn {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    const r = {
      listener: t
    };
    return this.listeners.add(r), this.onSubscribe(), () => {
      this.listeners.delete(r), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const sn = typeof window > "u" || "Deno" in window;
function Jt() {
}
function rl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function bs(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function tu(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Jr(e, t, r) {
  return bi(e) ? typeof t == "function" ? {
    ...r,
    queryKey: e,
    queryFn: t
  } : {
    ...t,
    queryKey: e
  } : e;
}
function Me(e, t, r) {
  return bi(e) ? [{
    ...t,
    queryKey: e
  }, r] : [e || {}, t];
}
function $o(e, t) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: s,
    queryKey: o,
    stale: a
  } = e;
  if (bi(o)) {
    if (n) {
      if (t.queryHash !== qs(o, t.options))
        return !1;
    } else if (!wr(t.queryKey, o))
      return !1;
  }
  if (r !== "all") {
    const c = t.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof a == "boolean" && t.isStale() !== a || typeof i < "u" && i !== t.state.fetchStatus || s && !s(t));
}
function zo(e, t) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: s
  } = e;
  if (bi(s)) {
    if (!t.options.mutationKey)
      return !1;
    if (r) {
      if (sr(t.options.mutationKey) !== sr(s))
        return !1;
    } else if (!wr(t.options.mutationKey, s))
      return !1;
  }
  return !(typeof n == "boolean" && t.state.status === "loading" !== n || i && !i(t));
}
function qs(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || sr)(e);
}
function sr(e) {
  return JSON.stringify(e, (t, r) => ws(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function wr(e, t) {
  return eu(e, t);
}
function eu(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((r) => !eu(e[r], t[r])) : !1;
}
function ru(e, t) {
  if (e === t)
    return e;
  const r = Ho(e) && Ho(t);
  if (r || ws(e) && ws(t)) {
    const n = r ? e.length : Object.keys(e).length, i = r ? t : Object.keys(t), s = i.length, o = r ? [] : {};
    let a = 0;
    for (let c = 0; c < s; c++) {
      const u = r ? c : i[c];
      o[u] = ru(e[u], t[u]), o[u] === e[u] && a++;
    }
    return n === s && a === n ? e : o;
  }
  return t;
}
function Bo(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Ho(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function ws(e) {
  if (!Ko(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const r = t.prototype;
  return !(!Ko(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function Ko(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function bi(e) {
  return Array.isArray(e);
}
function nu(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Qo(e) {
  nu(0).then(e);
}
function nl() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Es(e, t, r) {
  return r.isDataEqual != null && r.isDataEqual(e, t) ? e : typeof r.structuralSharing == "function" ? r.structuralSharing(e, t) : r.structuralSharing !== !1 ? ru(e, t) : t;
}
class il extends pn {
  constructor() {
    super(), this.setup = (t) => {
      if (!sn && window.addEventListener) {
        const r = () => t();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var r;
    this.setup = t, (r = this.cleanup) == null || r.call(this), this.cleanup = t((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(t) {
    this.focused = t, t && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const li = new il();
class sl extends pn {
  constructor() {
    super(), this.setup = (t) => {
      if (!sn && window.addEventListener) {
        const r = () => t();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var r;
    this.setup = t, (r = this.cleanup) == null || r.call(this), this.cleanup = t((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(t) {
    this.online = t, t && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const hi = new sl();
function ol(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function wi(e) {
  return (e ?? "online") === "online" ? hi.isOnline() : !0;
}
class iu {
  constructor(t) {
    this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}
function ti(e) {
  return e instanceof iu;
}
function su(e) {
  let t = !1, r = 0, n = !1, i, s, o;
  const a = new Promise((_, b) => {
    s = _, o = b;
  }), c = (_) => {
    n || (p(new iu(_)), e.abort == null || e.abort());
  }, u = () => {
    t = !0;
  }, f = () => {
    t = !1;
  }, l = () => !li.isFocused() || e.networkMode !== "always" && !hi.isOnline(), d = (_) => {
    n || (n = !0, e.onSuccess == null || e.onSuccess(_), i == null || i(), s(_));
  }, p = (_) => {
    n || (n = !0, e.onError == null || e.onError(_), i == null || i(), o(_));
  }, y = () => new Promise((_) => {
    i = (b) => {
      const w = n || !l();
      return w && _(b), w;
    }, e.onPause == null || e.onPause();
  }).then(() => {
    i = void 0, n || e.onContinue == null || e.onContinue();
  }), m = () => {
    if (n)
      return;
    let _;
    try {
      _ = e.fn();
    } catch (b) {
      _ = Promise.reject(b);
    }
    Promise.resolve(_).then(d).catch((b) => {
      var w, R;
      if (n)
        return;
      const A = (w = e.retry) != null ? w : 3, F = (R = e.retryDelay) != null ? R : ol, k = typeof F == "function" ? F(r, b) : F, O = A === !0 || typeof A == "number" && r < A || typeof A == "function" && A(r, b);
      if (t || !O) {
        p(b);
        return;
      }
      r++, e.onFail == null || e.onFail(r, b), nu(k).then(() => {
        if (l())
          return y();
      }).then(() => {
        t ? p(b) : m();
      });
    });
  };
  return wi(e.networkMode) ? m() : y().then(m), {
    promise: a,
    cancel: c,
    continue: () => (i == null ? void 0 : i()) ? a : Promise.resolve(),
    cancelRetry: u,
    continueRetry: f
  };
}
const Us = console;
function al() {
  let e = [], t = 0, r = (f) => {
    f();
  }, n = (f) => {
    f();
  };
  const i = (f) => {
    let l;
    t++;
    try {
      l = f();
    } finally {
      t--, t || a();
    }
    return l;
  }, s = (f) => {
    t ? e.push(f) : Qo(() => {
      r(f);
    });
  }, o = (f) => (...l) => {
    s(() => {
      f(...l);
    });
  }, a = () => {
    const f = e;
    e = [], f.length && Qo(() => {
      n(() => {
        f.forEach((l) => {
          r(l);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: o,
    schedule: s,
    setNotifyFunction: (f) => {
      r = f;
    },
    setBatchNotifyFunction: (f) => {
      n = f;
    }
  };
}
const bt = al();
class ou {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), bs(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(t) {
    this.cacheTime = Math.max(this.cacheTime || 0, t ?? (sn ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class ul extends ou {
  constructor(t) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.cache = t.cache, this.logger = t.logger || Us, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.initialState = t.state || cl(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(t, r) {
    const n = Es(this.state.data, t, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(t, r) {
    this.dispatch({
      type: "setState",
      state: t,
      setStateOptions: r
    });
  }
  cancel(t) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(t), n ? n.then(Jt).catch(Jt) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !tu(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  onOnline() {
    var t;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  addObserver(t) {
    this.observers.indexOf(t) === -1 && (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers.indexOf(t) !== -1 && (this.observers = this.observers.filter((r) => r !== t), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: t
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(t, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var s;
        return (s = this.retryer) == null || s.continueRetry(), this.promise;
      }
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const p = this.observers.find((y) => y.options.queryFn);
      p && this.setOptions(p.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const o = nl(), a = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (p) => {
      Object.defineProperty(p, "signal", {
        enumerable: !0,
        get: () => {
          if (o)
            return this.abortSignalConsumed = !0, o.signal;
        }
      });
    };
    c(a);
    const u = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(a)) : Promise.reject("Missing queryFn"), f = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: u
    };
    if (c(f), (n = this.options.behavior) == null || n.onFetch(f), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = f.fetchOptions) == null ? void 0 : i.meta)) {
      var l;
      this.dispatch({
        type: "fetch",
        meta: (l = f.fetchOptions) == null ? void 0 : l.meta
      });
    }
    const d = (p) => {
      if (ti(p) && p.silent || this.dispatch({
        type: "error",
        error: p
      }), !ti(p)) {
        var y, m, _, b;
        (y = (m = this.cache.config).onError) == null || y.call(m, p, this), (_ = (b = this.cache.config).onSettled) == null || _.call(b, this.state.data, p, this), process.env.NODE_ENV !== "production" && this.logger.error(p);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = su({
      fn: f.fetchFn,
      abort: o == null ? void 0 : o.abort.bind(o),
      onSuccess: (p) => {
        var y, m, _, b;
        if (typeof p > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), d(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(p), (y = (m = this.cache.config).onSuccess) == null || y.call(m, p, this), (_ = (b = this.cache.config).onSettled) == null || _.call(b, p, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: d,
      onFail: (p, y) => {
        this.dispatch({
          type: "failed",
          failureCount: p,
          error: y
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: f.options.retry,
      retryDelay: f.options.retryDelay,
      networkMode: f.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(t) {
    const r = (n) => {
      var i, s;
      switch (t.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = t.meta) != null ? i : null,
            fetchStatus: wi(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: t.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (s = t.dataUpdatedAt) != null ? s : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const o = t.error;
          return ti(o) && o.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: o,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: o,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = r(this.state), bt.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(t);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }
}
function cl(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, r = typeof t < "u", n = r ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class fl extends pn {
  constructor(t) {
    super(), this.config = t || {}, this.queries = [], this.queriesMap = {};
  }
  build(t, r, n) {
    var i;
    const s = r.queryKey, o = (i = r.queryHash) != null ? i : qs(s, r);
    let a = this.get(o);
    return a || (a = new ul({
      cache: this,
      logger: t.getLogger(),
      queryKey: s,
      queryHash: o,
      options: t.defaultQueryOptions(r),
      state: n,
      defaultOptions: t.getQueryDefaults(s)
    }), this.add(a)), a;
  }
  add(t) {
    this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const r = this.queriesMap[t.queryHash];
    r && (t.destroy(), this.queries = this.queries.filter((n) => n !== t), r === t && delete this.queriesMap[t.queryHash], this.notify({
      type: "removed",
      query: t
    }));
  }
  clear() {
    bt.batch(() => {
      this.queries.forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.queriesMap[t];
  }
  getAll() {
    return this.queries;
  }
  find(t, r) {
    const [n] = Me(t, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => $o(n, i));
  }
  findAll(t, r) {
    const [n] = Me(t, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => $o(n, i)) : this.queries;
  }
  notify(t) {
    bt.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(t);
      });
    });
  }
  onFocus() {
    bt.batch(() => {
      this.queries.forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    bt.batch(() => {
      this.queries.forEach((t) => {
        t.onOnline();
      });
    });
  }
}
class ll extends ou {
  constructor(t) {
    super(), this.defaultOptions = t.defaultOptions, this.mutationId = t.mutationId, this.mutationCache = t.mutationCache, this.logger = t.logger || Us, this.observers = [], this.state = t.state || hl(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(t) {
    this.dispatch({
      type: "setState",
      state: t
    });
  }
  addObserver(t) {
    this.observers.indexOf(t) === -1 && (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers = this.observers.filter((r) => r !== t), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var t, r;
    return (t = (r = this.retryer) == null ? void 0 : r.continue()) != null ? t : this.execute();
  }
  async execute() {
    const t = () => {
      var O;
      return this.retryer = su({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (x, I) => {
          this.dispatch({
            type: "failed",
            failureCount: x,
            error: I
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (O = this.options.retry) != null ? O : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, s, o, a, c, u, f;
      if (!r) {
        var l, d, p, y;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((l = (d = this.mutationCache.config).onMutate) == null ? void 0 : l.call(d, this.state.variables, this));
        const x = await ((p = (y = this.options).onMutate) == null ? void 0 : p.call(y, this.state.variables));
        x !== this.state.context && this.dispatch({
          type: "loading",
          context: x,
          variables: this.state.variables
        });
      }
      const O = await t();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, O, this.state.variables, this.state.context, this)), await ((s = (o = this.options).onSuccess) == null ? void 0 : s.call(o, O, this.state.variables, this.state.context)), await ((a = (c = this.mutationCache.config).onSettled) == null ? void 0 : a.call(c, O, null, this.state.variables, this.state.context, this)), await ((u = (f = this.options).onSettled) == null ? void 0 : u.call(f, O, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: O
      }), O;
    } catch (O) {
      try {
        var m, _, b, w, R, A, F, k;
        throw await ((m = (_ = this.mutationCache.config).onError) == null ? void 0 : m.call(_, O, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(O), await ((b = (w = this.options).onError) == null ? void 0 : b.call(w, O, this.state.variables, this.state.context)), await ((R = (A = this.mutationCache.config).onSettled) == null ? void 0 : R.call(A, void 0, O, this.state.variables, this.state.context, this)), await ((F = (k = this.options).onSettled) == null ? void 0 : F.call(k, void 0, O, this.state.variables, this.state.context)), O;
      } finally {
        this.dispatch({
          type: "error",
          error: O
        });
      }
    }
  }
  dispatch(t) {
    const r = (n) => {
      switch (t.type) {
        case "failed":
          return {
            ...n,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !wi(this.options.networkMode),
            status: "loading",
            variables: t.variables
          };
        case "success":
          return {
            ...n,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: t.error,
            failureCount: n.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = r(this.state), bt.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(t);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
}
function hl() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class dl extends pn {
  constructor(t) {
    super(), this.config = t || {}, this.mutations = [], this.mutationId = 0;
  }
  build(t, r, n) {
    const i = new ll({
      mutationCache: this,
      logger: t.getLogger(),
      mutationId: ++this.mutationId,
      options: t.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? t.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(t) {
    this.mutations.push(t), this.notify({
      type: "added",
      mutation: t
    });
  }
  remove(t) {
    this.mutations = this.mutations.filter((r) => r !== t), this.notify({
      type: "removed",
      mutation: t
    });
  }
  clear() {
    bt.batch(() => {
      this.mutations.forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(t) {
    return typeof t.exact > "u" && (t.exact = !0), this.mutations.find((r) => zo(t, r));
  }
  findAll(t) {
    return this.mutations.filter((r) => zo(t, r));
  }
  notify(t) {
    bt.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(t);
      });
    });
  }
  resumePausedMutations() {
    var t;
    return this.resuming = ((t = this.resuming) != null ? t : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return bt.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(Jt)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function pl() {
  return {
    onFetch: (e) => {
      e.fetchFn = () => {
        var t, r, n, i, s, o;
        const a = (t = e.fetchOptions) == null || (r = t.meta) == null ? void 0 : r.refetchPage, c = (n = e.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, u = c == null ? void 0 : c.pageParam, f = (c == null ? void 0 : c.direction) === "forward", l = (c == null ? void 0 : c.direction) === "backward", d = ((s = e.state.data) == null ? void 0 : s.pages) || [], p = ((o = e.state.data) == null ? void 0 : o.pageParams) || [];
        let y = p, m = !1;
        const _ = (k) => {
          Object.defineProperty(k, "signal", {
            enumerable: !0,
            get: () => {
              var O;
              if ((O = e.signal) != null && O.aborted)
                m = !0;
              else {
                var x;
                (x = e.signal) == null || x.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return e.signal;
            }
          });
        }, b = e.options.queryFn || (() => Promise.reject("Missing queryFn")), w = (k, O, x, I) => (y = I ? [O, ...y] : [...y, O], I ? [x, ...k] : [...k, x]), R = (k, O, x, I) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof x > "u" && !O && k.length)
            return Promise.resolve(k);
          const N = {
            queryKey: e.queryKey,
            pageParam: x,
            meta: e.options.meta
          };
          _(N);
          const H = b(N);
          return Promise.resolve(H).then((G) => w(k, x, G, I));
        };
        let A;
        if (!d.length)
          A = R([]);
        else if (f) {
          const k = typeof u < "u", O = k ? u : Go(e.options, d);
          A = R(d, k, O);
        } else if (l) {
          const k = typeof u < "u", O = k ? u : vl(e.options, d);
          A = R(d, k, O, !0);
        } else {
          y = [];
          const k = typeof e.options.getNextPageParam > "u";
          A = (a && d[0] ? a(d[0], 0, d) : !0) ? R([], k, p[0]) : Promise.resolve(w([], p[0], d[0]));
          for (let x = 1; x < d.length; x++)
            A = A.then((I) => {
              if (a && d[x] ? a(d[x], x, d) : !0) {
                const H = k ? p[x] : Go(e.options, I);
                return R(I, k, H);
              }
              return Promise.resolve(w(I, p[x], d[x]));
            });
        }
        return A.then((k) => ({
          pages: k,
          pageParams: y
        }));
      };
    }
  };
}
function Go(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function vl(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
class yl {
  constructor(t = {}) {
    this.queryCache = t.queryCache || new fl(), this.mutationCache = t.mutationCache || new dl(), this.logger = t.logger || Us, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && t.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = li.subscribe(() => {
      li.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = hi.subscribe(() => {
      hi.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var t, r;
    this.mountCount--, this.mountCount === 0 && ((t = this.unsubscribeFocus) == null || t.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(t, r) {
    const [n] = Me(t, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(t) {
    return this.mutationCache.findAll({
      ...t,
      fetching: !0
    }).length;
  }
  getQueryData(t, r) {
    var n;
    return (n = this.queryCache.find(t, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(t, r, n) {
    const i = Jr(t, r, n), s = this.getQueryData(i.queryKey);
    return s ? Promise.resolve(s) : this.fetchQuery(i);
  }
  getQueriesData(t) {
    return this.getQueryCache().findAll(t).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(t, r, n) {
    const i = this.queryCache.find(t), s = i == null ? void 0 : i.state.data, o = rl(r, s);
    if (typeof o > "u")
      return;
    const a = Jr(t), c = this.defaultQueryOptions(a);
    return this.queryCache.build(this, c).setData(o, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(t, r, n) {
    return bt.batch(() => this.getQueryCache().findAll(t).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(t, r) {
    var n;
    return (n = this.queryCache.find(t, r)) == null ? void 0 : n.state;
  }
  removeQueries(t, r) {
    const [n] = Me(t, r), i = this.queryCache;
    bt.batch(() => {
      i.findAll(n).forEach((s) => {
        i.remove(s);
      });
    });
  }
  resetQueries(t, r, n) {
    const [i, s] = Me(t, r, n), o = this.queryCache, a = {
      type: "active",
      ...i
    };
    return bt.batch(() => (o.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(a, s)));
  }
  cancelQueries(t, r, n) {
    const [i, s = {}] = Me(t, r, n);
    typeof s.revert > "u" && (s.revert = !0);
    const o = bt.batch(() => this.queryCache.findAll(i).map((a) => a.cancel(s)));
    return Promise.all(o).then(Jt).catch(Jt);
  }
  invalidateQueries(t, r, n) {
    const [i, s] = Me(t, r, n);
    return bt.batch(() => {
      var o, a;
      if (this.queryCache.findAll(i).forEach((u) => {
        u.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (o = (a = i.refetchType) != null ? a : i.type) != null ? o : "active"
      };
      return this.refetchQueries(c, s);
    });
  }
  refetchQueries(t, r, n) {
    const [i, s] = Me(t, r, n), o = bt.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var u;
      return c.fetch(void 0, {
        ...s,
        cancelRefetch: (u = s == null ? void 0 : s.cancelRefetch) != null ? u : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let a = Promise.all(o).then(Jt);
    return s != null && s.throwOnError || (a = a.catch(Jt)), a;
  }
  fetchQuery(t, r, n) {
    const i = Jr(t, r, n), s = this.defaultQueryOptions(i);
    typeof s.retry > "u" && (s.retry = !1);
    const o = this.queryCache.build(this, s);
    return o.isStaleByTime(s.staleTime) ? o.fetch(s) : Promise.resolve(o.state.data);
  }
  prefetchQuery(t, r, n) {
    return this.fetchQuery(t, r, n).then(Jt).catch(Jt);
  }
  fetchInfiniteQuery(t, r, n) {
    const i = Jr(t, r, n);
    return i.behavior = pl(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(t, r, n) {
    return this.fetchInfiniteQuery(t, r, n).then(Jt).catch(Jt);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(t) {
    this.defaultOptions = t;
  }
  setQueryDefaults(t, r) {
    const n = this.queryDefaults.find((i) => sr(t) === sr(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: t,
      defaultOptions: r
    });
  }
  getQueryDefaults(t) {
    if (!t)
      return;
    const r = this.queryDefaults.find((n) => wr(t, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((i) => wr(t, i.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(t) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r == null ? void 0 : r.defaultOptions;
  }
  setMutationDefaults(t, r) {
    const n = this.mutationDefaults.find((i) => sr(t) === sr(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: t,
      defaultOptions: r
    });
  }
  getMutationDefaults(t) {
    if (!t)
      return;
    const r = this.mutationDefaults.find((n) => wr(t, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((i) => wr(t, i.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(t) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r == null ? void 0 : r.defaultOptions;
  }
  defaultQueryOptions(t) {
    if (t != null && t._defaulted)
      return t;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(t == null ? void 0 : t.queryKey),
      ...t,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = qs(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(t == null ? void 0 : t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class gl extends pn {
  constructor(t, r) {
    super(), this.client = t, this.options = r, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), Vo(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Ss(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return Ss(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(t, r) {
    const n = this.options, i = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(t), process.env.NODE_ENV !== "production" && typeof (t == null ? void 0 : t.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), Bo(n, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = n.queryKey), this.updateQuery();
    const s = this.hasListeners();
    s && Yo(this.currentQuery, i, this.options, n) && this.executeFetch(), this.updateResult(r), s && (this.currentQuery !== i || this.options.enabled !== n.enabled || this.options.staleTime !== n.staleTime) && this.updateStaleTimeout();
    const o = this.computeRefetchInterval();
    s && (this.currentQuery !== i || this.options.enabled !== n.enabled || o !== this.currentRefetchInterval) && this.updateRefetchInterval(o);
  }
  getOptimisticResult(t) {
    const r = this.client.getQueryCache().build(this.client, t);
    return this.createResult(r, t);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(t) {
    const r = {};
    return Object.keys(t).forEach((n) => {
      Object.defineProperty(r, n, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(n), t[n])
      });
    }), r;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: t,
    ...r
  } = {}) {
    return this.fetch({
      ...r,
      meta: {
        refetchPage: t
      }
    });
  }
  fetchOptimistic(t) {
    const r = this.client.defaultQueryOptions(t), n = this.client.getQueryCache().build(this.client, r);
    return n.isFetchingOptimistic = !0, n.fetch().then(() => this.createResult(n, r));
  }
  fetch(t) {
    var r;
    return this.executeFetch({
      ...t,
      cancelRefetch: (r = t.cancelRefetch) != null ? r : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(t) {
    this.updateQuery();
    let r = this.currentQuery.fetch(this.options, t);
    return t != null && t.throwOnError || (r = r.catch(Jt)), r;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), sn || this.currentResult.isStale || !bs(this.options.staleTime))
      return;
    const r = tu(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, r);
  }
  computeRefetchInterval() {
    var t;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (t = this.options.refetchInterval) != null ? t : !1;
  }
  updateRefetchInterval(t) {
    this.clearRefetchInterval(), this.currentRefetchInterval = t, !(sn || this.options.enabled === !1 || !bs(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || li.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(t, r) {
    const n = this.currentQuery, i = this.options, s = this.currentResult, o = this.currentResultState, a = this.currentResultOptions, c = t !== n, u = c ? t.state : this.currentQueryInitialState, f = c ? this.currentResult : this.previousQueryResult, {
      state: l
    } = t;
    let {
      dataUpdatedAt: d,
      error: p,
      errorUpdatedAt: y,
      fetchStatus: m,
      status: _
    } = l, b = !1, w = !1, R;
    if (r._optimisticResults) {
      const x = this.hasListeners(), I = !x && Vo(t, r), N = x && Yo(t, n, r, i);
      (I || N) && (m = wi(t.options.networkMode) ? "fetching" : "paused", d || (_ = "loading")), r._optimisticResults === "isRestoring" && (m = "idle");
    }
    if (r.keepPreviousData && !l.dataUpdatedAt && f != null && f.isSuccess && _ !== "error")
      R = f.data, d = f.dataUpdatedAt, _ = f.status, b = !0;
    else if (r.select && typeof l.data < "u")
      if (s && l.data === (o == null ? void 0 : o.data) && r.select === this.selectFn)
        R = this.selectResult;
      else
        try {
          this.selectFn = r.select, R = r.select(l.data), R = Es(s == null ? void 0 : s.data, R, r), this.selectResult = R, this.selectError = null;
        } catch (x) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(x), this.selectError = x;
        }
    else
      R = l.data;
    if (typeof r.placeholderData < "u" && typeof R > "u" && _ === "loading") {
      let x;
      if (s != null && s.isPlaceholderData && r.placeholderData === (a == null ? void 0 : a.placeholderData))
        x = s.data;
      else if (x = typeof r.placeholderData == "function" ? r.placeholderData() : r.placeholderData, r.select && typeof x < "u")
        try {
          x = r.select(x), this.selectError = null;
        } catch (I) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(I), this.selectError = I;
        }
      typeof x < "u" && (_ = "success", R = Es(s == null ? void 0 : s.data, x, r), w = !0);
    }
    this.selectError && (p = this.selectError, R = this.selectResult, y = Date.now(), _ = "error");
    const A = m === "fetching", F = _ === "loading", k = _ === "error";
    return {
      status: _,
      fetchStatus: m,
      isLoading: F,
      isSuccess: _ === "success",
      isError: k,
      isInitialLoading: F && A,
      data: R,
      dataUpdatedAt: d,
      error: p,
      errorUpdatedAt: y,
      failureCount: l.fetchFailureCount,
      failureReason: l.fetchFailureReason,
      errorUpdateCount: l.errorUpdateCount,
      isFetched: l.dataUpdateCount > 0 || l.errorUpdateCount > 0,
      isFetchedAfterMount: l.dataUpdateCount > u.dataUpdateCount || l.errorUpdateCount > u.errorUpdateCount,
      isFetching: A,
      isRefetching: A && !F,
      isLoadingError: k && l.dataUpdatedAt === 0,
      isPaused: m === "paused",
      isPlaceholderData: w,
      isPreviousData: b,
      isRefetchError: k && l.dataUpdatedAt !== 0,
      isStale: js(t, r),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(t) {
    const r = this.currentResult, n = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, Bo(n, r))
      return;
    this.currentResult = n;
    const i = {
      cache: !0
    }, s = () => {
      if (!r)
        return !0;
      const {
        notifyOnChangeProps: o
      } = this.options;
      if (o === "all" || !o && !this.trackedProps.size)
        return !0;
      const a = new Set(o ?? this.trackedProps);
      return this.options.useErrorBoundary && a.add("error"), Object.keys(this.currentResult).some((c) => {
        const u = c;
        return this.currentResult[u] !== r[u] && a.has(u);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && s() && (i.listeners = !0), this.notify({
      ...i,
      ...t
    });
  }
  updateQuery() {
    const t = this.client.getQueryCache().build(this.client, this.options);
    if (t === this.currentQuery)
      return;
    const r = this.currentQuery;
    this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (r == null || r.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate(t) {
    const r = {};
    t.type === "success" ? r.onSuccess = !t.manual : t.type === "error" && !ti(t.error) && (r.onError = !0), this.updateResult(r), this.hasListeners() && this.updateTimers();
  }
  notify(t) {
    bt.batch(() => {
      if (t.onSuccess) {
        var r, n, i, s;
        (r = (n = this.options).onSuccess) == null || r.call(n, this.currentResult.data), (i = (s = this.options).onSettled) == null || i.call(s, this.currentResult.data, null);
      } else if (t.onError) {
        var o, a, c, u;
        (o = (a = this.options).onError) == null || o.call(a, this.currentResult.error), (c = (u = this.options).onSettled) == null || c.call(u, void 0, this.currentResult.error);
      }
      t.listeners && this.listeners.forEach(({
        listener: f
      }) => {
        f(this.currentResult);
      }), t.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function ml(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function Vo(e, t) {
  return ml(e, t) || e.state.dataUpdatedAt > 0 && Ss(e, t, t.refetchOnMount);
}
function Ss(e, t, r) {
  if (t.enabled !== !1) {
    const n = typeof r == "function" ? r(e) : r;
    return n === "always" || n !== !1 && js(e, t);
  }
  return !1;
}
function Yo(e, t, r, n) {
  return r.enabled !== !1 && (e !== t || n.enabled === !1) && (!r.suspense || e.state.status !== "error") && js(e, r);
}
function js(e, t) {
  return e.isStaleByTime(t.staleTime);
}
var Os = { exports: {} }, Gi = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wo;
function _l() {
  if (Wo)
    return Gi;
  Wo = 1;
  var e = Dr;
  function t(l, d) {
    return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, i = e.useEffect, s = e.useLayoutEffect, o = e.useDebugValue;
  function a(l, d) {
    var p = d(), y = n({ inst: { value: p, getSnapshot: d } }), m = y[0].inst, _ = y[1];
    return s(function() {
      m.value = p, m.getSnapshot = d, c(m) && _({ inst: m });
    }, [l, p, d]), i(function() {
      return c(m) && _({ inst: m }), l(function() {
        c(m) && _({ inst: m });
      });
    }, [l]), o(p), p;
  }
  function c(l) {
    var d = l.getSnapshot;
    l = l.value;
    try {
      var p = d();
      return !r(l, p);
    } catch {
      return !0;
    }
  }
  function u(l, d) {
    return d();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : a;
  return Gi.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, Gi;
}
var Vi = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jo;
function bl() {
  return Jo || (Jo = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Dr, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(R) {
      {
        for (var A = arguments.length, F = new Array(A > 1 ? A - 1 : 0), k = 1; k < A; k++)
          F[k - 1] = arguments[k];
        n("error", R, F);
      }
    }
    function n(R, A, F) {
      {
        var k = t.ReactDebugCurrentFrame, O = k.getStackAddendum();
        O !== "" && (A += "%s", F = F.concat([O]));
        var x = F.map(function(I) {
          return String(I);
        });
        x.unshift("Warning: " + A), Function.prototype.apply.call(console[R], console, x);
      }
    }
    function i(R, A) {
      return R === A && (R !== 0 || 1 / R === 1 / A) || R !== R && A !== A;
    }
    var s = typeof Object.is == "function" ? Object.is : i, o = e.useState, a = e.useEffect, c = e.useLayoutEffect, u = e.useDebugValue, f = !1, l = !1;
    function d(R, A, F) {
      f || e.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var k = A();
      if (!l) {
        var O = A();
        s(k, O) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), l = !0);
      }
      var x = o({
        inst: {
          value: k,
          getSnapshot: A
        }
      }), I = x[0].inst, N = x[1];
      return c(function() {
        I.value = k, I.getSnapshot = A, p(I) && N({
          inst: I
        });
      }, [R, k, A]), a(function() {
        p(I) && N({
          inst: I
        });
        var H = function() {
          p(I) && N({
            inst: I
          });
        };
        return R(H);
      }, [R]), u(k), k;
    }
    function p(R) {
      var A = R.getSnapshot, F = R.value;
      try {
        var k = A();
        return !s(F, k);
      } catch {
        return !0;
      }
    }
    function y(R, A, F) {
      return A();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", _ = !m, b = _ ? y : d, w = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b;
    Vi.useSyncExternalStore = w, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Vi;
}
process.env.NODE_ENV === "production" ? Os.exports = _l() : Os.exports = bl();
var wl = Os.exports;
const El = wl.useSyncExternalStore, Xo = /* @__PURE__ */ Ft.createContext(void 0), au = /* @__PURE__ */ Ft.createContext(!1);
function uu(e, t) {
  return e || (t && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = Xo), window.ReactQueryClientContext) : Xo);
}
const Sl = ({
  context: e
} = {}) => {
  const t = Ft.useContext(uu(e, Ft.useContext(au)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, Ol = ({
  client: e,
  children: t,
  context: r,
  contextSharing: n = !1
}) => {
  Ft.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]), process.env.NODE_ENV !== "production" && n && e.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const i = uu(r, n);
  return /* @__PURE__ */ Ft.createElement(au.Provider, {
    value: !r && n
  }, /* @__PURE__ */ Ft.createElement(i.Provider, {
    value: e
  }, t));
}, cu = /* @__PURE__ */ Ft.createContext(!1), Il = () => Ft.useContext(cu);
cu.Provider;
function Cl() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
const Pl = /* @__PURE__ */ Ft.createContext(Cl()), Rl = () => Ft.useContext(Pl);
function Tl(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
const Dl = (e, t) => {
  (e.suspense || e.useErrorBoundary) && (t.isReset() || (e.retryOnMount = !1));
}, Al = (e) => {
  Ft.useEffect(() => {
    e.clearReset();
  }, [e]);
}, xl = ({
  result: e,
  errorResetBoundary: t,
  useErrorBoundary: r,
  query: n
}) => e.isError && !t.isReset() && !e.isFetching && Tl(r, [e.error, n]), kl = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, Fl = (e, t) => e.isLoading && e.isFetching && !t, Ll = (e, t, r) => (e == null ? void 0 : e.suspense) && Fl(t, r), Nl = (e, t, r) => t.fetchOptimistic(e).then(({
  data: n
}) => {
  e.onSuccess == null || e.onSuccess(n), e.onSettled == null || e.onSettled(n, null);
}).catch((n) => {
  r.clearReset(), e.onError == null || e.onError(n), e.onSettled == null || e.onSettled(void 0, n);
});
function Ml(e, t) {
  const r = Sl({
    context: e.context
  }), n = Il(), i = Rl(), s = r.defaultQueryOptions(e);
  s._optimisticResults = n ? "isRestoring" : "optimistic", s.onError && (s.onError = bt.batchCalls(s.onError)), s.onSuccess && (s.onSuccess = bt.batchCalls(s.onSuccess)), s.onSettled && (s.onSettled = bt.batchCalls(s.onSettled)), kl(s), Dl(s, i), Al(i);
  const [o] = Ft.useState(() => new t(r, s)), a = o.getOptimisticResult(s);
  if (El(Ft.useCallback((c) => n ? () => {
  } : o.subscribe(bt.batchCalls(c)), [o, n]), () => o.getCurrentResult(), () => o.getCurrentResult()), Ft.useEffect(() => {
    o.setOptions(s, {
      listeners: !1
    });
  }, [s, o]), Ll(s, a, n))
    throw Nl(s, o, i);
  if (xl({
    result: a,
    errorResetBoundary: i,
    useErrorBoundary: s.useErrorBoundary,
    query: o.getCurrentQuery()
  }))
    throw a.error;
  return s.notifyOnChangeProps ? a : o.trackResult(a);
}
function fu(e, t, r) {
  const n = Jr(e, t, r);
  return Ml(n, gl);
}
const ql = new yl(), $s = gi(void 0);
function lu(e, t) {
  const r = (n) => /* @__PURE__ */ ut.jsx(
    Ol,
    {
      client: ql,
      context: $s,
      children: /* @__PURE__ */ ut.jsx(e, { ...n })
    }
  );
  return r.displayName = t, r;
}
function cr(e) {
  function t(r, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = n;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
const Ul = cr("LaunchDarklyUnexpectedResponseError"), jl = cr("LaunchDarklyInvalidEnvironmentIdError"), $l = cr("LaunchDarklyInvalidUserError"), zl = cr("LaunchDarklyInvalidEventKeyError"), Bl = cr("LaunchDarklyInvalidArgumentError"), Hl = cr("LaunchDarklyFlagFetchError");
for (var _t = { LDUnexpectedResponseError: Ul, LDInvalidEnvironmentIdError: jl, LDInvalidUserError: $l, LDInvalidEventKeyError: zl, LDInvalidArgumentError: Bl, LDInvalidDataError: cr("LaunchDarklyInvalidDataError"), LDFlagFetchError: Hl, isHttpErrorRecoverable: function(e) {
  return !(e >= 400 && e < 500) || e === 400 || e === 408 || e === 429;
} }, Kl = function(e) {
  var t = Zo(e), r = t[0], n = t[1];
  return 3 * (r + n) / 4 - n;
}, Ql = function(e) {
  var t, r, n = Zo(e), i = n[0], s = n[1], o = new Vl(function(u, f, l) {
    return 3 * (f + l) / 4 - l;
  }(0, i, s)), a = 0, c = s > 0 ? i - 4 : i;
  for (r = 0; r < c; r += 4)
    t = Yt[e.charCodeAt(r)] << 18 | Yt[e.charCodeAt(r + 1)] << 12 | Yt[e.charCodeAt(r + 2)] << 6 | Yt[e.charCodeAt(r + 3)], o[a++] = t >> 16 & 255, o[a++] = t >> 8 & 255, o[a++] = 255 & t;
  return s === 2 && (t = Yt[e.charCodeAt(r)] << 2 | Yt[e.charCodeAt(r + 1)] >> 4, o[a++] = 255 & t), s === 1 && (t = Yt[e.charCodeAt(r)] << 10 | Yt[e.charCodeAt(r + 1)] << 4 | Yt[e.charCodeAt(r + 2)] >> 2, o[a++] = t >> 8 & 255, o[a++] = 255 & t), o;
}, Gl = function(e) {
  for (var t, r = e.length, n = r % 3, i = [], s = 16383, o = 0, a = r - n; o < a; o += s)
    i.push(Wl(e, o, o + s > a ? a : o + s));
  return n === 1 ? (t = e[r - 1], i.push(ye[t >> 2] + ye[t << 4 & 63] + "==")) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], i.push(ye[t >> 10] + ye[t >> 4 & 63] + ye[t << 2 & 63] + "=")), i.join("");
}, ye = [], Yt = [], Vl = typeof Uint8Array < "u" ? Uint8Array : Array, Yi = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", mr = 0, Yl = Yi.length; mr < Yl; ++mr)
  ye[mr] = Yi[mr], Yt[Yi.charCodeAt(mr)] = mr;
function Zo(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  return r === -1 && (r = t), [r, r === t ? 0 : 4 - r % 4];
}
function Wl(e, t, r) {
  for (var n, i, s = [], o = t; o < r; o += 3)
    n = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (255 & e[o + 2]), s.push(ye[(i = n) >> 18 & 63] + ye[i >> 12 & 63] + ye[i >> 6 & 63] + ye[63 & i]);
  return s.join("");
}
Yt["-".charCodeAt(0)] = 62, Yt["_".charCodeAt(0)] = 63;
var Jl = { byteLength: Kl, toByteArray: Ql, fromByteArray: Gl }, ta = Array.isArray, ea = Object.keys, Xl = Object.prototype.hasOwnProperty, Zl = function e(t, r) {
  if (t === r)
    return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    var n, i, s, o = ta(t), a = ta(r);
    if (o && a) {
      if ((i = t.length) != r.length)
        return !1;
      for (n = i; n-- != 0; )
        if (!e(t[n], r[n]))
          return !1;
      return !0;
    }
    if (o != a)
      return !1;
    var c = t instanceof Date, u = r instanceof Date;
    if (c != u)
      return !1;
    if (c && u)
      return t.getTime() == r.getTime();
    var f = t instanceof RegExp, l = r instanceof RegExp;
    if (f != l)
      return !1;
    if (f && l)
      return t.toString() == r.toString();
    var d = ea(t);
    if ((i = d.length) !== ea(r).length)
      return !1;
    for (n = i; n-- != 0; )
      if (!Xl.call(r, d[n]))
        return !1;
    for (n = i; n-- != 0; )
      if (!e(t[s = d[n]], r[s]))
        return !1;
    return !0;
  }
  return t != t && r != r;
};
const th = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function hu(e) {
  const t = unescape(encodeURIComponent(e));
  return Jl.fromByteArray(function(r) {
    const n = [];
    for (let i = 0; i < r.length; i++)
      n.push(r.charCodeAt(i));
    return n;
  }(t));
}
function ra(e) {
  return hu(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function Wi(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var Ji, j = { appendUrlPath: function(e, t) {
  return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
}, base64URLEncode: ra, btoa: hu, chunkEventsForUrl: function(e, t) {
  const r = t.slice(0), n = [];
  let i, s = e;
  for (; r.length > 0; ) {
    for (i = []; s > 0; ) {
      const o = r.shift();
      if (!o)
        break;
      s -= ra(JSON.stringify(o)).length, s < 0 && i.length > 0 ? r.unshift(o) : i.push(o);
    }
    s = e, n.push(i);
  }
  return n;
}, clone: function(e) {
  return JSON.parse(JSON.stringify(e));
}, deepEquals: function(e, t) {
  return Zl(e, t);
}, extend: function(...e) {
  return e.reduce((t, r) => ({ ...t, ...r }), {});
}, getLDUserAgentString: function(e) {
  const t = e.version || "?";
  return e.userAgent + "/" + t;
}, objectHasOwnProperty: Wi, onNextTick: function(e) {
  setTimeout(e, 0);
}, sanitizeContext: function(e) {
  if (!e)
    return e;
  let t;
  return e.kind !== null && e.kind !== void 0 || th.forEach((r) => {
    const n = e[r];
    n !== void 0 && typeof n != "string" && (t = t || { ...e }, t[r] = String(n));
  }), t || e;
}, transformValuesToVersionedValues: function(e) {
  const t = {};
  for (const r in e)
    Wi(e, r) && (t[r] = { value: e[r], version: 0 });
  return t;
}, transformVersionedValuesToValues: function(e) {
  const t = {};
  for (const r in e)
    Wi(e, r) && (t[r] = e[r].value);
  return t;
}, wrapPromiseCallback: function(e, t) {
  const r = e.then((n) => (t && setTimeout(() => {
    t(null, n);
  }, 0), n), (n) => {
    if (!t)
      return Promise.reject(n);
    setTimeout(() => {
      t(n, null);
    }, 0);
  });
  return t ? void 0 : r;
} }, eh = new Uint8Array(16);
function na() {
  if (!Ji && !(Ji = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ji(eh);
}
var rh = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function di(e) {
  return typeof e == "string" && rh.test(e);
}
for (var ia, Xi, It = [], Zi = 0; Zi < 256; ++Zi)
  It.push((Zi + 256).toString(16).substr(1));
function ei(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (It[e[t + 0]] + It[e[t + 1]] + It[e[t + 2]] + It[e[t + 3]] + "-" + It[e[t + 4]] + It[e[t + 5]] + "-" + It[e[t + 6]] + It[e[t + 7]] + "-" + It[e[t + 8]] + It[e[t + 9]] + "-" + It[e[t + 10]] + It[e[t + 11]] + It[e[t + 12]] + It[e[t + 13]] + It[e[t + 14]] + It[e[t + 15]]).toLowerCase();
  if (!di(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
var ts = 0, es = 0;
function du(e) {
  if (!di(e))
    throw TypeError("Invalid UUID");
  var t, r = new Uint8Array(16);
  return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
}
function pu(e, t, r) {
  function n(i, s, o, a) {
    if (typeof i == "string" && (i = function(f) {
      f = unescape(encodeURIComponent(f));
      for (var l = [], d = 0; d < f.length; ++d)
        l.push(f.charCodeAt(d));
      return l;
    }(i)), typeof s == "string" && (s = du(s)), s.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(s), c.set(i, s.length), (c = r(c))[6] = 15 & c[6] | t, c[8] = 63 & c[8] | 128, o) {
      a = a || 0;
      for (var u = 0; u < 16; ++u)
        o[a + u] = c[u];
      return o;
    }
    return ei(c);
  }
  try {
    n.name = e;
  } catch {
  }
  return n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", n;
}
function sa(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function Ue(e, t) {
  var r = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
}
function Ei(e, t, r, n, i, s) {
  return Ue((o = Ue(Ue(t, e), Ue(n, s))) << (a = i) | o >>> 32 - a, r);
  var o, a;
}
function Pt(e, t, r, n, i, s, o) {
  return Ei(t & r | ~t & n, e, t, i, s, o);
}
function Rt(e, t, r, n, i, s, o) {
  return Ei(t & n | r & ~n, e, t, i, s, o);
}
function Tt(e, t, r, n, i, s, o) {
  return Ei(t ^ r ^ n, e, t, i, s, o);
}
function Dt(e, t, r, n, i, s, o) {
  return Ei(r ^ (t | ~n), e, t, i, s, o);
}
var nh = pu("v3", 48, function(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var r = 0; r < t.length; ++r)
      e[r] = t.charCodeAt(r);
  }
  return function(n) {
    for (var i = [], s = 32 * n.length, o = "0123456789abcdef", a = 0; a < s; a += 8) {
      var c = n[a >> 5] >>> a % 32 & 255, u = parseInt(o.charAt(c >>> 4 & 15) + o.charAt(15 & c), 16);
      i.push(u);
    }
    return i;
  }(function(n, i) {
    n[i >> 5] |= 128 << i % 32, n[sa(i) - 1] = i;
    for (var s = 1732584193, o = -271733879, a = -1732584194, c = 271733878, u = 0; u < n.length; u += 16) {
      var f = s, l = o, d = a, p = c;
      s = Pt(s, o, a, c, n[u], 7, -680876936), c = Pt(c, s, o, a, n[u + 1], 12, -389564586), a = Pt(a, c, s, o, n[u + 2], 17, 606105819), o = Pt(o, a, c, s, n[u + 3], 22, -1044525330), s = Pt(s, o, a, c, n[u + 4], 7, -176418897), c = Pt(c, s, o, a, n[u + 5], 12, 1200080426), a = Pt(a, c, s, o, n[u + 6], 17, -1473231341), o = Pt(o, a, c, s, n[u + 7], 22, -45705983), s = Pt(s, o, a, c, n[u + 8], 7, 1770035416), c = Pt(c, s, o, a, n[u + 9], 12, -1958414417), a = Pt(a, c, s, o, n[u + 10], 17, -42063), o = Pt(o, a, c, s, n[u + 11], 22, -1990404162), s = Pt(s, o, a, c, n[u + 12], 7, 1804603682), c = Pt(c, s, o, a, n[u + 13], 12, -40341101), a = Pt(a, c, s, o, n[u + 14], 17, -1502002290), s = Rt(s, o = Pt(o, a, c, s, n[u + 15], 22, 1236535329), a, c, n[u + 1], 5, -165796510), c = Rt(c, s, o, a, n[u + 6], 9, -1069501632), a = Rt(a, c, s, o, n[u + 11], 14, 643717713), o = Rt(o, a, c, s, n[u], 20, -373897302), s = Rt(s, o, a, c, n[u + 5], 5, -701558691), c = Rt(c, s, o, a, n[u + 10], 9, 38016083), a = Rt(a, c, s, o, n[u + 15], 14, -660478335), o = Rt(o, a, c, s, n[u + 4], 20, -405537848), s = Rt(s, o, a, c, n[u + 9], 5, 568446438), c = Rt(c, s, o, a, n[u + 14], 9, -1019803690), a = Rt(a, c, s, o, n[u + 3], 14, -187363961), o = Rt(o, a, c, s, n[u + 8], 20, 1163531501), s = Rt(s, o, a, c, n[u + 13], 5, -1444681467), c = Rt(c, s, o, a, n[u + 2], 9, -51403784), a = Rt(a, c, s, o, n[u + 7], 14, 1735328473), s = Tt(s, o = Rt(o, a, c, s, n[u + 12], 20, -1926607734), a, c, n[u + 5], 4, -378558), c = Tt(c, s, o, a, n[u + 8], 11, -2022574463), a = Tt(a, c, s, o, n[u + 11], 16, 1839030562), o = Tt(o, a, c, s, n[u + 14], 23, -35309556), s = Tt(s, o, a, c, n[u + 1], 4, -1530992060), c = Tt(c, s, o, a, n[u + 4], 11, 1272893353), a = Tt(a, c, s, o, n[u + 7], 16, -155497632), o = Tt(o, a, c, s, n[u + 10], 23, -1094730640), s = Tt(s, o, a, c, n[u + 13], 4, 681279174), c = Tt(c, s, o, a, n[u], 11, -358537222), a = Tt(a, c, s, o, n[u + 3], 16, -722521979), o = Tt(o, a, c, s, n[u + 6], 23, 76029189), s = Tt(s, o, a, c, n[u + 9], 4, -640364487), c = Tt(c, s, o, a, n[u + 12], 11, -421815835), a = Tt(a, c, s, o, n[u + 15], 16, 530742520), s = Dt(s, o = Tt(o, a, c, s, n[u + 2], 23, -995338651), a, c, n[u], 6, -198630844), c = Dt(c, s, o, a, n[u + 7], 10, 1126891415), a = Dt(a, c, s, o, n[u + 14], 15, -1416354905), o = Dt(o, a, c, s, n[u + 5], 21, -57434055), s = Dt(s, o, a, c, n[u + 12], 6, 1700485571), c = Dt(c, s, o, a, n[u + 3], 10, -1894986606), a = Dt(a, c, s, o, n[u + 10], 15, -1051523), o = Dt(o, a, c, s, n[u + 1], 21, -2054922799), s = Dt(s, o, a, c, n[u + 8], 6, 1873313359), c = Dt(c, s, o, a, n[u + 15], 10, -30611744), a = Dt(a, c, s, o, n[u + 6], 15, -1560198380), o = Dt(o, a, c, s, n[u + 13], 21, 1309151649), s = Dt(s, o, a, c, n[u + 4], 6, -145523070), c = Dt(c, s, o, a, n[u + 11], 10, -1120210379), a = Dt(a, c, s, o, n[u + 2], 15, 718787259), o = Dt(o, a, c, s, n[u + 9], 21, -343485551), s = Ue(s, f), o = Ue(o, l), a = Ue(a, d), c = Ue(c, p);
    }
    return [s, o, a, c];
  }(function(n) {
    if (n.length === 0)
      return [];
    for (var i = 8 * n.length, s = new Uint32Array(sa(i)), o = 0; o < i; o += 8)
      s[o >> 5] |= (255 & n[o / 8]) << o % 32;
    return s;
  }(e), 8 * e.length));
}), ih = nh;
function sh(e, t, r, n) {
  switch (e) {
    case 0:
      return t & r ^ ~t & n;
    case 1:
    case 3:
      return t ^ r ^ n;
    case 2:
      return t & r ^ t & n ^ r & n;
  }
}
function rs(e, t) {
  return e << t | e >>> 32 - t;
}
var oh = pu("v5", 80, function(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var n = unescape(encodeURIComponent(e));
    e = [];
    for (var i = 0; i < n.length; ++i)
      e.push(n.charCodeAt(i));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o), c = 0; c < o; ++c) {
    for (var u = new Uint32Array(16), f = 0; f < 16; ++f)
      u[f] = e[64 * c + 4 * f] << 24 | e[64 * c + 4 * f + 1] << 16 | e[64 * c + 4 * f + 2] << 8 | e[64 * c + 4 * f + 3];
    a[c] = u;
  }
  a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
  for (var l = 0; l < o; ++l) {
    for (var d = new Uint32Array(80), p = 0; p < 16; ++p)
      d[p] = a[l][p];
    for (var y = 16; y < 80; ++y)
      d[y] = rs(d[y - 3] ^ d[y - 8] ^ d[y - 14] ^ d[y - 16], 1);
    for (var m = r[0], _ = r[1], b = r[2], w = r[3], R = r[4], A = 0; A < 80; ++A) {
      var F = Math.floor(A / 20), k = rs(m, 5) + sh(F, _, b, w) + R + t[F] + d[A] >>> 0;
      R = w, w = b, b = rs(_, 30) >>> 0, _ = m, m = k;
    }
    r[0] = r[0] + m >>> 0, r[1] = r[1] + _ >>> 0, r[2] = r[2] + b >>> 0, r[3] = r[3] + w >>> 0, r[4] = r[4] + R >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
}), ah = oh, zs = Object.freeze({ __proto__: null, v1: function(e, t, r) {
  var n = t && r || 0, i = t || new Array(16), s = (e = e || {}).node || ia, o = e.clockseq !== void 0 ? e.clockseq : Xi;
  if (s == null || o == null) {
    var a = e.random || (e.rng || na)();
    s == null && (s = ia = [1 | a[0], a[1], a[2], a[3], a[4], a[5]]), o == null && (o = Xi = 16383 & (a[6] << 8 | a[7]));
  }
  var c = e.msecs !== void 0 ? e.msecs : Date.now(), u = e.nsecs !== void 0 ? e.nsecs : es + 1, f = c - ts + (u - es) / 1e4;
  if (f < 0 && e.clockseq === void 0 && (o = o + 1 & 16383), (f < 0 || c > ts) && e.nsecs === void 0 && (u = 0), u >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  ts = c, es = u, Xi = o;
  var l = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
  i[n++] = l >>> 24 & 255, i[n++] = l >>> 16 & 255, i[n++] = l >>> 8 & 255, i[n++] = 255 & l;
  var d = c / 4294967296 * 1e4 & 268435455;
  i[n++] = d >>> 8 & 255, i[n++] = 255 & d, i[n++] = d >>> 24 & 15 | 16, i[n++] = d >>> 16 & 255, i[n++] = o >>> 8 | 128, i[n++] = 255 & o;
  for (var p = 0; p < 6; ++p)
    i[n + p] = s[p];
  return t || ei(i);
}, v3: ih, v4: function(e, t, r) {
  var n = (e = e || {}).random || (e.rng || na)();
  if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, t) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      t[r + i] = n[i];
    return t;
  }
  return ei(n);
}, v5: ah, NIL: "00000000-0000-0000-0000-000000000000", version: function(e) {
  if (!di(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}, validate: di, stringify: ei, parse: du });
const Qr = ["debug", "info", "warn", "error", "none"];
var Bs = { commonBasicLogger: function(e, t) {
  if (e && e.destination && typeof e.destination != "function")
    throw new Error("destination for basicLogger was set to a non-function");
  function r(u) {
    return function(f) {
      console && console[u] && console[u].call(console, f);
    };
  }
  const n = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [r("log"), r("info"), r("warn"), r("error")], i = !(!e || !e.destination), s = e && e.prefix !== void 0 && e.prefix !== null ? e.prefix : "[LaunchDarkly] ";
  let o = 1;
  if (e && e.level)
    for (let u = 0; u < Qr.length; u++)
      Qr[u] === e.level && (o = u);
  function a(u, f, l) {
    if (l.length < 1)
      return;
    let d;
    const p = i ? f + ": " + s : s;
    if (l.length !== 1 && t) {
      const y = [...l];
      y[0] = p + y[0], d = t(...y);
    } else
      d = p + l[0];
    try {
      n[u](d);
    } catch (y) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + f + " method threw an exception: " + y);
    }
  }
  const c = {};
  for (let u = 0; u < Qr.length; u++) {
    const f = Qr[u];
    if (f !== "none")
      if (u < o)
        c[f] = () => {
        };
      else {
        const l = u;
        c[f] = function() {
          a(l, f, arguments);
        };
      }
  }
  return c;
}, validateLogger: function(e) {
  Qr.forEach((t) => {
    if (t !== "none" && (!e[t] || typeof e[t] != "function"))
      throw new Error("Provided logger instance must support logger." + t + "(...) method");
  });
} };
function Bn(e) {
  return e && e.message ? e.message : typeof e == "string" || e instanceof String ? e : JSON.stringify(e);
}
const _r = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initializing-the-client for instructions on SDK initialization.";
var U = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + _r;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(e) {
  return 'enqueueing "' + e + '" event';
}, debugPostingDiagnosticEvent: function(e) {
  return "sending diagnostic event (" + e.kind + ")";
}, debugPostingEvents: function(e) {
  return "sending " + e + " events";
}, debugStreamDelete: function(e) {
  return 'received streaming deletion for flag "' + e + '"';
}, debugStreamDeleteIgnored: function(e) {
  return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
}, debugStreamPatch: function(e) {
  return 'received streaming update for flag "' + e + '"';
}, debugStreamPatchIgnored: function(e) {
  return 'received streaming update for flag "' + e + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(e) {
  return "polling for feature flags at " + e;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(e, t) {
  return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + _r;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + _r;
}, errorFetchingFlags: function(e) {
  return "Error fetching flag settings: " + Bn(e);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(e, t, r) {
  return "Received error " + e + (e === 401 ? " (invalid SDK key)" : "") + " for " + t + " - " + (_t.isHttpErrorRecoverable(e) ? r : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + _r;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (e, t) => `an inspector: "${t}" of type: "${e}" generated an exception`, invalidContentType: function(e) {
  return 'Expected application/json content type but got "' + e + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (e, t) => `an inspector: "${t}" of an invalid type (${e}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidContext: function() {
  return "Invalid context specified." + _r;
}, invalidTagValue: (e) => `Config option "${e}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(e) {
  return "local storage is unavailable: " + Bn(e);
}, networkError: (e) => "network error" + (e ? " (" + e + ")" : ""), optionBelowMinimum: (e, t, r) => 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + r, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(e) {
  return "Opening stream connection to " + e;
}, streamError: function(e, t) {
  return "Error on stream connection: " + Bn(e) + ", will continue retrying after " + t + " milliseconds.";
}, tagValueTooLong: (e) => `Value of "${e}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(e) {
  return 'Custom event "' + e + '" does not exist';
}, unknownOption: (e) => 'Ignoring unknown config option "' + e + '"', contextNotSpecified: function() {
  return "No context specified." + _r;
}, unrecoverableStreamError: (e) => `Error on stream connection ${Bn(e)}, giving up permanently`, wrongOptionType: (e, t, r) => 'Config option "' + e + '" should be of type ' + t + ", got " + r + ", using default value", wrongOptionTypeBoolean: (e, t) => 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean" };
const { validateLogger: uh } = Bs, oa = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(e, t, r) {
  const n = {};
  return t.id && (n.id = aa(`${e}.id`, t.id, r)), t.version && (n.version = aa(`${e}.version`, t.version, r)), n;
} }, inspectors: { default: [] } }, ch = /^(\w|\.|-)+$/;
function ns(e) {
  return e && e.replace(/\/+$/, "");
}
function aa(e, t, r) {
  if (typeof t == "string" && t.match(ch)) {
    if (!(t.length > 64))
      return t;
    r.warn(U.tagValueTooLong(e));
  } else
    r.warn(U.invalidTagValue(e));
}
var Hs = { baseOptionDefs: oa, validate: function(e, t, r, n) {
  const i = j.extend({ logger: { default: n } }, oa, r), s = {};
  function o(c) {
    j.onNextTick(() => {
      t && t.maybeReportError(new _t.LDInvalidArgumentError(c));
    });
  }
  let a = j.extend({}, e || {});
  return function(c) {
    const u = c;
    Object.keys(s).forEach((f) => {
      if (u[f] !== void 0) {
        const l = s[f];
        n && n.warn(U.deprecated(f, l)), l && (u[l] === void 0 && (u[l] = u[f]), delete u[f]);
      }
    });
  }(a), a = function(c) {
    const u = j.extend({}, c);
    return Object.keys(i).forEach((f) => {
      u[f] !== void 0 && u[f] !== null || (u[f] = i[f] && i[f].default);
    }), u;
  }(a), a = function(c) {
    const u = j.extend({}, c), f = (l) => {
      if (l === null)
        return "any";
      if (l === void 0)
        return;
      if (Array.isArray(l))
        return "array";
      const d = typeof l;
      return d === "boolean" || d === "string" || d === "number" || d === "function" ? d : "object";
    };
    return Object.keys(c).forEach((l) => {
      const d = c[l];
      if (d != null) {
        const p = i[l];
        if (p === void 0)
          o(U.unknownOption(l));
        else {
          const y = p.type || f(p.default), m = p.validator;
          if (m) {
            const _ = m(l, c[l], n);
            _ !== void 0 ? u[l] = _ : delete u[l];
          } else if (y !== "any") {
            const _ = y.split("|"), b = f(d);
            _.indexOf(b) < 0 ? y === "boolean" ? (u[l] = !!d, o(U.wrongOptionTypeBoolean(l, b))) : (o(U.wrongOptionType(l, y, b)), u[l] = p.default) : b === "number" && p.minimum !== void 0 && d < p.minimum && (o(U.optionBelowMinimum(l, d, p.minimum)), u[l] = p.minimum);
          }
        }
      }
    }), u.baseUrl = ns(u.baseUrl), u.streamUrl = ns(u.streamUrl), u.eventsUrl = ns(u.eventsUrl), u;
  }(a), uh(a.logger), a;
}, getTags: function(e) {
  const t = {};
  return e && (e.application && e.application.id !== void 0 && e.application.id !== null && (t["application-id"] = [e.application.id]), e.application && e.application.version !== void 0 && e.application.id !== null && (t["application-version"] = [e.application.version])), t;
} };
const { getLDUserAgentString: fh } = j;
var Ks = { getLDHeaders: function(e, t) {
  if (t && !t.sendLDHeaders)
    return {};
  const r = {};
  r[e.userAgentHeaderName || "User-Agent"] = fh(e), t && t.wrapperName && (r["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
  const n = Hs.getTags(t), i = Object.keys(n);
  return i.length && (r["x-launchdarkly-tags"] = i.sort().map((s) => Array.isArray(n[s]) ? n[s].sort().map((o) => `${s}/${o}`) : [`${s}/${n[s]}`]).reduce((s, o) => s.concat(o), []).join(" ")), r;
}, transformHeaders: function(e, t) {
  return t && t.requestHeaderTransform ? t.requestHeaderTransform({ ...e }) : e;
} };
const { v1: lh } = zs, { getLDHeaders: hh, transformHeaders: dh } = Ks;
var vu = function(e, t, r) {
  const n = "/a/" + t + ".gif", i = j.extend({ "Content-Type": "application/json" }, hh(e, r)), s = e.httpFallbackPing, o = {};
  return o.sendChunk = (a, c, u, f) => {
    const l = JSON.stringify(a), d = u ? null : lh();
    return f ? function p(y) {
      const m = u ? i : j.extend({}, i, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": d });
      return e.httpRequest("POST", c, dh(m, r), l).promise.then((_) => {
        if (_)
          return _.status >= 400 && _t.isHttpErrorRecoverable(_.status) && y ? p(!1) : function(b) {
            const w = { status: b.status }, R = b.header("date");
            if (R) {
              const A = Date.parse(R);
              A && (w.serverTime = A);
            }
            return w;
          }(_);
      }).catch(() => y ? p(!1) : Promise.reject());
    }(!0).catch(() => {
    }) : (s && s(c + n + "?d=" + j.base64URLEncode(l)), Promise.resolve());
  }, o.sendEvents = function(a, c, u) {
    if (!e.httpRequest)
      return Promise.resolve();
    const f = e.httpAllowsPost();
    let l;
    l = f ? [a] : j.chunkEventsForUrl(2e3 - c.length, a);
    const d = [];
    for (let p = 0; p < l.length; p++)
      d.push(o.sendChunk(l[p], c, u, f));
    return Promise.all(d);
  }, o;
};
const { commonBasicLogger: ph } = Bs;
function ua(e) {
  return typeof e == "string" && e !== "kind" && e.match(/^(\w|\.|-)+$/);
}
function ca(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var Si = { checkContext: function(e, t) {
  if (e) {
    if (t && (e.kind === void 0 || e.kind === null))
      return e.key !== void 0 && e.key !== null;
    const r = e.key, n = e.kind === void 0 ? "user" : e.kind, i = ua(n), s = n === "multi" || r != null && r !== "";
    if (n === "multi") {
      const o = Object.keys(e).filter((a) => a !== "kind");
      return s && o.every((a) => ua(a)) && o.every((a) => {
        const c = e[a].key;
        return c != null && c !== "";
      });
    }
    return s && i;
  }
  return !1;
}, getContextKeys: function(e, t = ph()) {
  if (!e)
    return;
  const r = {}, { kind: n, key: i } = e;
  switch (n) {
    case void 0:
      r.user = `${i}`;
      break;
    case "multi":
      Object.entries(e).filter(([s]) => s !== "kind").forEach(([s, o]) => {
        o && o.key && (r[s] = o.key);
      });
      break;
    case null:
      t.warn(`null is not a valid context kind: ${e}`);
      break;
    case "":
      t.warn(`'' is not a valid context kind: ${e}`);
      break;
    default:
      r[n] = `${i}`;
  }
  return r;
}, getContextKinds: function(e) {
  return e ? e.kind === null || e.kind === void 0 ? ["user"] : e.kind !== "multi" ? [e.kind] : Object.keys(e).filter((t) => t !== "kind") : [];
}, getCanonicalKey: function(e) {
  if (e) {
    if ((e.kind === void 0 || e.kind === null || e.kind === "user") && e.key)
      return e.key;
    if (e.kind !== "multi" && e.key)
      return `${e.kind}:${ca(e.key)}`;
    if (e.kind === "multi")
      return Object.keys(e).sort().filter((t) => t !== "kind").map((t) => `${t}:${ca(e[t].key)}`).join(":");
  }
} };
const { getContextKinds: vh } = Si;
var yh = function() {
  const e = {};
  let t = 0, r = 0, n = {}, i = {};
  return e.summarizeEvent = (s) => {
    if (s.kind === "feature") {
      const o = s.key + ":" + (s.variation !== null && s.variation !== void 0 ? s.variation : "") + ":" + (s.version !== null && s.version !== void 0 ? s.version : ""), a = n[o];
      let c = i[s.key];
      c || (c = /* @__PURE__ */ new Set(), i[s.key] = c), function(u) {
        return u.context ? vh(u.context) : u.contextKeys ? Object.keys(u.contextKeys) : [];
      }(s).forEach((u) => c.add(u)), a ? a.count = a.count + 1 : n[o] = { count: 1, key: s.key, version: s.version, variation: s.variation, value: s.value, default: s.default }, (t === 0 || s.creationDate < t) && (t = s.creationDate), s.creationDate > r && (r = s.creationDate);
    }
  }, e.getSummary = () => {
    const s = {};
    let o = !0;
    for (const a of Object.values(n)) {
      let c = s[a.key];
      c || (c = { default: a.default, counters: [], contextKinds: [...i[a.key]] }, s[a.key] = c);
      const u = { value: a.value, count: a.count };
      a.variation !== void 0 && a.variation !== null && (u.variation = a.variation), a.version !== void 0 && a.version !== null ? u.version = a.version : u.unknown = !0, c.counters.push(u), o = !1;
    }
    return o ? null : { startDate: t, endDate: r, features: s };
  }, e.clearSummary = () => {
    t = 0, r = 0, n = {}, i = {};
  }, e;
};
function yu(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function fa(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map((t) => t.indexOf("~") >= 0 ? t.replace(/~1/g, "/").replace(/~0/g, "~") : t);
}
function la(e) {
  return !e.startsWith("/");
}
function ha(e, t) {
  const r = la(e), n = la(t);
  if (r && n)
    return e === t;
  if (r) {
    const i = fa(t);
    return i.length === 1 && e === i[0];
  }
  if (n) {
    const i = fa(e);
    return i.length === 1 && t === i[0];
  }
  return e === t;
}
function da(e) {
  return `/${yu(e)}`;
}
var is = { cloneExcluding: function(e, t) {
  const r = [], n = {}, i = [];
  for (r.push(...Object.keys(e).map((s) => ({ key: s, ptr: da(s), source: e, parent: n, visited: [e] }))); r.length; ) {
    const s = r.pop();
    if (t.some((o) => ha(o, s.ptr)))
      i.push(s.ptr);
    else {
      const o = s.source[s.key];
      if (o === null)
        s.parent[s.key] = o;
      else if (Array.isArray(o))
        s.parent[s.key] = [...o];
      else if (typeof o == "object") {
        if (s.visited.includes(o))
          continue;
        s.parent[s.key] = {}, r.push(...Object.keys(o).map((a) => {
          return { key: a, ptr: (c = s.ptr, u = yu(a), `${c}/${u}`), source: o, parent: s.parent[s.key], visited: [...s.visited, o] };
          var c, u;
        }));
      } else
        s.parent[s.key] = o;
    }
  }
  return { cloned: n, excluded: i.sort() };
}, compare: ha, literalToReference: da }, gh = function(e) {
  const t = {}, r = e.allAttributesPrivate, n = e.privateAttributes || [], i = ["key", "kind", "_meta", "anonymous"], s = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], o = (a) => {
    if (typeof a != "object" || a === null || Array.isArray(a))
      return;
    const { cloned: c, excluded: u } = is.cloneExcluding(a, ((f) => (r ? Object.keys(f) : [...n, ...f._meta && f._meta.privateAttributes || []]).filter((l) => !i.some((d) => is.compare(l, d))))(a));
    return c.key = String(c.key), u.length && (c._meta || (c._meta = {}), c._meta.redactedAttributes = u), c._meta && (delete c._meta.privateAttributes, Object.keys(c._meta).length === 0 && delete c._meta), c.anonymous !== void 0 && (c.anonymous = !!c.anonymous), c;
  };
  return t.filter = (a) => a.kind === void 0 || a.kind === null ? o(((c) => {
    const u = { ...c.custom || {}, kind: "user", key: c.key };
    c.anonymous !== void 0 && (u.anonymous = !!c.anonymous);
    for (const f of s)
      delete u[f], c[f] !== void 0 && c[f] !== null && (u[f] = String(c[f]));
    return c.privateAttributeNames !== void 0 && c.privateAttributeNames !== null && (u._meta = u._meta || {}, u._meta.privateAttributes = c.privateAttributeNames.map((f) => f.startsWith("/") ? is.literalToReference(f) : f)), u;
  })(a)) : a.kind === "multi" ? ((c) => {
    const u = { kind: c.kind }, f = Object.keys(c);
    for (const l of f)
      if (l !== "kind") {
        const d = o(c[l]);
        d && (u[l] = d);
      }
    return u;
  })(a) : o(a), t;
};
const { getContextKeys: mh } = Si;
var _h = function(e, t, r, n = null, i = null, s = null) {
  const o = {}, a = s || vu(e, r, t), c = j.appendUrlPath(t.eventsUrl, "/events/bulk/" + r), u = yh(), f = gh(t), l = t.samplingInterval, d = t.eventCapacity, p = t.flushInterval, y = t.logger;
  let m, _ = [], b = 0, w = !1, R = !1;
  function A() {
    return l === 0 || Math.floor(Math.random() * l) === 0;
  }
  function F(O) {
    const x = j.extend({}, O);
    return O.kind === "identify" ? x.context = f.filter(O.context) : (x.contextKeys = mh(O.context, y), delete x.context), O.kind === "feature" && (delete x.trackEvents, delete x.debugEventsUntilDate), x;
  }
  function k(O) {
    _.length < d ? (_.push(O), R = !1) : (R || (R = !0, y.warn(U.eventCapacityExceeded())), n && n.incrementDroppedEvents());
  }
  return o.enqueue = function(O) {
    if (w)
      return;
    let x = !1, I = !1;
    var N;
    if (u.summarizeEvent(O), O.kind === "feature" ? A() && (x = !!O.trackEvents, I = !!(N = O).debugEventsUntilDate && N.debugEventsUntilDate > b && N.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : x = A(), x && k(F(O)), I) {
      const H = j.extend({}, O, { kind: "debug" });
      H.context = f.filter(H.context), delete H.trackEvents, delete H.debugEventsUntilDate, k(H);
    }
  }, o.flush = function() {
    if (w)
      return Promise.resolve();
    const O = _, x = u.getSummary();
    return u.clearSummary(), x && (x.kind = "summary", O.push(x)), n && n.setEventsInLastBatch(O.length), O.length === 0 ? Promise.resolve() : (_ = [], y.debug(U.debugPostingEvents(O.length)), a.sendEvents(O, c).then((I) => {
      const N = I && I[0];
      N && (N.serverTime && (b = N.serverTime), _t.isHttpErrorRecoverable(N.status) || (w = !0), N.status >= 400 && j.onNextTick(() => {
        i.maybeReportError(new _t.LDUnexpectedResponseError(U.httpErrorMessage(N.status, "event posting", "some events were dropped")));
      }));
    }));
  }, o.start = function() {
    const O = () => {
      o.flush(), m = setTimeout(O, p);
    };
    m = setTimeout(O, p);
  }, o.stop = function() {
    clearTimeout(m);
  }, o;
}, bh = function(e) {
  const t = {}, r = {};
  return t.on = function(n, i, s) {
    r[n] = r[n] || [], r[n] = r[n].concat({ handler: i, context: s });
  }, t.off = function(n, i, s) {
    if (r[n])
      for (let o = 0; o < r[n].length; o++)
        r[n][o].handler === i && r[n][o].context === s && (r[n] = r[n].slice(0, o).concat(r[n].slice(o + 1)));
  }, t.emit = function(n) {
    if (!r[n])
      return;
    const i = r[n].slice(0);
    for (let s = 0; s < i.length; s++)
      i[s].handler.apply(i[s].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function() {
    return Object.keys(r);
  }, t.getEventListenerCount = function(n) {
    return r[n] ? r[n].length : 0;
  }, t.maybeReportError = function(n) {
    n && (r.error ? this.emit("error", n) : (e || console).error(n.message));
  }, t;
};
const Hn = "ready", ss = "initialized", os = "failed";
var wh = function(e) {
  let t = !1, r = !1, n = null, i = null;
  const s = new Promise((o) => {
    const a = () => {
      e.off(Hn, a), o();
    };
    e.on(Hn, a);
  }).catch(() => {
  });
  return { getInitializationPromise: () => i || (t ? Promise.resolve() : r ? Promise.reject(n) : (i = new Promise((o, a) => {
    const c = () => {
      e.off(ss, c), o();
    }, u = (f) => {
      e.off(os, u), a(f);
    };
    e.on(ss, c), e.on(os, u);
  }), i)), getReadyPromise: () => s, signalSuccess: () => {
    t || r || (t = !0, e.emit(ss), e.emit(Hn));
  }, signalFailure: (o) => {
    t || r || (r = !0, n = o, e.emit(os, o), e.emit(Hn)), e.maybeReportError(o);
  } };
}, Eh = function(e, t, r, n) {
  const i = {};
  function s() {
    let o = "";
    const a = n.getContext();
    return a && (o = r || j.btoa(JSON.stringify(a))), "ld:" + t + ":" + o;
  }
  return i.loadFlags = () => e.get(s()).then((o) => {
    if (o == null)
      return null;
    try {
      let a = JSON.parse(o);
      if (a) {
        const c = a.$schema;
        c === void 0 || c < 1 ? a = j.transformValuesToVersionedValues(a) : delete a.$schema;
      }
      return a;
    } catch {
      return i.clearFlags().then(() => null);
    }
  }), i.saveFlags = (o) => {
    const a = j.extend({}, o, { $schema: 1 });
    return e.set(s(), JSON.stringify(a));
  }, i.clearFlags = () => e.clear(s()), i;
}, Sh = function(e, t) {
  const r = {};
  let n = !1;
  const i = (s) => {
    n || (n = !0, t.warn(U.localStorageUnavailable(s)));
  };
  return r.isEnabled = () => !!e, r.get = (s) => new Promise((o) => {
    e ? e.get(s).then(o).catch((a) => {
      i(a), o(void 0);
    }) : o(void 0);
  }), r.set = (s, o) => new Promise((a) => {
    e ? e.set(s, o).then(() => a(!0)).catch((c) => {
      i(c), a(!1);
    }) : a(!1);
  }), r.clear = (s) => new Promise((o) => {
    e ? e.clear(s).then(() => o(!0)).catch((a) => {
      i(a), o(!1);
    }) : o(!1);
  }), r;
};
const { appendUrlPath: pa, base64URLEncode: Oh, objectHasOwnProperty: Ih } = j, { getLDHeaders: Ch, transformHeaders: Ph } = Ks, { isHttpErrorRecoverable: Rh } = _t;
var Th = function(e, t, r, n) {
  const i = t.streamUrl, s = t.logger, o = {}, a = pa(i, "/eval/" + r), c = t.useReport, u = t.evaluationReasons, f = t.streamReconnectDelay, l = Ch(e, t);
  let d, p = !1, y = null, m = null, _ = null, b = null, w = null, R = 0;
  function A() {
    const N = (H = function() {
      const nt = f * Math.pow(2, R);
      return nt > 3e4 ? 3e4 : nt;
    }(), H - Math.trunc(0.5 * Math.random() * H));
    var H;
    return R += 1, N;
  }
  function F(N) {
    if (N.status && typeof N.status == "number" && !Rh(N.status))
      return x(), s.error(U.unrecoverableStreamError(N)), void (m && (clearTimeout(m), m = null));
    const H = A();
    p || (s.warn(U.streamError(N, H)), p = !0), I(!1), x(), k(H);
  }
  function k(N) {
    m || (N ? m = setTimeout(O, N) : O());
  }
  function O() {
    let N;
    m = null;
    let H = "";
    const nt = { headers: l, readTimeoutMillis: 3e5 };
    if (e.eventSourceFactory) {
      b != null && (H = "h=" + b), c ? e.eventSourceAllowsReport ? (N = a, nt.method = "REPORT", nt.headers["Content-Type"] = "application/json", nt.body = JSON.stringify(_)) : (N = pa(i, "/ping/" + r), H = "") : N = a + "/" + Oh(JSON.stringify(_)), nt.headers = Ph(nt.headers, t), u && (H = H + (H ? "&" : "") + "withReasons=true"), N = N + (H ? "?" : "") + H, x(), s.info(U.streamConnecting(N)), d = (/* @__PURE__ */ new Date()).getTime(), y = e.eventSourceFactory(N, nt);
      for (const G in w)
        Ih(w, G) && y.addEventListener(G, w[G]);
      y.onerror = F, y.onopen = () => {
        R = 0;
      };
    }
  }
  function x() {
    y && (s.info(U.streamClosing()), y.close(), y = null);
  }
  function I(N) {
    d && n && n.recordStreamInit(d, !N, (/* @__PURE__ */ new Date()).getTime() - d), d = null;
  }
  return o.connect = function(N, H, nt) {
    _ = N, b = H, w = {};
    for (const G in nt || {})
      w[G] = function(ft) {
        p = !1, I(!0), nt[G] && nt[G](ft);
      };
    k();
  }, o.disconnect = function() {
    clearTimeout(m), m = null, x();
  }, o.isConnected = function() {
    return !!(y && e.eventSourceIsActive && e.eventSourceIsActive(y));
  }, o;
}, Dh = function(e) {
  let t, r, n, i;
  const s = { addPromise: (o, a) => {
    t = o, r && r(), r = a, o.then((c) => {
      t === o && (n(c), e && e());
    }, (c) => {
      t === o && (i(c), e && e());
    });
  } };
  return s.resultPromise = new Promise((o, a) => {
    n = o, i = a;
  }), s;
};
const { transformHeaders: Ah, getLDHeaders: xh } = Ks, as = "application/json";
var kh = function(e, t, r) {
  const n = t.baseUrl, i = t.useReport, s = t.evaluationReasons, o = t.logger, a = {}, c = {};
  function u(f, l) {
    if (!e.httpRequest)
      return new Promise((b, w) => {
        w(new _t.LDFlagFetchError(U.httpUnavailable()));
      });
    const d = l ? "REPORT" : "GET", p = xh(e, t);
    l && (p["Content-Type"] = as);
    let y = c[f];
    y || (y = Dh(() => {
      delete c[f];
    }), c[f] = y);
    const m = e.httpRequest(d, f, Ah(p, t), l), _ = m.promise.then((b) => {
      if (b.status === 200) {
        if (b.header("content-type") && b.header("content-type").substring(0, as.length) === as)
          return JSON.parse(b.body);
        {
          const w = U.invalidContentType(b.header("content-type") || "");
          return Promise.reject(new _t.LDFlagFetchError(w));
        }
      }
      return Promise.reject(function(w) {
        return w.status === 404 ? new _t.LDInvalidEnvironmentIdError(U.environmentNotFound()) : new _t.LDFlagFetchError(U.errorFetchingFlags(w.statusText || String(w.status)));
      }(b));
    }, (b) => Promise.reject(new _t.LDFlagFetchError(U.networkError(b))));
    return y.addPromise(_, () => {
      m.cancel && m.cancel();
    }), y.resultPromise;
  }
  return a.fetchJSON = function(f) {
    return u(j.appendUrlPath(n, f), null);
  }, a.fetchFlagSettings = function(f, l) {
    let d, p, y, m = "";
    return i ? (p = [n, "/sdk/evalx/", r, "/context"].join(""), y = JSON.stringify(f)) : (d = j.base64URLEncode(JSON.stringify(f)), p = [n, "/sdk/evalx/", r, "/contexts/", d].join("")), l && (m = "h=" + l), s && (m = m + (m ? "&" : "") + "withReasons=true"), p = p + (m ? "?" : "") + m, o.debug(U.debugPolling(p)), u(p, y);
  }, a;
}, Fh = function(e, t) {
  const r = {};
  let n;
  return r.setContext = function(i) {
    n = j.sanitizeContext(i), n && t && t(j.clone(n));
  }, r.getContext = function() {
    return n ? j.clone(n) : null;
  }, e && r.setContext(e), r;
};
const { v1: Lh } = zs, { getContextKinds: Nh } = Si;
var Mh = function(e) {
  function t(n) {
    return n == null || n === "user" ? "ld:$anonUserId" : `ld:$contextKey:${n}`;
  }
  function r(n, i) {
    return i.key !== null && i.key !== void 0 ? (i.key = i.key.toString(), Promise.resolve(i)) : i.anonymous ? function(s) {
      return e.get(t(s));
    }(n).then((s) => {
      if (s)
        return i.key = s, i;
      {
        const o = Lh();
        return i.key = o, function(a, c) {
          return e.set(t(c), a);
        }(o, n).then(() => i);
      }
    }) : Promise.reject(new _t.LDInvalidUserError(U.invalidContext()));
  }
  this.processContext = (n) => {
    if (!n)
      return Promise.reject(new _t.LDInvalidUserError(U.contextNotSpecified()));
    const i = j.clone(n);
    if (n.kind === "multi") {
      const s = Nh(i);
      return Promise.all(s.map((o) => r(o, i[o]))).then(() => i);
    }
    return r(n.kind, i);
  };
};
const { v1: qh } = zs, { baseOptionDefs: us } = Hs, { appendUrlPath: Uh } = j;
var cs = { DiagnosticId: function(e) {
  const t = { diagnosticId: qh() };
  return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
}, DiagnosticsAccumulator: function(e) {
  let t, r, n, i;
  function s(o) {
    t = o, r = 0, n = 0, i = [];
  }
  return s(e), { getProps: () => ({ dataSinceDate: t, droppedEvents: r, eventsInLastBatch: n, streamInits: i }), setProps: (o) => {
    t = o.dataSinceDate, r = o.droppedEvents || 0, n = o.eventsInLastBatch || 0, i = o.streamInits || [];
  }, incrementDroppedEvents: () => {
    r++;
  }, setEventsInLastBatch: (o) => {
    n = o;
  }, recordStreamInit: (o, a, c) => {
    const u = { timestamp: o, failed: a, durationMillis: c };
    i.push(u);
  }, reset: s };
}, DiagnosticsManager: function(e, t, r, n, i, s, o) {
  const a = !!e.diagnosticUseCombinedEvent, c = "ld:" + i + ":$diagnostics", u = Uh(s.eventsUrl, "/events/diagnostic/" + i), f = s.diagnosticRecordingInterval, l = r;
  let d, p, y = !!s.streaming;
  const m = {};
  function _() {
    return { sdk: R(), configuration: A(), platform: e.diagnosticPlatformData };
  }
  function b(F) {
    s.logger && s.logger.debug(U.debugPostingDiagnosticEvent(F)), n.sendEvents(F, u, !0).then(() => {
    }).catch(() => {
    });
  }
  function w() {
    b(function() {
      const F = (/* @__PURE__ */ new Date()).getTime();
      let k = { kind: a ? "diagnostic-combined" : "diagnostic", id: o, creationDate: F, ...l.getProps() };
      return a && (k = { ...k, ..._() }), l.reset(F), k;
    }()), p = setTimeout(w, f), d = (/* @__PURE__ */ new Date()).getTime(), a && function() {
      if (t.isEnabled()) {
        const F = { ...l.getProps() };
        t.set(c, JSON.stringify(F));
      }
    }();
  }
  function R() {
    const F = { ...e.diagnosticSdkData };
    return s.wrapperName && (F.wrapperName = s.wrapperName), s.wrapperVersion && (F.wrapperVersion = s.wrapperVersion), F;
  }
  function A() {
    return { customBaseURI: s.baseUrl !== us.baseUrl.default, customStreamURI: s.streamUrl !== us.streamUrl.default, customEventsURI: s.eventsUrl !== us.eventsUrl.default, eventsCapacity: s.eventCapacity, eventsFlushIntervalMillis: s.flushInterval, reconnectTimeMillis: s.streamReconnectDelay, streamingDisabled: !y, allAttributesPrivate: !!s.allAttributesPrivate, diagnosticRecordingIntervalMillis: s.diagnosticRecordingInterval, usingSecureMode: !!s.hash, bootstrapMode: !!s.bootstrap, fetchGoalsDisabled: !s.fetchGoals, sendEventsOnlyForVariation: !!s.sendEventsOnlyForVariation };
  }
  return m.start = () => {
    a ? function(F) {
      if (!t.isEnabled())
        return F(!1);
      t.get(c).then((k) => {
        if (k)
          try {
            const O = JSON.parse(k);
            l.setProps(O), d = O.dataSinceDate;
          } catch {
          }
        F(!0);
      }).catch(() => {
        F(!1);
      });
    }((F) => {
      if (F) {
        const k = (d || 0) + f, O = (/* @__PURE__ */ new Date()).getTime();
        O >= k ? w() : p = setTimeout(w, k - O);
      } else
        Math.floor(4 * Math.random()) === 0 ? w() : p = setTimeout(w, f);
    }) : (b({ kind: "diagnostic-init", id: o, creationDate: l.getProps().dataSinceDate, ..._() }), p = setTimeout(w, f));
  }, m.stop = () => {
    p && clearTimeout(p);
  }, m.setStreaming = (F) => {
    y = F;
  }, m;
} }, jh = function(e, t) {
  let r = !1;
  const n = { type: e.type, name: e.name, method: (...i) => {
    try {
      e.method(...i);
    } catch {
      r || (r = !0, t.warn(U.inspectorMethodError(n.type, n.name)));
    }
  } };
  return n;
};
const { onNextTick: Kn } = j, qt = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(qt);
var $h = { InspectorTypes: qt, InspectorManager: function(e, t) {
  const r = {}, n = { [qt.flagUsed]: [], [qt.flagDetailsChanged]: [], [qt.flagDetailChanged]: [], [qt.clientIdentityChanged]: [] }, i = e && e.map((s) => jh(s, t));
  return i && i.forEach((s) => {
    Object.prototype.hasOwnProperty.call(n, s.type) ? n[s.type].push(s) : t.warn(U.invalidInspector(s.type, s.name));
  }), r.hasListeners = (s) => n[s] && n[s].length, r.onFlagUsed = (s, o, a) => {
    n[qt.flagUsed].length && Kn(() => {
      n[qt.flagUsed].forEach((c) => c.method(s, o, a));
    });
  }, r.onFlags = (s) => {
    n[qt.flagDetailsChanged].length && Kn(() => {
      n[qt.flagDetailsChanged].forEach((o) => o.method(s));
    });
  }, r.onFlagChanged = (s, o) => {
    n[qt.flagDetailChanged].length && Kn(() => {
      n[qt.flagDetailChanged].forEach((a) => a.method(s, o));
    });
  }, r.onIdentityChanged = (s) => {
    n[qt.clientIdentityChanged].length && Kn(() => {
      n[qt.clientIdentityChanged].forEach((o) => o.method(s));
    });
  }, r;
} };
const { commonBasicLogger: va } = Bs, { checkContext: zh, getContextKeys: Bh } = Si, { InspectorTypes: Qn, InspectorManager: Hh } = $h, Gr = "change", ya = "internal-change";
var gu = { initialize: function(e, t, r, n, i) {
  const s = function() {
    return r && r.logger ? r.logger : i && i.logger && i.logger.default || va("warn");
  }(), o = bh(s), a = wh(o), c = Hs.validate(r, o, i, s), u = Hh(c.inspectors, s), f = c.sendEvents;
  let l = e, d = c.hash;
  const p = Sh(n.localStorage, s), y = vu(n, l, c), m = c.sendEvents && !c.diagnosticOptOut, _ = m ? cs.DiagnosticId(l) : null, b = m ? cs.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, w = m ? cs.DiagnosticsManager(n, p, b, y, l, c, _) : null, R = Th(n, c, l, b), A = c.eventProcessor || _h(n, c, l, b, o, y), F = kh(n, c, l);
  let k, O, x, I = {}, N = c.streaming, H = !1, nt = !1, G = !0;
  const ft = c.stateProvider, ot = Fh(null, function(S) {
    (function(T) {
      ft || T && be({ kind: "identify", context: T, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(S), u.hasListeners(Qn.clientIdentityChanged) && u.onIdentityChanged(ot.getContext());
  }), He = new Mh(p), ne = p.isEnabled() ? Eh(p, l, d, ot) : null;
  function be(S) {
    l && (ft && ft.enqueueEvent && ft.enqueueEvent(S) || (S.context ? (G = !1, !f || nt || n.isDoNotTrack() || (s.debug(U.debugEnqueueingEvent(S.kind)), A.enqueue(S))) : G && (s.warn(U.eventWithoutContext()), G = !1)));
  }
  function Ke(S, T) {
    u.hasListeners(Qn.flagDetailChanged) && u.onFlagChanged(S.key, he(T));
  }
  function Qe() {
    u.hasListeners(Qn.flagDetailsChanged) && u.onFlags(Object.entries(I).map(([S, T]) => ({ key: S, detail: he(T) })).reduce((S, T) => (S[T.key] = T.detail, S), {}));
  }
  function Ge(S, T, P, V) {
    const Y = ot.getContext(), it = /* @__PURE__ */ new Date(), X = { kind: "feature", key: S, context: Y, value: T ? T.value : null, variation: T ? T.variationIndex : null, default: P, creationDate: it.getTime() }, gt = I[S];
    gt && (X.version = gt.flagVersion ? gt.flagVersion : gt.version, X.trackEvents = gt.trackEvents, X.debugEventsUntilDate = gt.debugEventsUntilDate), (V || gt && gt.trackReason) && T && (X.reason = T.reason), be(X);
  }
  function Ve(S) {
    return zh(S, !1) ? Promise.resolve(S) : Promise.reject(new _t.LDInvalidUserError(U.invalidContext()));
  }
  function Te(S, T, P, V, Y) {
    let it;
    if (I && j.objectHasOwnProperty(I, S) && I[S] && !I[S].deleted) {
      const X = I[S];
      it = he(X), X.value !== null && X.value !== void 0 || (it.value = T);
    } else
      it = { value: T, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } };
    return P && Ge(S, it, T, V), Y || function(X, gt) {
      u.hasListeners(Qn.flagUsed) && u.onFlagUsed(X, gt, ot.getContext());
    }(S, it), it;
  }
  function he(S) {
    return { value: S.value, variationIndex: S.variation === void 0 ? null : S.variation, reason: S.reason || null };
  }
  function dr() {
    if (O = !0, !ot.getContext())
      return;
    const S = (T) => {
      try {
        return JSON.parse(T);
      } catch {
        return void o.maybeReportError(new _t.LDInvalidDataError(U.invalidData()));
      }
    };
    R.connect(ot.getContext(), d, { ping: function() {
      s.debug(U.debugStreamPing());
      const T = ot.getContext();
      F.fetchFlagSettings(T, d).then((P) => {
        j.deepEquals(T, ot.getContext()) && Qt(P || {});
      }).catch((P) => {
        o.maybeReportError(new _t.LDFlagFetchError(U.errorFetchingFlags(P)));
      });
    }, put: function(T) {
      const P = S(T.data);
      P && (s.debug(U.debugStreamPut()), Qt(P));
    }, patch: function(T) {
      const P = S(T.data);
      if (!P)
        return;
      const V = I[P.key];
      if (!V || !V.version || !P.version || V.version < P.version) {
        s.debug(U.debugStreamPatch(P.key));
        const Y = {}, it = j.extend({}, P);
        delete it.key, I[P.key] = it;
        const X = he(it);
        Y[P.key] = V ? { previous: V.value, current: X } : { current: X }, J(Y), Ke(P, it);
      } else
        s.debug(U.debugStreamPatchIgnored(P.key));
    }, delete: function(T) {
      const P = S(T.data);
      if (P)
        if (!I[P.key] || I[P.key].version < P.version) {
          s.debug(U.debugStreamDelete(P.key));
          const V = {};
          I[P.key] && !I[P.key].deleted && (V[P.key] = { previous: I[P.key].value }), I[P.key] = { version: P.version, deleted: !0 }, Ke(P, I[P.key]), J(V);
        } else
          s.debug(U.debugStreamDeleteIgnored(P.key));
    } });
  }
  function we() {
    O && (R.disconnect(), O = !1);
  }
  function Qt(S) {
    const T = {};
    if (!S)
      return Promise.resolve();
    for (const P in I)
      j.objectHasOwnProperty(I, P) && I[P] && (S[P] && !j.deepEquals(S[P].value, I[P].value) ? T[P] = { previous: I[P].value, current: he(S[P]) } : S[P] && !S[P].deleted || (T[P] = { previous: I[P].value }));
    for (const P in S)
      j.objectHasOwnProperty(S, P) && S[P] && (!I[P] || I[P].deleted) && (T[P] = { current: he(S[P]) });
    return I = { ...S }, Qe(), J(T).catch(() => {
    });
  }
  function J(S) {
    const T = Object.keys(S);
    if (T.length > 0) {
      const P = {};
      T.forEach((V) => {
        const Y = S[V].current, it = Y ? Y.value : void 0, X = S[V].previous;
        o.emit(Gr + ":" + V, it, X), P[V] = Y ? { current: it, previous: X } : { previous: X };
      }), o.emit(Gr, P), o.emit(ya, I), c.sendEventsOnlyForVariation || ft || T.forEach((V) => {
        Ge(V, S[V].current);
      });
    }
    return k && ne ? ne.saveFlags(I) : Promise.resolve();
  }
  function de() {
    const S = N || x && N === void 0;
    S && !O ? dr() : !S && O && we(), w && w.setStreaming(S);
  }
  function pe(S) {
    return S === Gr || S.substr(0, Gr.length + 1) === Gr + ":";
  }
  if (typeof c.bootstrap == "string" && c.bootstrap.toUpperCase() === "LOCALSTORAGE" && (ne ? k = !0 : s.warn(U.localStorageUnavailable())), typeof c.bootstrap == "object" && (I = function(S) {
    const T = Object.keys(S), P = "$flagsState", V = "$valid", Y = S[P];
    !Y && T.length && s.warn(U.bootstrapOldFormat()), S[V] === !1 && s.warn(U.bootstrapInvalid());
    const it = {};
    return T.forEach((X) => {
      if (X !== P && X !== V) {
        let gt = { value: S[X] };
        Y && Y[X] ? gt = j.extend(gt, Y[X]) : gt.version = 0, it[X] = gt;
      }
    }), it;
  }(c.bootstrap)), ft) {
    const S = ft.getInitialState();
    S ? zt(S) : ft.on("init", zt), ft.on("update", function(T) {
      T.context && ot.setContext(T.context), T.flags && Qt(T.flags);
    });
  } else
    (function() {
      return e ? He.processContext(t).then(Ve).then((S) => (ot.setContext(S), typeof c.bootstrap == "object" ? ie() : k ? ne.loadFlags().then((T) => T == null ? (I = {}, F.fetchFlagSettings(ot.getContext(), d).then((P) => Qt(P || {})).then(ie).catch((P) => {
        De(new _t.LDFlagFetchError(U.errorFetchingFlags(P)));
      })) : (I = T, j.onNextTick(ie), F.fetchFlagSettings(ot.getContext(), d).then((P) => Qt(P)).catch((P) => o.maybeReportError(P)))) : F.fetchFlagSettings(ot.getContext(), d).then((T) => {
        I = T || {}, Qe(), ie();
      }).catch((T) => {
        I = {}, De(T);
      }))) : Promise.reject(new _t.LDInvalidEnvironmentIdError(U.environmentNotSpecified()));
    })().catch(De);
  function zt(S) {
    l = S.environment, ot.setContext(S.context), I = { ...S.flags }, j.onNextTick(ie);
  }
  function ie() {
    s.info(U.clientInitialized()), H = !0, de(), a.signalSuccess();
  }
  function De(S) {
    a.signalFailure(S);
  }
  return { client: { waitForInitialization: () => a.getInitializationPromise(), waitUntilReady: () => a.getReadyPromise(), identify: function(S, T, P) {
    if (nt)
      return j.wrapPromiseCallback(Promise.resolve({}), P);
    if (ft)
      return s.warn(U.identifyDisabled()), j.wrapPromiseCallback(Promise.resolve(j.transformVersionedValuesToValues(I)), P);
    const V = k && ne ? ne.clearFlags() : Promise.resolve();
    return j.wrapPromiseCallback(V.then(() => He.processContext(S)).then(Ve).then((Y) => F.fetchFlagSettings(Y, T).then((it) => {
      const X = j.transformVersionedValuesToValues(it);
      return ot.setContext(Y), d = T, it ? Qt(it).then(() => X) : X;
    })).then((Y) => (O && dr(), Y)).catch((Y) => (o.maybeReportError(Y), Promise.reject(Y))), P);
  }, getContext: function() {
    return ot.getContext();
  }, variation: function(S, T) {
    return Te(S, T, !0, !1, !1).value;
  }, variationDetail: function(S, T) {
    return Te(S, T, !0, !0, !1);
  }, track: function(S, T, P) {
    if (typeof S != "string")
      return void o.maybeReportError(new _t.LDInvalidEventKeyError(U.unknownCustomEventKey(S)));
    n.customEventFilter && !n.customEventFilter(S) && s.warn(U.unknownCustomEventKey(S));
    const V = ot.getContext(), Y = { kind: "custom", key: S, context: V, url: n.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    V && V.anonymous && (Y.contextKind = V.anonymous ? "anonymousUser" : "user"), T != null && (Y.data = T), P != null && (Y.metricValue = P), be(Y);
  }, on: function(S, T, P) {
    pe(S) ? (x = !0, H && de(), o.on(S, T, P)) : o.on(...arguments);
  }, off: function(S) {
    if (o.off(...arguments), pe(S)) {
      let T = !1;
      o.getEvents().forEach((P) => {
        pe(P) && o.getEventListenerCount(P) > 0 && (T = !0);
      }), T || (x = !1, O && N === void 0 && we());
    }
  }, setStreaming: function(S) {
    const T = S === null ? void 0 : S;
    T !== N && (N = T, de());
  }, flush: function(S) {
    return j.wrapPromiseCallback(f ? A.flush() : Promise.resolve(), S);
  }, allFlags: function() {
    const S = {};
    if (!I)
      return S;
    for (const T in I)
      j.objectHasOwnProperty(I, T) && !I[T].deleted && (S[T] = Te(T, null, !c.sendEventsOnlyForVariation, !1, !0).value);
    return S;
  }, close: function(S) {
    if (nt)
      return j.wrapPromiseCallback(Promise.resolve(), S);
    const T = () => {
      nt = !0, I = {};
    }, P = Promise.resolve().then(() => {
      if (we(), w && w.stop(), f)
        return A.stop(), A.flush();
    }).then(T).catch(T);
    return j.wrapPromiseCallback(P, S);
  } }, options: c, emitter: o, ident: ot, logger: s, requestor: F, start: function() {
    f && (w && w.start(), A.start());
  }, enqueueEvent: be, getFlagsInternal: function() {
    return I;
  }, getEnvironmentId: () => l, internalChangeEventName: ya };
}, commonBasicLogger: va, errors: _t, messages: U, utils: j, getContextKeys: Bh }, Kh = gu.initialize, Qh = gu.errors;
function ga(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ma(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ga(Object(r), !0).forEach(function(n) {
      Gh(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ga(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gh(e, t, r) {
  return (t = function(n) {
    var i = function(s, o) {
      if (typeof s != "object" || s === null)
        return s;
      var a = s[Symbol.toPrimitive];
      if (a !== void 0) {
        var c = a.call(s, o || "default");
        if (typeof c != "object")
          return c;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(s);
    }(n, "string");
    return typeof i == "symbol" ? i : String(i);
  }(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var _a = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function Vh(e, t, r, n, i) {
  if (i && !function() {
    var u = window.navigator && window.navigator.userAgent;
    if (u) {
      var f = u.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (f)
        return parseInt(f[2], 10) < 73;
    }
    return !0;
  }())
    return _a;
  var s = new window.XMLHttpRequest();
  for (var o in s.open(e, t, !i), r || {})
    Object.prototype.hasOwnProperty.call(r, o) && s.setRequestHeader(o, r[o]);
  if (i)
    return s.send(n), _a;
  var a, c = new Promise(function(u, f) {
    s.addEventListener("load", function() {
      a || u({ status: s.status, header: function(l) {
        return s.getResponseHeader(l);
      }, body: s.responseText });
    }), s.addEventListener("error", function() {
      a || f(new Error());
    }), s.send(n);
  });
  return { promise: c, cancel: function() {
    a = !0, s.abort();
  } };
}
var fs = (e) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Yh(e, t, r, n) {
  var i, s, o = ((e.kind === "substring" || e.kind === "regex") && n.includes("/") ? t : t.replace(n, "")).replace(r, "");
  switch (e.kind) {
    case "exact":
      s = t, i = new RegExp("^" + fs(e.url) + "/?$");
      break;
    case "canonical":
      s = o, i = new RegExp("^" + fs(e.url) + "/?$");
      break;
    case "substring":
      s = o, i = new RegExp(".*" + fs(e.substring) + ".*$");
      break;
    case "regex":
      s = o, i = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return i.test(s);
}
function ba(e, t) {
  for (var r = {}, n = null, i = [], s = 0; s < e.length; s++)
    for (var o = e[s], a = o.urls || [], c = 0; c < a.length; c++)
      if (Yh(a[c], window.location.href, window.location.search, window.location.hash)) {
        o.kind === "pageview" ? t("pageview", o) : (i.push(o), t("click_pageview", o));
        break;
      }
  return i.length > 0 && (n = function(u) {
    for (var f = function(d, p) {
      for (var y = [], m = 0; m < p.length; m++)
        for (var _ = d.target, b = p[m], w = b.selector, R = document.querySelectorAll(w); _ && R.length > 0; ) {
          for (var A = 0; A < R.length; A++)
            _ === R[A] && y.push(b);
          _ = _.parentNode;
        }
      return y;
    }(u, i), l = 0; l < f.length; l++)
      t("click", f[l]);
  }, document.addEventListener("click", n)), r.dispose = function() {
    document.removeEventListener("click", n);
  }, r;
}
var Wh = 300;
function Jh(e, t) {
  var r, n;
  function i() {
    n && n.dispose(), r && r.length && (n = ba(r, s));
  }
  function s(o, a) {
    var c = e.ident.getContext(), u = { kind: o, key: a.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: c };
    return o === "click" && (u.selector = a.selector), e.enqueueEvent(u);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(o) {
    o && o.length > 0 && (n = ba(r = o, s), function(a, c) {
      var u, f = window.location.href;
      function l() {
        (u = window.location.href) !== f && (f = u, c());
      }
      (function d(p, y) {
        p(), setTimeout(function() {
          d(p, y);
        }, y);
      })(l, a), window.history && window.history.pushState ? window.addEventListener("popstate", l) : window.addEventListener("hashchange", l);
    }(Wh, i)), t();
  }).catch(function(o) {
    e.emitter.maybeReportError(new Qh.LDUnexpectedResponseError((o && o.message, o.message))), t();
  }), {};
}
var Gn = "goalsReady", Xh = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function Zh(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = function(f) {
    var l, d = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var p = f && f.disableSyncEventPost;
      d.httpRequest = function(b, w, R, A) {
        var F = d.synchronousFlush & !p;
        return d.synchronousFlush = !1, Vh(b, w, R, A, F);
      };
    }
    d.httpAllowsPost = function() {
      return l === void 0 && (l = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), l;
    }, d.httpFallbackPing = function(b) {
      new window.Image().src = b;
    };
    var y, m = f && f.eventUrlTransformer;
    d.getCurrentUrl = function() {
      return m ? m(window.location.href) : window.location.href;
    }, d.isDoNotTrack = function() {
      var b;
      return (b = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || b === !0 || b === "1" || b === "yes";
    };
    try {
      window.localStorage && (d.localStorage = { get: function(b) {
        return new Promise(function(w) {
          w(window.localStorage.getItem(b));
        });
      }, set: function(b, w) {
        return new Promise(function(R) {
          window.localStorage.setItem(b, w), R();
        });
      }, clear: function(b) {
        return new Promise(function(w) {
          window.localStorage.removeItem(b), w();
        });
      } });
    } catch {
      d.localStorage = null;
    }
    if (f && f.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (d.eventSourceAllowsReport = !0, y = window.EventSourcePolyfill) : (d.eventSourceAllowsReport = !1, y = window.EventSource), window.EventSource) {
      var _ = 3e5;
      d.eventSourceFactory = function(b, w) {
        var R = ma(ma({}, { heartbeatTimeout: _, silentTimeout: _, skipDefaultHeaders: !0 }), w);
        return new y(b, R);
      }, d.eventSourceIsActive = function(b) {
        return b.readyState === window.EventSource.OPEN || b.readyState === window.EventSource.CONNECTING;
      };
    }
    return d.userAgent = "JSClient", d.version = "3.1.3", d.diagnosticSdkData = { name: "js-client-sdk", version: "3.1.3" }, d.diagnosticPlatformData = { name: "JS" }, d.diagnosticUseCombinedEvent = !0, d;
  }(r), i = Kh(e, t, r, n, Xh), s = i.client, o = i.options, a = i.emitter, c = new Promise(function(f) {
    var l = a.on(Gn, function() {
      a.off(Gn, l), f();
    });
  });
  s.waitUntilGoalsReady = function() {
    return c;
  }, o.fetchGoals ? Jh(i, function() {
    return a.emit(Gn);
  }) : a.emit(Gn), document.readyState !== "complete" ? window.addEventListener("load", i.start) : i.start();
  var u = function() {
    n.synchronousFlush = !0, s.flush().catch(function() {
    }), n.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && u();
  }), window.addEventListener("pagehide", u), s;
}
const td = (e, t) => (e = e == null ? void 0 : e.toLowerCase(), t ? (t = t == null ? void 0 : t.toLowerCase(), {
  kind: "user",
  key: `${e}_${t}`,
  name: `${e} (Hub ${t})`,
  email: e,
  HubName: t
}) : {
  kind: "user",
  key: e,
  name: e,
  email: e
}), ed = ({ clientSideId: e, userEmail: t, hubName: r }) => {
  const n = Ga(null);
  oi(() => {
    if (!(t && e))
      return;
    const c = td(t, r), u = Zh(e, c);
    return n.current = u, () => {
      (async () => {
        await u.close();
      })();
    };
  }, [e, r, t]), oi(() => {
    const c = async () => {
      var u;
      await ((u = n.current) == null ? void 0 : u.close());
    };
    return window.addEventListener("beforeunload", c), () => {
      window.removeEventListener("beforeunload", c);
    };
  }, []);
  const {
    data: i,
    error: s,
    refetch: o,
    status: a
  } = fu(
    ["LDK.waitForInitialization", e, t, r],
    async () => n.current ? (await n.current.waitForInitialization(), !0) : !1,
    {
      enabled: !!e && !!t,
      context: $s
    }
  );
  return {
    client: n.current,
    error: s,
    status: a,
    isInitialized: i === !0,
    retry: async () => {
      await o();
    }
  };
}, mu = (e, t) => t ?? !1, ri = Dr.createContext({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  checkFlag: mu
}), Yp = lu(
  ({
    clientSideId: e,
    userEmail: t,
    hubName: r,
    loadingComponent: n,
    errorComponent: i,
    children: s
  }) => {
    const { client: o, error: a, status: c, isInitialized: u, retry: f } = ed({
      clientSideId: e,
      userEmail: t,
      hubName: r
    }), l = Ar(
      () => ({
        isInitialized: u,
        isLoading: c === "loading",
        error: a ?? void 0,
        retry: f,
        checkFlag: u && o ? (d, p) => o.variation(d, p) ?? !1 : mu
      }),
      [o, a, u, f, c]
    );
    return c === "loading" && n ? /* @__PURE__ */ ut.jsx(ri.Provider, { value: l, children: n }) : c === "error" && i ? /* @__PURE__ */ ut.jsx(ri.Provider, { value: l, children: i }) : /* @__PURE__ */ ut.jsx(ri.Provider, { value: l, children: s });
  },
  "LaunchDarklyProvider"
);
function Wp() {
  const { isInitialized: e, isLoading: t, error: r, retry: n, checkFlag: i } = dn(ri), s = ae(
    (o, a) => i(o, a),
    [i]
  );
  return {
    isInitialized: e,
    isLoading: t,
    error: r,
    retry: n,
    hasFeature: s
  };
}
var vn = "delete", lt = 5, Xt = 1 << lt, kt = Xt - 1, W = {};
function Is() {
  return { value: !1 };
}
function Zt(e) {
  e && (e.value = !0);
}
function Qs() {
}
function Sr(e) {
  return e.size === void 0 && (e.size = e.__iterate(_u)), e.size;
}
function $e(e, t) {
  if (typeof t != "number") {
    var r = t >>> 0;
    if ("" + r !== t || r === 4294967295)
      return NaN;
    t = r;
  }
  return t < 0 ? Sr(e) + t : t;
}
function _u() {
  return !0;
}
function Oi(e, t, r) {
  return (e === 0 && !wu(e) || r !== void 0 && e <= -r) && (t === void 0 || r !== void 0 && t >= r);
}
function yn(e, t) {
  return bu(e, t, 0);
}
function Ii(e, t) {
  return bu(e, t, t);
}
function bu(e, t, r) {
  return e === void 0 ? r : wu(e) ? t === 1 / 0 ? t : Math.max(0, t + e) | 0 : t === void 0 || t === e ? e : Math.min(t, e) | 0;
}
function wu(e) {
  return e < 0 || e === 0 && 1 / e === -1 / 0;
}
var Eu = "@@__IMMUTABLE_ITERABLE__@@";
function jt(e) {
  return !!(e && e[Eu]);
}
var Su = "@@__IMMUTABLE_KEYED__@@";
function dt(e) {
  return !!(e && e[Su]);
}
var Ou = "@@__IMMUTABLE_INDEXED__@@";
function Ut(e) {
  return !!(e && e[Ou]);
}
function Ci(e) {
  return dt(e) || Ut(e);
}
var mt = function(t) {
  return jt(t) ? t : Kt(t);
}, re = /* @__PURE__ */ function(e) {
  function t(r) {
    return dt(r) ? r : Be(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
}(mt), fr = /* @__PURE__ */ function(e) {
  function t(r) {
    return Ut(r) ? r : le(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
}(mt), xr = /* @__PURE__ */ function(e) {
  function t(r) {
    return jt(r) && !Ci(r) ? r : Nr(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
}(mt);
mt.Keyed = re;
mt.Indexed = fr;
mt.Set = xr;
var Iu = "@@__IMMUTABLE_SEQ__@@";
function Gs(e) {
  return !!(e && e[Iu]);
}
var Cu = "@@__IMMUTABLE_RECORD__@@";
function kr(e) {
  return !!(e && e[Cu]);
}
function me(e) {
  return jt(e) || kr(e);
}
var Fr = "@@__IMMUTABLE_ORDERED__@@";
function ce(e) {
  return !!(e && e[Fr]);
}
var gn = 0, fe = 1, ee = 2, Cs = typeof Symbol == "function" && Symbol.iterator, Pu = "@@iterator", Pi = Cs || Pu, Z = function(t) {
  this.next = t;
};
Z.prototype.toString = function() {
  return "[Iterator]";
};
Z.KEYS = gn;
Z.VALUES = fe;
Z.ENTRIES = ee;
Z.prototype.inspect = Z.prototype.toSource = function() {
  return this.toString();
};
Z.prototype[Pi] = function() {
  return this;
};
function pt(e, t, r, n) {
  var i = e === 0 ? t : e === 1 ? r : [t, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}
function $t() {
  return { value: void 0, done: !0 };
}
function Ru(e) {
  return Array.isArray(e) ? !0 : !!Ri(e);
}
function wa(e) {
  return e && typeof e.next == "function";
}
function Ps(e) {
  var t = Ri(e);
  return t && t.call(e);
}
function Ri(e) {
  var t = e && (Cs && e[Cs] || e[Pu]);
  if (typeof t == "function")
    return t;
}
function rd(e) {
  var t = Ri(e);
  return t && t === e.entries;
}
function nd(e) {
  var t = Ri(e);
  return t && t === e.keys;
}
var Lr = Object.prototype.hasOwnProperty;
function Tu(e) {
  return Array.isArray(e) || typeof e == "string" ? !0 : e && typeof e == "object" && Number.isInteger(e.length) && e.length >= 0 && (e.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(e).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    e.hasOwnProperty(e.length - 1)
  ));
}
var Kt = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? Ys() : me(r) ? r.toSeq() : sd(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, t.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, t.prototype.__iterate = function(n, i) {
    var s = this._cache;
    if (s) {
      for (var o = s.length, a = 0; a !== o; ) {
        var c = s[i ? o - ++a : a++];
        if (n(c[1], c[0], this) === !1)
          break;
      }
      return a;
    }
    return this.__iterateUncached(n, i);
  }, t.prototype.__iterator = function(n, i) {
    var s = this._cache;
    if (s) {
      var o = s.length, a = 0;
      return new Z(function() {
        if (a === o)
          return $t();
        var c = s[i ? o - ++a : a++];
        return pt(n, c[0], c[1]);
      });
    }
    return this.__iteratorUncached(n, i);
  }, t;
}(mt), Be = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? Ys().toKeyedSeq() : jt(r) ? dt(r) ? r.toSeq() : r.fromEntrySeq() : kr(r) ? r.toSeq() : Ws(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function() {
    return this;
  }, t;
}(Kt), le = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? Ys() : jt(r) ? dt(r) ? r.entrySeq() : r.toIndexedSeq() : kr(r) ? r.toSeq().entrySeq() : Du(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toIndexedSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, t;
}(Kt), Nr = /* @__PURE__ */ function(e) {
  function t(r) {
    return (jt(r) && !Ci(r) ? r : le(r)).toSetSeq();
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toSetSeq = function() {
    return this;
  }, t;
}(Kt);
Kt.isSeq = Gs;
Kt.Keyed = Be;
Kt.Set = Nr;
Kt.Indexed = le;
Kt.prototype[Iu] = !0;
var ur = /* @__PURE__ */ function(e) {
  function t(r) {
    this._array = r, this.size = r.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, i) {
    return this.has(n) ? this._array[$e(this, n)] : i;
  }, t.prototype.__iterate = function(n, i) {
    for (var s = this._array, o = s.length, a = 0; a !== o; ) {
      var c = i ? o - ++a : a++;
      if (n(s[c], c, this) === !1)
        break;
    }
    return a;
  }, t.prototype.__iterator = function(n, i) {
    var s = this._array, o = s.length, a = 0;
    return new Z(function() {
      if (a === o)
        return $t();
      var c = i ? o - ++a : a++;
      return pt(n, c, s[c]);
    });
  }, t;
}(le), Vs = /* @__PURE__ */ function(e) {
  function t(r) {
    var n = Object.keys(r).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r) : []
    );
    this._object = r, this._keys = n, this.size = n.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, i) {
    return i !== void 0 && !this.has(n) ? i : this._object[n];
  }, t.prototype.has = function(n) {
    return Lr.call(this._object, n);
  }, t.prototype.__iterate = function(n, i) {
    for (var s = this._object, o = this._keys, a = o.length, c = 0; c !== a; ) {
      var u = o[i ? a - ++c : c++];
      if (n(s[u], u, this) === !1)
        break;
    }
    return c;
  }, t.prototype.__iterator = function(n, i) {
    var s = this._object, o = this._keys, a = o.length, c = 0;
    return new Z(function() {
      if (c === a)
        return $t();
      var u = o[i ? a - ++c : c++];
      return pt(n, u, s[u]);
    });
  }, t;
}(Be);
Vs.prototype[Fr] = !0;
var id = /* @__PURE__ */ function(e) {
  function t(r) {
    this._collection = r, this.size = r.length || r.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function(n, i) {
    if (i)
      return this.cacheResult().__iterate(n, i);
    var s = this._collection, o = Ps(s), a = 0;
    if (wa(o))
      for (var c; !(c = o.next()).done && n(c.value, a++, this) !== !1; )
        ;
    return a;
  }, t.prototype.__iteratorUncached = function(n, i) {
    if (i)
      return this.cacheResult().__iterator(n, i);
    var s = this._collection, o = Ps(s);
    if (!wa(o))
      return new Z($t);
    var a = 0;
    return new Z(function() {
      var c = o.next();
      return c.done ? c : pt(n, a++, c.value);
    });
  }, t;
}(le), Ea;
function Ys() {
  return Ea || (Ea = new ur([]));
}
function Ws(e) {
  var t = Js(e);
  if (t)
    return t.fromEntrySeq();
  if (typeof e == "object")
    return new Vs(e);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + e
  );
}
function Du(e) {
  var t = Js(e);
  if (t)
    return t;
  throw new TypeError(
    "Expected Array or collection object of values: " + e
  );
}
function sd(e) {
  var t = Js(e);
  if (t)
    return rd(e) ? t.fromEntrySeq() : nd(e) ? t.toSetSeq() : t;
  if (typeof e == "object")
    return new Vs(e);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + e
  );
}
function Js(e) {
  return Tu(e) ? new ur(e) : Ru(e) ? new id(e) : void 0;
}
var Au = "@@__IMMUTABLE_MAP__@@";
function Xs(e) {
  return !!(e && e[Au]);
}
function xu(e) {
  return Xs(e) && ce(e);
}
function Sa(e) {
  return !!(e && typeof e.equals == "function" && typeof e.hashCode == "function");
}
function Ht(e, t) {
  if (e === t || e !== e && t !== t)
    return !0;
  if (!e || !t)
    return !1;
  if (typeof e.valueOf == "function" && typeof t.valueOf == "function") {
    if (e = e.valueOf(), t = t.valueOf(), e === t || e !== e && t !== t)
      return !0;
    if (!e || !t)
      return !1;
  }
  return !!(Sa(e) && Sa(t) && e.equals(t));
}
var Vr = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(t, r) {
  t |= 0, r |= 0;
  var n = t & 65535, i = r & 65535;
  return n * i + ((t >>> 16) * i + n * (r >>> 16) << 16 >>> 0) | 0;
};
function Ti(e) {
  return e >>> 1 & 1073741824 | e & 3221225471;
}
var od = Object.prototype.valueOf;
function Bt(e) {
  if (e == null)
    return Oa(e);
  if (typeof e.hashCode == "function")
    return Ti(e.hashCode(e));
  var t = hd(e);
  if (t == null)
    return Oa(t);
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;
    case "number":
      return ad(t);
    case "string":
      return t.length > dd ? ud(t) : Rs(t);
    case "object":
    case "function":
      return fd(t);
    case "symbol":
      return cd(t);
    default:
      if (typeof t.toString == "function")
        return Rs(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}
function Oa(e) {
  return e === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function ad(e) {
  if (e !== e || e === 1 / 0)
    return 0;
  var t = e | 0;
  for (t !== e && (t ^= e * 4294967295); e > 4294967295; )
    e /= 4294967295, t ^= e;
  return Ti(t);
}
function ud(e) {
  var t = ds[e];
  return t === void 0 && (t = Rs(e), hs === pd && (hs = 0, ds = {}), hs++, ds[e] = t), t;
}
function Rs(e) {
  for (var t = 0, r = 0; r < e.length; r++)
    t = 31 * t + e.charCodeAt(r) | 0;
  return Ti(t);
}
function cd(e) {
  var t = Pa[e];
  return t !== void 0 || (t = ku(), Pa[e] = t), t;
}
function fd(e) {
  var t;
  if (Ts && (t = Ds.get(e), t !== void 0) || (t = e[ir], t !== void 0) || !Ca && (t = e.propertyIsEnumerable && e.propertyIsEnumerable[ir], t !== void 0 || (t = ld(e), t !== void 0)))
    return t;
  if (t = ku(), Ts)
    Ds.set(e, t);
  else {
    if (Ia !== void 0 && Ia(e) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (Ca)
      Object.defineProperty(e, ir, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: t
      });
    else if (e.propertyIsEnumerable !== void 0 && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable)
      e.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, e.propertyIsEnumerable[ir] = t;
    else if (e.nodeType !== void 0)
      e[ir] = t;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return t;
}
var Ia = Object.isExtensible, Ca = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function ld(e) {
  if (e && e.nodeType > 0)
    switch (e.nodeType) {
      case 1:
        return e.uniqueID;
      case 9:
        return e.documentElement && e.documentElement.uniqueID;
    }
}
function hd(e) {
  return e.valueOf !== od && typeof e.valueOf == "function" ? e.valueOf(e) : e;
}
function ku() {
  var e = ++ls;
  return ls & 1073741824 && (ls = 0), e;
}
var Ts = typeof WeakMap == "function", Ds;
Ts && (Ds = /* @__PURE__ */ new WeakMap());
var Pa = /* @__PURE__ */ Object.create(null), ls = 0, ir = "__immutablehash__";
typeof Symbol == "function" && (ir = Symbol(ir));
var dd = 16, pd = 255, hs = 0, ds = {}, Di = /* @__PURE__ */ function(e) {
  function t(r, n) {
    this._iter = r, this._useKeys = n, this.size = r.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, i) {
    return this._iter.get(n, i);
  }, t.prototype.has = function(n) {
    return this._iter.has(n);
  }, t.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, t.prototype.reverse = function() {
    var n = this, i = Zs(this, !0);
    return this._useKeys || (i.valueSeq = function() {
      return n._iter.toSeq().reverse();
    }), i;
  }, t.prototype.map = function(n, i) {
    var s = this, o = qu(this, n, i);
    return this._useKeys || (o.valueSeq = function() {
      return s._iter.toSeq().map(n, i);
    }), o;
  }, t.prototype.__iterate = function(n, i) {
    var s = this;
    return this._iter.__iterate(function(o, a) {
      return n(o, a, s);
    }, i);
  }, t.prototype.__iterator = function(n, i) {
    return this._iter.__iterator(n, i);
  }, t;
}(Be);
Di.prototype[Fr] = !0;
var Fu = /* @__PURE__ */ function(e) {
  function t(r) {
    this._iter = r, this.size = r.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.includes = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, i) {
    var s = this, o = 0;
    return i && Sr(this), this._iter.__iterate(
      function(a) {
        return n(a, i ? s.size - ++o : o++, s);
      },
      i
    );
  }, t.prototype.__iterator = function(n, i) {
    var s = this, o = this._iter.__iterator(fe, i), a = 0;
    return i && Sr(this), new Z(function() {
      var c = o.next();
      return c.done ? c : pt(
        n,
        i ? s.size - ++a : a++,
        c.value,
        c
      );
    });
  }, t;
}(le), Lu = /* @__PURE__ */ function(e) {
  function t(r) {
    this._iter = r, this.size = r.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.has = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, i) {
    var s = this;
    return this._iter.__iterate(function(o) {
      return n(o, o, s);
    }, i);
  }, t.prototype.__iterator = function(n, i) {
    var s = this._iter.__iterator(fe, i);
    return new Z(function() {
      var o = s.next();
      return o.done ? o : pt(n, o.value, o.value, o);
    });
  }, t;
}(Nr), Nu = /* @__PURE__ */ function(e) {
  function t(r) {
    this._iter = r, this.size = r.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, t.prototype.__iterate = function(n, i) {
    var s = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        Ta(o);
        var a = jt(o);
        return n(
          a ? o.get(1) : o[1],
          a ? o.get(0) : o[0],
          s
        );
      }
    }, i);
  }, t.prototype.__iterator = function(n, i) {
    var s = this._iter.__iterator(fe, i);
    return new Z(function() {
      for (; ; ) {
        var o = s.next();
        if (o.done)
          return o;
        var a = o.value;
        if (a) {
          Ta(a);
          var c = jt(a);
          return pt(
            n,
            c ? a.get(0) : a[0],
            c ? a.get(1) : a[1],
            o
          );
        }
      }
    });
  }, t;
}(Be);
Fu.prototype.cacheResult = Di.prototype.cacheResult = Lu.prototype.cacheResult = Nu.prototype.cacheResult = ro;
function Mu(e) {
  var t = _e(e);
  return t._iter = e, t.size = e.size, t.flip = function() {
    return e;
  }, t.reverse = function() {
    var r = e.reverse.apply(this);
    return r.flip = function() {
      return e.reverse();
    }, r;
  }, t.has = function(r) {
    return e.includes(r);
  }, t.includes = function(r) {
    return e.has(r);
  }, t.cacheResult = ro, t.__iterateUncached = function(r, n) {
    var i = this;
    return e.__iterate(function(s, o) {
      return r(o, s, i) !== !1;
    }, n);
  }, t.__iteratorUncached = function(r, n) {
    if (r === ee) {
      var i = e.__iterator(r, n);
      return new Z(function() {
        var s = i.next();
        if (!s.done) {
          var o = s.value[0];
          s.value[0] = s.value[1], s.value[1] = o;
        }
        return s;
      });
    }
    return e.__iterator(
      r === fe ? gn : fe,
      n
    );
  }, t;
}
function qu(e, t, r) {
  var n = _e(e);
  return n.size = e.size, n.has = function(i) {
    return e.has(i);
  }, n.get = function(i, s) {
    var o = e.get(i, W);
    return o === W ? s : t.call(r, o, i, e);
  }, n.__iterateUncached = function(i, s) {
    var o = this;
    return e.__iterate(
      function(a, c, u) {
        return i(t.call(r, a, c, u), c, o) !== !1;
      },
      s
    );
  }, n.__iteratorUncached = function(i, s) {
    var o = e.__iterator(ee, s);
    return new Z(function() {
      var a = o.next();
      if (a.done)
        return a;
      var c = a.value, u = c[0];
      return pt(
        i,
        u,
        t.call(r, c[1], u, e),
        a
      );
    });
  }, n;
}
function Zs(e, t) {
  var r = this, n = _e(e);
  return n._iter = e, n.size = e.size, n.reverse = function() {
    return e;
  }, e.flip && (n.flip = function() {
    var i = Mu(e);
    return i.reverse = function() {
      return e.flip();
    }, i;
  }), n.get = function(i, s) {
    return e.get(t ? i : -1 - i, s);
  }, n.has = function(i) {
    return e.has(t ? i : -1 - i);
  }, n.includes = function(i) {
    return e.includes(i);
  }, n.cacheResult = ro, n.__iterate = function(i, s) {
    var o = this, a = 0;
    return s && Sr(e), e.__iterate(
      function(c, u) {
        return i(c, t ? u : s ? o.size - ++a : a++, o);
      },
      !s
    );
  }, n.__iterator = function(i, s) {
    var o = 0;
    s && Sr(e);
    var a = e.__iterator(ee, !s);
    return new Z(function() {
      var c = a.next();
      if (c.done)
        return c;
      var u = c.value;
      return pt(
        i,
        t ? u[0] : s ? r.size - ++o : o++,
        u[1],
        c
      );
    });
  }, n;
}
function Uu(e, t, r, n) {
  var i = _e(e);
  return n && (i.has = function(s) {
    var o = e.get(s, W);
    return o !== W && !!t.call(r, o, s, e);
  }, i.get = function(s, o) {
    var a = e.get(s, W);
    return a !== W && t.call(r, a, s, e) ? a : o;
  }), i.__iterateUncached = function(s, o) {
    var a = this, c = 0;
    return e.__iterate(function(u, f, l) {
      if (t.call(r, u, f, l))
        return c++, s(u, n ? f : c - 1, a);
    }, o), c;
  }, i.__iteratorUncached = function(s, o) {
    var a = e.__iterator(ee, o), c = 0;
    return new Z(function() {
      for (; ; ) {
        var u = a.next();
        if (u.done)
          return u;
        var f = u.value, l = f[0], d = f[1];
        if (t.call(r, d, l, e))
          return pt(s, n ? l : c++, d, u);
      }
    });
  }, i;
}
function vd(e, t, r) {
  var n = qr().asMutable();
  return e.__iterate(function(i, s) {
    n.update(t.call(r, i, s, e), 0, function(o) {
      return o + 1;
    });
  }), n.asImmutable();
}
function yd(e, t, r) {
  var n = dt(e), i = (ce(e) ? Re() : qr()).asMutable();
  e.__iterate(function(o, a) {
    i.update(
      t.call(r, o, a, e),
      function(c) {
        return c = c || [], c.push(n ? [a, o] : o), c;
      }
    );
  });
  var s = eo(e);
  return i.map(function(o) {
    return st(e, s(o));
  }).asImmutable();
}
function gd(e, t, r) {
  var n = dt(e), i = [[], []];
  e.__iterate(function(o, a) {
    i[t.call(r, o, a, e) ? 1 : 0].push(
      n ? [a, o] : o
    );
  });
  var s = eo(e);
  return i.map(function(o) {
    return st(e, s(o));
  });
}
function to(e, t, r, n) {
  var i = e.size;
  if (Oi(t, r, i))
    return e;
  var s = yn(t, i), o = Ii(r, i);
  if (s !== s || o !== o)
    return to(e.toSeq().cacheResult(), t, r, n);
  var a = o - s, c;
  a === a && (c = a < 0 ? 0 : a);
  var u = _e(e);
  return u.size = c === 0 ? c : e.size && c || void 0, !n && Gs(e) && c >= 0 && (u.get = function(f, l) {
    return f = $e(this, f), f >= 0 && f < c ? e.get(f + s, l) : l;
  }), u.__iterateUncached = function(f, l) {
    var d = this;
    if (c === 0)
      return 0;
    if (l)
      return this.cacheResult().__iterate(f, l);
    var p = 0, y = !0, m = 0;
    return e.__iterate(function(_, b) {
      if (!(y && (y = p++ < s)))
        return m++, f(_, n ? b : m - 1, d) !== !1 && m !== c;
    }), m;
  }, u.__iteratorUncached = function(f, l) {
    if (c !== 0 && l)
      return this.cacheResult().__iterator(f, l);
    if (c === 0)
      return new Z($t);
    var d = e.__iterator(f, l), p = 0, y = 0;
    return new Z(function() {
      for (; p++ < s; )
        d.next();
      if (++y > c)
        return $t();
      var m = d.next();
      return n || f === fe || m.done ? m : f === gn ? pt(f, y - 1, void 0, m) : pt(f, y - 1, m.value[1], m);
    });
  }, u;
}
function md(e, t, r) {
  var n = _e(e);
  return n.__iterateUncached = function(i, s) {
    var o = this;
    if (s)
      return this.cacheResult().__iterate(i, s);
    var a = 0;
    return e.__iterate(
      function(c, u, f) {
        return t.call(r, c, u, f) && ++a && i(c, u, o);
      }
    ), a;
  }, n.__iteratorUncached = function(i, s) {
    var o = this;
    if (s)
      return this.cacheResult().__iterator(i, s);
    var a = e.__iterator(ee, s), c = !0;
    return new Z(function() {
      if (!c)
        return $t();
      var u = a.next();
      if (u.done)
        return u;
      var f = u.value, l = f[0], d = f[1];
      return t.call(r, d, l, o) ? i === ee ? u : pt(i, l, d, u) : (c = !1, $t());
    });
  }, n;
}
function ju(e, t, r, n) {
  var i = _e(e);
  return i.__iterateUncached = function(s, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterate(s, o);
    var c = !0, u = 0;
    return e.__iterate(function(f, l, d) {
      if (!(c && (c = t.call(r, f, l, d))))
        return u++, s(f, n ? l : u - 1, a);
    }), u;
  }, i.__iteratorUncached = function(s, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterator(s, o);
    var c = e.__iterator(ee, o), u = !0, f = 0;
    return new Z(function() {
      var l, d, p;
      do {
        if (l = c.next(), l.done)
          return n || s === fe ? l : s === gn ? pt(s, f++, void 0, l) : pt(s, f++, l.value[1], l);
        var y = l.value;
        d = y[0], p = y[1], u && (u = t.call(r, p, d, a));
      } while (u);
      return s === ee ? l : pt(s, d, p, l);
    });
  }, i;
}
function _d(e, t) {
  var r = dt(e), n = [e].concat(t).map(function(o) {
    return jt(o) ? r && (o = re(o)) : o = r ? Ws(o) : Du(Array.isArray(o) ? o : [o]), o;
  }).filter(function(o) {
    return o.size !== 0;
  });
  if (n.length === 0)
    return e;
  if (n.length === 1) {
    var i = n[0];
    if (i === e || r && dt(i) || Ut(e) && Ut(i))
      return i;
  }
  var s = new ur(n);
  return r ? s = s.toKeyedSeq() : Ut(e) || (s = s.toSetSeq()), s = s.flatten(!0), s.size = n.reduce(function(o, a) {
    if (o !== void 0) {
      var c = a.size;
      if (c !== void 0)
        return o + c;
    }
  }, 0), s;
}
function $u(e, t, r) {
  var n = _e(e);
  return n.__iterateUncached = function(i, s) {
    if (s)
      return this.cacheResult().__iterate(i, s);
    var o = 0, a = !1;
    function c(u, f) {
      u.__iterate(function(l, d) {
        return (!t || f < t) && jt(l) ? c(l, f + 1) : (o++, i(l, r ? d : o - 1, n) === !1 && (a = !0)), !a;
      }, s);
    }
    return c(e, 0), o;
  }, n.__iteratorUncached = function(i, s) {
    if (s)
      return this.cacheResult().__iterator(i, s);
    var o = e.__iterator(i, s), a = [], c = 0;
    return new Z(function() {
      for (; o; ) {
        var u = o.next();
        if (u.done !== !1) {
          o = a.pop();
          continue;
        }
        var f = u.value;
        if (i === ee && (f = f[1]), (!t || a.length < t) && jt(f))
          a.push(o), o = f.__iterator(i, s);
        else
          return r ? u : pt(i, c++, f, u);
      }
      return $t();
    });
  }, n;
}
function bd(e, t, r) {
  var n = eo(e);
  return e.toSeq().map(function(i, s) {
    return n(t.call(r, i, s, e));
  }).flatten(!0);
}
function wd(e, t) {
  var r = _e(e);
  return r.size = e.size && e.size * 2 - 1, r.__iterateUncached = function(n, i) {
    var s = this, o = 0;
    return e.__iterate(
      function(a) {
        return (!o || n(t, o++, s) !== !1) && n(a, o++, s) !== !1;
      },
      i
    ), o;
  }, r.__iteratorUncached = function(n, i) {
    var s = e.__iterator(fe, i), o = 0, a;
    return new Z(function() {
      return (!a || o % 2) && (a = s.next(), a.done) ? a : o % 2 ? pt(n, o++, t) : pt(n, o++, a.value, a);
    });
  }, r;
}
function Or(e, t, r) {
  t || (t = zu);
  var n = dt(e), i = 0, s = e.toSeq().map(function(o, a) {
    return [a, o, i++, r ? r(o, a, e) : o];
  }).valueSeq().toArray();
  return s.sort(function(o, a) {
    return t(o[3], a[3]) || o[2] - a[2];
  }).forEach(
    n ? function(o, a) {
      s[a].length = 2;
    } : function(o, a) {
      s[a] = o[1];
    }
  ), n ? Be(s) : Ut(e) ? le(s) : Nr(s);
}
function Vn(e, t, r) {
  if (t || (t = zu), r) {
    var n = e.toSeq().map(function(i, s) {
      return [i, r(i, s, e)];
    }).reduce(function(i, s) {
      return Ra(t, i[1], s[1]) ? s : i;
    });
    return n && n[0];
  }
  return e.reduce(function(i, s) {
    return Ra(t, i, s) ? s : i;
  });
}
function Ra(e, t, r) {
  var n = e(r, t);
  return n === 0 && r !== t && (r == null || r !== r) || n > 0;
}
function Yn(e, t, r, n) {
  var i = _e(e), s = new ur(r).map(function(o) {
    return o.size;
  });
  return i.size = n ? s.max() : s.min(), i.__iterate = function(o, a) {
    for (var c = this.__iterator(fe, a), u, f = 0; !(u = c.next()).done && o(u.value, f++, this) !== !1; )
      ;
    return f;
  }, i.__iteratorUncached = function(o, a) {
    var c = r.map(
      function(l) {
        return l = mt(l), Ps(a ? l.reverse() : l);
      }
    ), u = 0, f = !1;
    return new Z(function() {
      var l;
      return f || (l = c.map(function(d) {
        return d.next();
      }), f = n ? l.every(function(d) {
        return d.done;
      }) : l.some(function(d) {
        return d.done;
      })), f ? $t() : pt(
        o,
        u++,
        t.apply(
          null,
          l.map(function(d) {
            return d.value;
          })
        )
      );
    });
  }, i;
}
function st(e, t) {
  return e === t ? e : Gs(e) ? t : e.constructor(t);
}
function Ta(e) {
  if (e !== Object(e))
    throw new TypeError("Expected [K, V] tuple: " + e);
}
function eo(e) {
  return dt(e) ? re : Ut(e) ? fr : xr;
}
function _e(e) {
  return Object.create(
    (dt(e) ? Be : Ut(e) ? le : Nr).prototype
  );
}
function ro() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Kt.prototype.cacheResult.call(this);
}
function zu(e, t) {
  return e === void 0 && t === void 0 ? 0 : e === void 0 ? 1 : t === void 0 ? -1 : e > t ? 1 : e < t ? -1 : 0;
}
function ge(e, t) {
  t = t || 0;
  for (var r = Math.max(0, e.length - t), n = new Array(r), i = 0; i < r; i++)
    n[i] = e[i + t];
  return n;
}
function no(e, t) {
  if (!e)
    throw new Error(t);
}
function te(e) {
  no(
    e !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function Bu(e) {
  if (Tu(e) && typeof e != "string")
    return e;
  if (ce(e))
    return e.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + e
  );
}
var Ed = Object.prototype.toString;
function Sd(e) {
  if (!e || typeof e != "object" || Ed.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t, n = Object.getPrototypeOf(t); n !== null; )
    r = n, n = Object.getPrototypeOf(r);
  return r === t;
}
function ze(e) {
  return typeof e == "object" && (me(e) || Array.isArray(e) || Sd(e));
}
function on(e) {
  try {
    return typeof e == "string" ? JSON.stringify(e) : String(e);
  } catch {
    return JSON.stringify(e);
  }
}
function Od(e, t) {
  return me(e) ? e.has(t) : ze(e) && Lr.call(e, t);
}
function Hu(e, t, r) {
  return me(e) ? e.get(t, r) : Od(e, t) ? typeof e.get == "function" ? e.get(t) : e[t] : r;
}
function pi(e) {
  if (Array.isArray(e))
    return ge(e);
  var t = {};
  for (var r in e)
    Lr.call(e, r) && (t[r] = e[r]);
  return t;
}
function Id(e, t) {
  if (!ze(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (me(e)) {
    if (!e.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + e
      );
    return e.remove(t);
  }
  if (!Lr.call(e, t))
    return e;
  var r = pi(e);
  return Array.isArray(r) ? r.splice(t, 1) : delete r[t], r;
}
function Cd(e, t, r) {
  if (!ze(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (me(e)) {
    if (!e.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + e
      );
    return e.set(t, r);
  }
  if (Lr.call(e, t) && r === e[t])
    return e;
  var n = pi(e);
  return n[t] = r, n;
}
function Mr(e, t, r, n) {
  n || (n = r, r = void 0);
  var i = Ku(
    me(e),
    e,
    Bu(t),
    0,
    r,
    n
  );
  return i === W ? r : i;
}
function Ku(e, t, r, n, i, s) {
  var o = t === W;
  if (n === r.length) {
    var a = o ? i : t, c = s(a);
    return c === a ? t : c;
  }
  if (!o && !ze(t))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + r.slice(0, n).map(on) + "]: " + t
    );
  var u = r[n], f = o ? W : Hu(t, u, W), l = Ku(
    f === W ? e : me(f),
    f,
    r,
    n + 1,
    i,
    s
  );
  return l === f ? t : l === W ? Id(t, u) : Cd(
    o ? e ? ue() : {} : t,
    u,
    l
  );
}
function Pd(e, t, r) {
  return Mr(e, t, W, function() {
    return r;
  });
}
function io(e, t) {
  return Pd(this, e, t);
}
function Rd(e, t) {
  return Mr(e, t, function() {
    return W;
  });
}
function so(e) {
  return Rd(this, e);
}
function Qu(e, t, r, n) {
  return Mr(e, [t], r, n);
}
function oo(e, t, r) {
  return arguments.length === 1 ? e(this) : Qu(this, e, t, r);
}
function ao(e, t, r) {
  return Mr(this, e, t, r);
}
function Gu() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return Yu(this, e);
}
function Vu(e) {
  for (var t = [], r = arguments.length - 1; r-- > 0; )
    t[r] = arguments[r + 1];
  if (typeof e != "function")
    throw new TypeError("Invalid merger function: " + e);
  return Yu(this, t, e);
}
function Yu(e, t, r) {
  for (var n = [], i = 0; i < t.length; i++) {
    var s = re(t[i]);
    s.size !== 0 && n.push(s);
  }
  return n.length === 0 ? e : e.toSeq().size === 0 && !e.__ownerID && n.length === 1 ? e.constructor(n[0]) : e.withMutations(function(o) {
    for (var a = r ? function(u, f) {
      Qu(
        o,
        f,
        W,
        function(l) {
          return l === W ? u : r(l, u, f);
        }
      );
    } : function(u, f) {
      o.set(f, u);
    }, c = 0; c < n.length; c++)
      n[c].forEach(a);
  });
}
function uo(e, t, r) {
  return co(e, t, Td(r));
}
function co(e, t, r) {
  if (!ze(e))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + e
    );
  if (me(e))
    return typeof r == "function" && e.mergeWith ? e.mergeWith.apply(e, [r].concat(t)) : e.merge ? e.merge.apply(e, t) : e.concat.apply(e, t);
  for (var n = Array.isArray(e), i = e, s = n ? fr : re, o = n ? function(c) {
    i === e && (i = pi(i)), i.push(c);
  } : function(c, u) {
    var f = Lr.call(i, u), l = f && r ? r(i[u], c, u) : c;
    (!f || l !== i[u]) && (i === e && (i = pi(i)), i[u] = l);
  }, a = 0; a < t.length; a++)
    s(t[a]).forEach(o);
  return i;
}
function Td(e) {
  function t(r, n, i) {
    return ze(r) && ze(n) && Dd(r, n) ? co(r, [n], t) : e ? e(r, n, i) : n;
  }
  return t;
}
function Dd(e, t) {
  var r = Kt(e), n = Kt(t);
  return Ut(r) === Ut(n) && dt(r) === dt(n);
}
function Wu() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return uo(this, e);
}
function Ju(e) {
  for (var t = [], r = arguments.length - 1; r-- > 0; )
    t[r] = arguments[r + 1];
  return uo(this, t, e);
}
function fo(e) {
  for (var t = [], r = arguments.length - 1; r-- > 0; )
    t[r] = arguments[r + 1];
  return Mr(this, e, ue(), function(n) {
    return co(n, t);
  });
}
function lo(e) {
  for (var t = [], r = arguments.length - 1; r-- > 0; )
    t[r] = arguments[r + 1];
  return Mr(
    this,
    e,
    ue(),
    function(n) {
      return uo(n, t);
    }
  );
}
function mn(e) {
  var t = this.asMutable();
  return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
}
function _n() {
  return this.__ownerID ? this : this.__ensureOwner(new Qs());
}
function bn() {
  return this.__ensureOwner();
}
function ho() {
  return this.__altered;
}
var qr = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? ue() : Xs(r) && !ce(r) ? r : ue().withMutations(function(n) {
      var i = e(r);
      te(i.size), i.forEach(function(s, o) {
        return n.set(o, s);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    return ue().withMutations(function(s) {
      for (var o = 0; o < n.length; o += 2) {
        if (o + 1 >= n.length)
          throw new Error("Missing value for key: " + n[o]);
        s.set(n[o], n[o + 1]);
      }
    });
  }, t.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, t.prototype.get = function(n, i) {
    return this._root ? this._root.get(0, void 0, n, i) : i;
  }, t.prototype.set = function(n, i) {
    return xa(this, n, i);
  }, t.prototype.remove = function(n) {
    return xa(this, n, W);
  }, t.prototype.deleteAll = function(n) {
    var i = mt(n);
    return i.size === 0 ? this : this.withMutations(function(s) {
      i.forEach(function(o) {
        return s.remove(o);
      });
    });
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : ue();
  }, t.prototype.sort = function(n) {
    return Re(Or(this, n));
  }, t.prototype.sortBy = function(n, i) {
    return Re(Or(this, i, n));
  }, t.prototype.map = function(n, i) {
    var s = this;
    return this.withMutations(function(o) {
      o.forEach(function(a, c) {
        o.set(c, n.call(i, a, c, s));
      });
    });
  }, t.prototype.__iterator = function(n, i) {
    return new Ad(this, n, i);
  }, t.prototype.__iterate = function(n, i) {
    var s = this, o = 0;
    return this._root && this._root.iterate(function(a) {
      return o++, n(a[1], a[0], s);
    }, i), o;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? po(this.size, this._root, n, this.__hash) : this.size === 0 ? ue() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
}(re);
qr.isMap = Xs;
var ht = qr.prototype;
ht[Au] = !0;
ht[vn] = ht.remove;
ht.removeAll = ht.deleteAll;
ht.setIn = io;
ht.removeIn = ht.deleteIn = so;
ht.update = oo;
ht.updateIn = ao;
ht.merge = ht.concat = Gu;
ht.mergeWith = Vu;
ht.mergeDeep = Wu;
ht.mergeDeepWith = Ju;
ht.mergeIn = fo;
ht.mergeDeepIn = lo;
ht.withMutations = mn;
ht.wasAltered = ho;
ht.asImmutable = bn;
ht["@@transducer/init"] = ht.asMutable = _n;
ht["@@transducer/step"] = function(e, t) {
  return e.set(t[0], t[1]);
};
ht["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var an = function(t, r) {
  this.ownerID = t, this.entries = r;
};
an.prototype.get = function(t, r, n, i) {
  for (var s = this.entries, o = 0, a = s.length; o < a; o++)
    if (Ht(n, s[o][0]))
      return s[o][1];
  return i;
};
an.prototype.update = function(t, r, n, i, s, o, a) {
  for (var c = s === W, u = this.entries, f = 0, l = u.length; f < l && !Ht(i, u[f][0]); f++)
    ;
  var d = f < l;
  if (d ? u[f][1] === s : c)
    return this;
  if (Zt(a), (c || !d) && Zt(o), !(c && u.length === 1)) {
    if (!d && !c && u.length >= Md)
      return xd(t, u, i, s);
    var p = t && t === this.ownerID, y = p ? u : ge(u);
    return d ? c ? f === l - 1 ? y.pop() : y[f] = y.pop() : y[f] = [i, s] : y.push([i, s]), p ? (this.entries = y, this) : new an(t, y);
  }
};
var Ir = function(t, r, n) {
  this.ownerID = t, this.bitmap = r, this.nodes = n;
};
Ir.prototype.get = function(t, r, n, i) {
  r === void 0 && (r = Bt(n));
  var s = 1 << ((t === 0 ? r : r >>> t) & kt), o = this.bitmap;
  return o & s ? this.nodes[Xu(o & s - 1)].get(
    t + lt,
    r,
    n,
    i
  ) : i;
};
Ir.prototype.update = function(t, r, n, i, s, o, a) {
  n === void 0 && (n = Bt(i));
  var c = (r === 0 ? n : n >>> r) & kt, u = 1 << c, f = this.bitmap, l = (f & u) !== 0;
  if (!l && s === W)
    return this;
  var d = Xu(f & u - 1), p = this.nodes, y = l ? p[d] : void 0, m = vo(
    y,
    t,
    r + lt,
    n,
    i,
    s,
    o,
    a
  );
  if (m === y)
    return this;
  if (!l && m && p.length >= qd)
    return Fd(t, p, f, c, m);
  if (l && !m && p.length === 2 && ka(p[d ^ 1]))
    return p[d ^ 1];
  if (l && m && p.length === 1 && ka(m))
    return m;
  var _ = t && t === this.ownerID, b = l ? m ? f : f ^ u : f | u, w = l ? m ? Zu(p, d, m, _) : Nd(p, d, _) : Ld(p, d, m, _);
  return _ ? (this.bitmap = b, this.nodes = w, this) : new Ir(t, b, w);
};
var un = function(t, r, n) {
  this.ownerID = t, this.count = r, this.nodes = n;
};
un.prototype.get = function(t, r, n, i) {
  r === void 0 && (r = Bt(n));
  var s = (t === 0 ? r : r >>> t) & kt, o = this.nodes[s];
  return o ? o.get(t + lt, r, n, i) : i;
};
un.prototype.update = function(t, r, n, i, s, o, a) {
  n === void 0 && (n = Bt(i));
  var c = (r === 0 ? n : n >>> r) & kt, u = s === W, f = this.nodes, l = f[c];
  if (u && !l)
    return this;
  var d = vo(
    l,
    t,
    r + lt,
    n,
    i,
    s,
    o,
    a
  );
  if (d === l)
    return this;
  var p = this.count;
  if (!l)
    p++;
  else if (!d && (p--, p < Ud))
    return kd(t, f, p, c);
  var y = t && t === this.ownerID, m = Zu(f, c, d, y);
  return y ? (this.count = p, this.nodes = m, this) : new un(t, p, m);
};
var Cr = function(t, r, n) {
  this.ownerID = t, this.keyHash = r, this.entries = n;
};
Cr.prototype.get = function(t, r, n, i) {
  for (var s = this.entries, o = 0, a = s.length; o < a; o++)
    if (Ht(n, s[o][0]))
      return s[o][1];
  return i;
};
Cr.prototype.update = function(t, r, n, i, s, o, a) {
  n === void 0 && (n = Bt(i));
  var c = s === W;
  if (n !== this.keyHash)
    return c ? this : (Zt(a), Zt(o), yo(this, t, r, n, [i, s]));
  for (var u = this.entries, f = 0, l = u.length; f < l && !Ht(i, u[f][0]); f++)
    ;
  var d = f < l;
  if (d ? u[f][1] === s : c)
    return this;
  if (Zt(a), (c || !d) && Zt(o), c && l === 2)
    return new Pe(t, this.keyHash, u[f ^ 1]);
  var p = t && t === this.ownerID, y = p ? u : ge(u);
  return d ? c ? f === l - 1 ? y.pop() : y[f] = y.pop() : y[f] = [i, s] : y.push([i, s]), p ? (this.entries = y, this) : new Cr(t, this.keyHash, y);
};
var Pe = function(t, r, n) {
  this.ownerID = t, this.keyHash = r, this.entry = n;
};
Pe.prototype.get = function(t, r, n, i) {
  return Ht(n, this.entry[0]) ? this.entry[1] : i;
};
Pe.prototype.update = function(t, r, n, i, s, o, a) {
  var c = s === W, u = Ht(i, this.entry[0]);
  if (u ? s === this.entry[1] : c)
    return this;
  if (Zt(a), c) {
    Zt(o);
    return;
  }
  return u ? t && t === this.ownerID ? (this.entry[1] = s, this) : new Pe(t, this.keyHash, [i, s]) : (Zt(o), yo(this, t, r, Bt(i), [i, s]));
};
an.prototype.iterate = Cr.prototype.iterate = function(e, t) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++)
    if (e(r[t ? i - n : n]) === !1)
      return !1;
};
Ir.prototype.iterate = un.prototype.iterate = function(e, t) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var s = r[t ? i - n : n];
    if (s && s.iterate(e, t) === !1)
      return !1;
  }
};
Pe.prototype.iterate = function(e, t) {
  return e(this.entry);
};
var Ad = /* @__PURE__ */ function(e) {
  function t(r, n, i) {
    this._type = n, this._reverse = i, this._stack = r._root && Da(r._root);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.next = function() {
    for (var n = this._type, i = this._stack; i; ) {
      var s = i.node, o = i.index++, a = void 0;
      if (s.entry) {
        if (o === 0)
          return ps(n, s.entry);
      } else if (s.entries) {
        if (a = s.entries.length - 1, o <= a)
          return ps(
            n,
            s.entries[this._reverse ? a - o : o]
          );
      } else if (a = s.nodes.length - 1, o <= a) {
        var c = s.nodes[this._reverse ? a - o : o];
        if (c) {
          if (c.entry)
            return ps(n, c.entry);
          i = this._stack = Da(c, i);
        }
        continue;
      }
      i = this._stack = this._stack.__prev;
    }
    return $t();
  }, t;
}(Z);
function ps(e, t) {
  return pt(e, t[0], t[1]);
}
function Da(e, t) {
  return {
    node: e,
    index: 0,
    __prev: t
  };
}
function po(e, t, r, n) {
  var i = Object.create(ht);
  return i.size = e, i._root = t, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var Aa;
function ue() {
  return Aa || (Aa = po(0));
}
function xa(e, t, r) {
  var n, i;
  if (e._root) {
    var s = Is(), o = Is();
    if (n = vo(
      e._root,
      e.__ownerID,
      0,
      void 0,
      t,
      r,
      s,
      o
    ), !o.value)
      return e;
    i = e.size + (s.value ? r === W ? -1 : 1 : 0);
  } else {
    if (r === W)
      return e;
    i = 1, n = new an(e.__ownerID, [[t, r]]);
  }
  return e.__ownerID ? (e.size = i, e._root = n, e.__hash = void 0, e.__altered = !0, e) : n ? po(i, n) : ue();
}
function vo(e, t, r, n, i, s, o, a) {
  return e ? e.update(
    t,
    r,
    n,
    i,
    s,
    o,
    a
  ) : s === W ? e : (Zt(a), Zt(o), new Pe(t, n, [i, s]));
}
function ka(e) {
  return e.constructor === Pe || e.constructor === Cr;
}
function yo(e, t, r, n, i) {
  if (e.keyHash === n)
    return new Cr(t, n, [e.entry, i]);
  var s = (r === 0 ? e.keyHash : e.keyHash >>> r) & kt, o = (r === 0 ? n : n >>> r) & kt, a, c = s === o ? [yo(e, t, r + lt, n, i)] : (a = new Pe(t, n, i), s < o ? [e, a] : [a, e]);
  return new Ir(t, 1 << s | 1 << o, c);
}
function xd(e, t, r, n) {
  e || (e = new Qs());
  for (var i = new Pe(e, Bt(r), [r, n]), s = 0; s < t.length; s++) {
    var o = t[s];
    i = i.update(e, 0, void 0, o[0], o[1]);
  }
  return i;
}
function kd(e, t, r, n) {
  for (var i = 0, s = 0, o = new Array(r), a = 0, c = 1, u = t.length; a < u; a++, c <<= 1) {
    var f = t[a];
    f !== void 0 && a !== n && (i |= c, o[s++] = f);
  }
  return new Ir(e, i, o);
}
function Fd(e, t, r, n, i) {
  for (var s = 0, o = new Array(Xt), a = 0; r !== 0; a++, r >>>= 1)
    o[a] = r & 1 ? t[s++] : void 0;
  return o[n] = i, new un(e, s + 1, o);
}
function Xu(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), e = e + (e >> 4) & 252645135, e += e >> 8, e += e >> 16, e & 127;
}
function Zu(e, t, r, n) {
  var i = n ? e : ge(e);
  return i[t] = r, i;
}
function Ld(e, t, r, n) {
  var i = e.length + 1;
  if (n && t + 1 === i)
    return e[t] = r, e;
  for (var s = new Array(i), o = 0, a = 0; a < i; a++)
    a === t ? (s[a] = r, o = -1) : s[a] = e[a + o];
  return s;
}
function Nd(e, t, r) {
  var n = e.length - 1;
  if (r && t === n)
    return e.pop(), e;
  for (var i = new Array(n), s = 0, o = 0; o < n; o++)
    o === t && (s = 1), i[o] = e[o + s];
  return i;
}
var Md = Xt / 4, qd = Xt / 2, Ud = Xt / 4, tc = "@@__IMMUTABLE_LIST__@@";
function ec(e) {
  return !!(e && e[tc]);
}
var Ai = /* @__PURE__ */ function(e) {
  function t(r) {
    var n = ni();
    if (r == null)
      return n;
    if (ec(r))
      return r;
    var i = e(r), s = i.size;
    return s === 0 ? n : (te(s), s > 0 && s < Xt ? cn(0, s, lt, null, new je(i.toArray())) : n.withMutations(function(o) {
      o.setSize(s), i.forEach(function(a, c) {
        return o.set(c, a);
      });
    }));
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, t.prototype.get = function(n, i) {
    if (n = $e(this, n), n >= 0 && n < this.size) {
      n += this._origin;
      var s = rc(this, n);
      return s && s.array[n & kt];
    }
    return i;
  }, t.prototype.set = function(n, i) {
    return jd(this, n, i);
  }, t.prototype.remove = function(n) {
    return this.has(n) ? n === 0 ? this.shift() : n === this.size - 1 ? this.pop() : this.splice(n, 1) : this;
  }, t.prototype.insert = function(n, i) {
    return this.splice(n, 0, i);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = lt, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : ni();
  }, t.prototype.push = function() {
    var n = arguments, i = this.size;
    return this.withMutations(function(s) {
      qe(s, 0, i + n.length);
      for (var o = 0; o < n.length; o++)
        s.set(i + o, n[o]);
    });
  }, t.prototype.pop = function() {
    return qe(this, 0, -1);
  }, t.prototype.unshift = function() {
    var n = arguments;
    return this.withMutations(function(i) {
      qe(i, -n.length);
      for (var s = 0; s < n.length; s++)
        i.set(s, n[s]);
    });
  }, t.prototype.shift = function() {
    return qe(this, 1);
  }, t.prototype.concat = function() {
    for (var n = arguments, i = [], s = 0; s < arguments.length; s++) {
      var o = n[s], a = e(
        typeof o != "string" && Ru(o) ? o : [o]
      );
      a.size !== 0 && i.push(a);
    }
    return i.length === 0 ? this : this.size === 0 && !this.__ownerID && i.length === 1 ? this.constructor(i[0]) : this.withMutations(function(c) {
      i.forEach(function(u) {
        return u.forEach(function(f) {
          return c.push(f);
        });
      });
    });
  }, t.prototype.setSize = function(n) {
    return qe(this, 0, n);
  }, t.prototype.map = function(n, i) {
    var s = this;
    return this.withMutations(function(o) {
      for (var a = 0; a < s.size; a++)
        o.set(a, n.call(i, o.get(a), a, s));
    });
  }, t.prototype.slice = function(n, i) {
    var s = this.size;
    return Oi(n, i, s) ? this : qe(
      this,
      yn(n, s),
      Ii(i, s)
    );
  }, t.prototype.__iterator = function(n, i) {
    var s = i ? this.size : 0, o = Fa(this, i);
    return new Z(function() {
      var a = o();
      return a === rn ? $t() : pt(n, i ? --s : s++, a);
    });
  }, t.prototype.__iterate = function(n, i) {
    for (var s = i ? this.size : 0, o = Fa(this, i), a; (a = o()) !== rn && n(a, i ? --s : s++, this) !== !1; )
      ;
    return s;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? cn(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      n,
      this.__hash
    ) : this.size === 0 ? ni() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
}(fr);
Ai.isList = ec;
var wt = Ai.prototype;
wt[tc] = !0;
wt[vn] = wt.remove;
wt.merge = wt.concat;
wt.setIn = io;
wt.deleteIn = wt.removeIn = so;
wt.update = oo;
wt.updateIn = ao;
wt.mergeIn = fo;
wt.mergeDeepIn = lo;
wt.withMutations = mn;
wt.wasAltered = ho;
wt.asImmutable = bn;
wt["@@transducer/init"] = wt.asMutable = _n;
wt["@@transducer/step"] = function(e, t) {
  return e.push(t);
};
wt["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var je = function(t, r) {
  this.array = t, this.ownerID = r;
};
je.prototype.removeBefore = function(t, r, n) {
  if (n === r ? 1 << r : this.array.length === 0)
    return this;
  var i = n >>> r & kt;
  if (i >= this.array.length)
    return new je([], t);
  var s = i === 0, o;
  if (r > 0) {
    var a = this.array[i];
    if (o = a && a.removeBefore(t, r - lt, n), o === a && s)
      return this;
  }
  if (s && !o)
    return this;
  var c = Pr(this, t);
  if (!s)
    for (var u = 0; u < i; u++)
      c.array[u] = void 0;
  return o && (c.array[i] = o), c;
};
je.prototype.removeAfter = function(t, r, n) {
  if (n === (r ? 1 << r : 0) || this.array.length === 0)
    return this;
  var i = n - 1 >>> r & kt;
  if (i >= this.array.length)
    return this;
  var s;
  if (r > 0) {
    var o = this.array[i];
    if (s = o && o.removeAfter(t, r - lt, n), s === o && i === this.array.length - 1)
      return this;
  }
  var a = Pr(this, t);
  return a.array.splice(i + 1), s && (a.array[i] = s), a;
};
var rn = {};
function Fa(e, t) {
  var r = e._origin, n = e._capacity, i = fn(n), s = e._tail;
  return o(e._root, e._level, 0);
  function o(u, f, l) {
    return f === 0 ? a(u, l) : c(u, f, l);
  }
  function a(u, f) {
    var l = f === i ? s && s.array : u && u.array, d = f > r ? 0 : r - f, p = n - f;
    return p > Xt && (p = Xt), function() {
      if (d === p)
        return rn;
      var y = t ? --p : d++;
      return l && l[y];
    };
  }
  function c(u, f, l) {
    var d, p = u && u.array, y = l > r ? 0 : r - l >> f, m = (n - l >> f) + 1;
    return m > Xt && (m = Xt), function() {
      for (; ; ) {
        if (d) {
          var _ = d();
          if (_ !== rn)
            return _;
          d = null;
        }
        if (y === m)
          return rn;
        var b = t ? --m : y++;
        d = o(
          p && p[b],
          f - lt,
          l + (b << f)
        );
      }
    };
  }
}
function cn(e, t, r, n, i, s, o) {
  var a = Object.create(wt);
  return a.size = t - e, a._origin = e, a._capacity = t, a._level = r, a._root = n, a._tail = i, a.__ownerID = s, a.__hash = o, a.__altered = !1, a;
}
var La;
function ni() {
  return La || (La = cn(0, 0, lt));
}
function jd(e, t, r) {
  if (t = $e(e, t), t !== t)
    return e;
  if (t >= e.size || t < 0)
    return e.withMutations(function(o) {
      t < 0 ? qe(o, t).set(0, r) : qe(o, 0, t + 1).set(t, r);
    });
  t += e._origin;
  var n = e._tail, i = e._root, s = Is();
  return t >= fn(e._capacity) ? n = As(n, e.__ownerID, 0, t, r, s) : i = As(
    i,
    e.__ownerID,
    e._level,
    t,
    r,
    s
  ), s.value ? e.__ownerID ? (e._root = i, e._tail = n, e.__hash = void 0, e.__altered = !0, e) : cn(e._origin, e._capacity, e._level, i, n) : e;
}
function As(e, t, r, n, i, s) {
  var o = n >>> r & kt, a = e && o < e.array.length;
  if (!a && i === void 0)
    return e;
  var c;
  if (r > 0) {
    var u = e && e.array[o], f = As(
      u,
      t,
      r - lt,
      n,
      i,
      s
    );
    return f === u ? e : (c = Pr(e, t), c.array[o] = f, c);
  }
  return a && e.array[o] === i ? e : (s && Zt(s), c = Pr(e, t), i === void 0 && o === c.array.length - 1 ? c.array.pop() : c.array[o] = i, c);
}
function Pr(e, t) {
  return t && e && t === e.ownerID ? e : new je(e ? e.array.slice() : [], t);
}
function rc(e, t) {
  if (t >= fn(e._capacity))
    return e._tail;
  if (t < 1 << e._level + lt) {
    for (var r = e._root, n = e._level; r && n > 0; )
      r = r.array[t >>> n & kt], n -= lt;
    return r;
  }
}
function qe(e, t, r) {
  t !== void 0 && (t |= 0), r !== void 0 && (r |= 0);
  var n = e.__ownerID || new Qs(), i = e._origin, s = e._capacity, o = i + t, a = r === void 0 ? s : r < 0 ? s + r : i + r;
  if (o === i && a === s)
    return e;
  if (o >= a)
    return e.clear();
  for (var c = e._level, u = e._root, f = 0; o + f < 0; )
    u = new je(
      u && u.array.length ? [void 0, u] : [],
      n
    ), c += lt, f += 1 << c;
  f && (o += f, i += f, a += f, s += f);
  for (var l = fn(s), d = fn(a); d >= 1 << c + lt; )
    u = new je(
      u && u.array.length ? [u] : [],
      n
    ), c += lt;
  var p = e._tail, y = d < l ? rc(e, a - 1) : d > l ? new je([], n) : p;
  if (p && d > l && o < s && p.array.length) {
    u = Pr(u, n);
    for (var m = u, _ = c; _ > lt; _ -= lt) {
      var b = l >>> _ & kt;
      m = m.array[b] = Pr(m.array[b], n);
    }
    m.array[l >>> lt & kt] = p;
  }
  if (a < s && (y = y && y.removeAfter(n, 0, a)), o >= d)
    o -= d, a -= d, c = lt, u = null, y = y && y.removeBefore(n, 0, o);
  else if (o > i || d < l) {
    for (f = 0; u; ) {
      var w = o >>> c & kt;
      if (w !== d >>> c & kt)
        break;
      w && (f += (1 << c) * w), c -= lt, u = u.array[w];
    }
    u && o > i && (u = u.removeBefore(n, c, o - f)), u && d < l && (u = u.removeAfter(
      n,
      c,
      d - f
    )), f && (o -= f, a -= f);
  }
  return e.__ownerID ? (e.size = a - o, e._origin = o, e._capacity = a, e._level = c, e._root = u, e._tail = y, e.__hash = void 0, e.__altered = !0, e) : cn(o, a, c, u, y);
}
function fn(e) {
  return e < Xt ? 0 : e - 1 >>> lt << lt;
}
var Re = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? Xr() : xu(r) ? r : Xr().withMutations(function(n) {
      var i = re(r);
      te(i.size), i.forEach(function(s, o) {
        return n.set(o, s);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, t.prototype.get = function(n, i) {
    var s = this._map.get(n);
    return s !== void 0 ? this._list.get(s)[1] : i;
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Xr();
  }, t.prototype.set = function(n, i) {
    return Ma(this, n, i);
  }, t.prototype.remove = function(n) {
    return Ma(this, n, W);
  }, t.prototype.__iterate = function(n, i) {
    var s = this;
    return this._list.__iterate(
      function(o) {
        return o && n(o[1], o[0], s);
      },
      i
    );
  }, t.prototype.__iterator = function(n, i) {
    return this._list.fromEntrySeq().__iterator(n, i);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var i = this._map.__ensureOwner(n), s = this._list.__ensureOwner(n);
    return n ? go(i, s, n, this.__hash) : this.size === 0 ? Xr() : (this.__ownerID = n, this.__altered = !1, this._map = i, this._list = s, this);
  }, t;
}(qr);
Re.isOrderedMap = xu;
Re.prototype[Fr] = !0;
Re.prototype[vn] = Re.prototype.remove;
function go(e, t, r, n) {
  var i = Object.create(Re.prototype);
  return i.size = e ? e.size : 0, i._map = e, i._list = t, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var Na;
function Xr() {
  return Na || (Na = go(ue(), ni()));
}
function Ma(e, t, r) {
  var n = e._map, i = e._list, s = n.get(t), o = s !== void 0, a, c;
  if (r === W) {
    if (!o)
      return e;
    i.size >= Xt && i.size >= n.size * 2 ? (c = i.filter(function(u, f) {
      return u !== void 0 && s !== f;
    }), a = c.toKeyedSeq().map(function(u) {
      return u[0];
    }).flip().toMap(), e.__ownerID && (a.__ownerID = c.__ownerID = e.__ownerID)) : (a = n.remove(t), c = s === i.size - 1 ? i.pop() : i.set(s, void 0));
  } else if (o) {
    if (r === i.get(s)[1])
      return e;
    a = n, c = i.set(s, [t, r]);
  } else
    a = n.set(t, i.size), c = i.set(i.size, [t, r]);
  return e.__ownerID ? (e.size = a.size, e._map = a, e._list = c, e.__hash = void 0, e.__altered = !0, e) : go(a, c);
}
var nc = "@@__IMMUTABLE_STACK__@@";
function xs(e) {
  return !!(e && e[nc]);
}
var mo = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? Wn() : xs(r) ? r : Wn().pushAll(r);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, t.prototype.get = function(n, i) {
    var s = this._head;
    for (n = $e(this, n); s && n--; )
      s = s.next;
    return s ? s.value : i;
  }, t.prototype.peek = function() {
    return this._head && this._head.value;
  }, t.prototype.push = function() {
    var n = arguments;
    if (arguments.length === 0)
      return this;
    for (var i = this.size + arguments.length, s = this._head, o = arguments.length - 1; o >= 0; o--)
      s = {
        value: n[o],
        next: s
      };
    return this.__ownerID ? (this.size = i, this._head = s, this.__hash = void 0, this.__altered = !0, this) : Zr(i, s);
  }, t.prototype.pushAll = function(n) {
    if (n = e(n), n.size === 0)
      return this;
    if (this.size === 0 && xs(n))
      return n;
    te(n.size);
    var i = this.size, s = this._head;
    return n.__iterate(
      function(o) {
        i++, s = {
          value: o,
          next: s
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = i, this._head = s, this.__hash = void 0, this.__altered = !0, this) : Zr(i, s);
  }, t.prototype.pop = function() {
    return this.slice(1);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Wn();
  }, t.prototype.slice = function(n, i) {
    if (Oi(n, i, this.size))
      return this;
    var s = yn(n, this.size), o = Ii(i, this.size);
    if (o !== this.size)
      return e.prototype.slice.call(this, n, i);
    for (var a = this.size - s, c = this._head; s--; )
      c = c.next;
    return this.__ownerID ? (this.size = a, this._head = c, this.__hash = void 0, this.__altered = !0, this) : Zr(a, c);
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Zr(this.size, this._head, n, this.__hash) : this.size === 0 ? Wn() : (this.__ownerID = n, this.__altered = !1, this);
  }, t.prototype.__iterate = function(n, i) {
    var s = this;
    if (i)
      return new ur(this.toArray()).__iterate(
        function(c, u) {
          return n(c, u, s);
        },
        i
      );
    for (var o = 0, a = this._head; a && n(a.value, o++, this) !== !1; )
      a = a.next;
    return o;
  }, t.prototype.__iterator = function(n, i) {
    if (i)
      return new ur(this.toArray()).__iterator(n, i);
    var s = 0, o = this._head;
    return new Z(function() {
      if (o) {
        var a = o.value;
        return o = o.next, pt(n, s++, a);
      }
      return $t();
    });
  }, t;
}(fr);
mo.isStack = xs;
var Lt = mo.prototype;
Lt[nc] = !0;
Lt.shift = Lt.pop;
Lt.unshift = Lt.push;
Lt.unshiftAll = Lt.pushAll;
Lt.withMutations = mn;
Lt.wasAltered = ho;
Lt.asImmutable = bn;
Lt["@@transducer/init"] = Lt.asMutable = _n;
Lt["@@transducer/step"] = function(e, t) {
  return e.unshift(t);
};
Lt["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
function Zr(e, t, r, n) {
  var i = Object.create(Lt);
  return i.size = e, i._head = t, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var qa;
function Wn() {
  return qa || (qa = Zr(0));
}
var ic = "@@__IMMUTABLE_SET__@@";
function _o(e) {
  return !!(e && e[ic]);
}
function sc(e) {
  return _o(e) && ce(e);
}
function oc(e, t) {
  if (e === t)
    return !0;
  if (!jt(t) || e.size !== void 0 && t.size !== void 0 && e.size !== t.size || e.__hash !== void 0 && t.__hash !== void 0 && e.__hash !== t.__hash || dt(e) !== dt(t) || Ut(e) !== Ut(t) || ce(e) !== ce(t))
    return !1;
  if (e.size === 0 && t.size === 0)
    return !0;
  var r = !Ci(e);
  if (ce(e)) {
    var n = e.entries();
    return t.every(function(c, u) {
      var f = n.next().value;
      return f && Ht(f[1], c) && (r || Ht(f[0], u));
    }) && n.next().done;
  }
  var i = !1;
  if (e.size === void 0)
    if (t.size === void 0)
      typeof e.cacheResult == "function" && e.cacheResult();
    else {
      i = !0;
      var s = e;
      e = t, t = s;
    }
  var o = !0, a = t.__iterate(function(c, u) {
    if (r ? !e.has(c) : i ? !Ht(c, e.get(u, W)) : !Ht(e.get(u, W), c))
      return o = !1, !1;
  });
  return o && e.size === a;
}
function lr(e, t) {
  var r = function(n) {
    e.prototype[n] = t[n];
  };
  return Object.keys(t).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(r), e;
}
function vi(e) {
  if (!e || typeof e != "object")
    return e;
  if (!jt(e)) {
    if (!ze(e))
      return e;
    e = Kt(e);
  }
  if (dt(e)) {
    var t = {};
    return e.__iterate(function(n, i) {
      t[i] = vi(n);
    }), t;
  }
  var r = [];
  return e.__iterate(function(n) {
    r.push(vi(n));
  }), r;
}
var xi = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? tn() : _o(r) && !ce(r) ? r : tn().withMutations(function(n) {
      var i = e(r);
      te(i.size), i.forEach(function(s) {
        return n.add(s);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(re(n).keySeq());
  }, t.intersect = function(n) {
    return n = mt(n).toArray(), n.length ? Ct.intersect.apply(t(n.pop()), n) : tn();
  }, t.union = function(n) {
    return n = mt(n).toArray(), n.length ? Ct.union.apply(t(n.pop()), n) : tn();
  }, t.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, t.prototype.has = function(n) {
    return this._map.has(n);
  }, t.prototype.add = function(n) {
    return Jn(this, this._map.set(n, n));
  }, t.prototype.remove = function(n) {
    return Jn(this, this._map.remove(n));
  }, t.prototype.clear = function() {
    return Jn(this, this._map.clear());
  }, t.prototype.map = function(n, i) {
    var s = this, o = !1, a = Jn(
      this,
      this._map.mapEntries(function(c) {
        var u = c[1], f = n.call(i, u, u, s);
        return f !== u && (o = !0), [f, f];
      }, i)
    );
    return o ? a : this;
  }, t.prototype.union = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    return n = n.filter(function(s) {
      return s.size !== 0;
    }), n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(s) {
      for (var o = 0; o < n.length; o++)
        typeof n[o] == "string" ? s.add(n[o]) : e(n[o]).forEach(function(a) {
          return s.add(a);
        });
    });
  }, t.prototype.intersect = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var s = [];
    return this.forEach(function(o) {
      n.every(function(a) {
        return a.includes(o);
      }) || s.push(o);
    }), this.withMutations(function(o) {
      s.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.subtract = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var s = [];
    return this.forEach(function(o) {
      n.some(function(a) {
        return a.includes(o);
      }) && s.push(o);
    }), this.withMutations(function(o) {
      s.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.sort = function(n) {
    return ln(Or(this, n));
  }, t.prototype.sortBy = function(n, i) {
    return ln(Or(this, i, n));
  }, t.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, t.prototype.__iterate = function(n, i) {
    var s = this;
    return this._map.__iterate(function(o) {
      return n(o, o, s);
    }, i);
  }, t.prototype.__iterator = function(n, i) {
    return this._map.__iterator(n, i);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var i = this._map.__ensureOwner(n);
    return n ? this.__make(i, n) : this.size === 0 ? this.__empty() : (this.__ownerID = n, this._map = i, this);
  }, t;
}(xr);
xi.isSet = _o;
var Ct = xi.prototype;
Ct[ic] = !0;
Ct[vn] = Ct.remove;
Ct.merge = Ct.concat = Ct.union;
Ct.withMutations = mn;
Ct.asImmutable = bn;
Ct["@@transducer/init"] = Ct.asMutable = _n;
Ct["@@transducer/step"] = function(e, t) {
  return e.add(t);
};
Ct["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
Ct.__empty = tn;
Ct.__make = ac;
function Jn(e, t) {
  return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : t.size === 0 ? e.__empty() : e.__make(t);
}
function ac(e, t) {
  var r = Object.create(Ct);
  return r.size = e ? e.size : 0, r._map = e, r.__ownerID = t, r;
}
var Ua;
function tn() {
  return Ua || (Ua = ac(ue()));
}
var $d = /* @__PURE__ */ function(e) {
  function t(r, n, i) {
    if (!(this instanceof t))
      return new t(r, n, i);
    if (no(i !== 0, "Cannot step a Range by 0"), r = r || 0, n === void 0 && (n = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), n < r && (i = -i), this._start = r, this._end = n, this._step = i, this.size = Math.max(0, Math.ceil((n - r) / i - 1) + 1), this.size === 0) {
      if (vs)
        return vs;
      vs = this;
    }
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, t.prototype.get = function(n, i) {
    return this.has(n) ? this._start + $e(this, n) * this._step : i;
  }, t.prototype.includes = function(n) {
    var i = (n - this._start) / this._step;
    return i >= 0 && i < this.size && i === Math.floor(i);
  }, t.prototype.slice = function(n, i) {
    return Oi(n, i, this.size) ? this : (n = yn(n, this.size), i = Ii(i, this.size), i <= n ? new t(0, 0) : new t(
      this.get(n, this._end),
      this.get(i, this._end),
      this._step
    ));
  }, t.prototype.indexOf = function(n) {
    var i = n - this._start;
    if (i % this._step === 0) {
      var s = i / this._step;
      if (s >= 0 && s < this.size)
        return s;
    }
    return -1;
  }, t.prototype.lastIndexOf = function(n) {
    return this.indexOf(n);
  }, t.prototype.__iterate = function(n, i) {
    for (var s = this.size, o = this._step, a = i ? this._start + (s - 1) * o : this._start, c = 0; c !== s && n(a, i ? s - ++c : c++, this) !== !1; )
      a += i ? -o : o;
    return c;
  }, t.prototype.__iterator = function(n, i) {
    var s = this.size, o = this._step, a = i ? this._start + (s - 1) * o : this._start, c = 0;
    return new Z(function() {
      if (c === s)
        return $t();
      var u = a;
      return a += i ? -o : o, pt(n, i ? s - ++c : c++, u);
    });
  }, t.prototype.equals = function(n) {
    return n instanceof t ? this._start === n._start && this._end === n._end && this._step === n._step : oc(this, n);
  }, t;
}(le), vs;
function uc(e, t, r) {
  for (var n = Bu(t), i = 0; i !== n.length; )
    if (e = Hu(e, n[i++], W), e === W)
      return r;
  return e;
}
function cc(e, t) {
  return uc(this, e, t);
}
function zd(e, t) {
  return uc(e, t, W) !== W;
}
function Bd(e) {
  return zd(this, e);
}
function fc() {
  te(this.size);
  var e = {};
  return this.__iterate(function(t, r) {
    e[r] = t;
  }), e;
}
mt.isIterable = jt;
mt.isKeyed = dt;
mt.isIndexed = Ut;
mt.isAssociative = Ci;
mt.isOrdered = ce;
mt.Iterator = Z;
lr(mt, {
  // ### Conversion to other types
  toArray: function() {
    te(this.size);
    var t = new Array(this.size || 0), r = dt(this), n = 0;
    return this.__iterate(function(i, s) {
      t[n++] = r ? [s, i] : i;
    }), t;
  },
  toIndexedSeq: function() {
    return new Fu(this);
  },
  toJS: function() {
    return vi(this);
  },
  toKeyedSeq: function() {
    return new Di(this, !0);
  },
  toMap: function() {
    return qr(this.toKeyedSeq());
  },
  toObject: fc,
  toOrderedMap: function() {
    return Re(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return ln(dt(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return xi(dt(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new Lu(this);
  },
  toSeq: function() {
    return Ut(this) ? this.toIndexedSeq() : dt(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return mo(dt(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return Ai(dt(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(t, r) {
    return this.size === 0 ? t + r : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + r;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var t = [], r = arguments.length; r--; )
      t[r] = arguments[r];
    return st(this, _d(this, t));
  },
  includes: function(t) {
    return this.some(function(r) {
      return Ht(r, t);
    });
  },
  entries: function() {
    return this.__iterator(ee);
  },
  every: function(t, r) {
    te(this.size);
    var n = !0;
    return this.__iterate(function(i, s, o) {
      if (!t.call(r, i, s, o))
        return n = !1, !1;
    }), n;
  },
  filter: function(t, r) {
    return st(this, Uu(this, t, r, !0));
  },
  partition: function(t, r) {
    return gd(this, t, r);
  },
  find: function(t, r, n) {
    var i = this.findEntry(t, r);
    return i ? i[1] : n;
  },
  forEach: function(t, r) {
    return te(this.size), this.__iterate(r ? t.bind(r) : t);
  },
  join: function(t) {
    te(this.size), t = t !== void 0 ? "" + t : ",";
    var r = "", n = !0;
    return this.__iterate(function(i) {
      n ? n = !1 : r += t, r += i != null ? i.toString() : "";
    }), r;
  },
  keys: function() {
    return this.__iterator(gn);
  },
  map: function(t, r) {
    return st(this, qu(this, t, r));
  },
  reduce: function(t, r, n) {
    return ja(
      this,
      t,
      r,
      n,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(t, r, n) {
    return ja(
      this,
      t,
      r,
      n,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return st(this, Zs(this, !0));
  },
  slice: function(t, r) {
    return st(this, to(this, t, r, !0));
  },
  some: function(t, r) {
    return !this.every(Xn(t), r);
  },
  sort: function(t) {
    return st(this, Or(this, t));
  },
  values: function() {
    return this.__iterator(fe);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(t, r) {
    return Sr(
      t ? this.toSeq().filter(t, r) : this
    );
  },
  countBy: function(t, r) {
    return vd(this, t, r);
  },
  equals: function(t) {
    return oc(this, t);
  },
  entrySeq: function() {
    var t = this;
    if (t._cache)
      return new ur(t._cache);
    var r = t.toSeq().map(Kd).toIndexedSeq();
    return r.fromEntrySeq = function() {
      return t.toSeq();
    }, r;
  },
  filterNot: function(t, r) {
    return this.filter(Xn(t), r);
  },
  findEntry: function(t, r, n) {
    var i = n;
    return this.__iterate(function(s, o, a) {
      if (t.call(r, s, o, a))
        return i = [o, s], !1;
    }), i;
  },
  findKey: function(t, r) {
    var n = this.findEntry(t, r);
    return n && n[0];
  },
  findLast: function(t, r, n) {
    return this.toKeyedSeq().reverse().find(t, r, n);
  },
  findLastEntry: function(t, r, n) {
    return this.toKeyedSeq().reverse().findEntry(t, r, n);
  },
  findLastKey: function(t, r) {
    return this.toKeyedSeq().reverse().findKey(t, r);
  },
  first: function(t) {
    return this.find(_u, null, t);
  },
  flatMap: function(t, r) {
    return st(this, bd(this, t, r));
  },
  flatten: function(t) {
    return st(this, $u(this, t, !0));
  },
  fromEntrySeq: function() {
    return new Nu(this);
  },
  get: function(t, r) {
    return this.find(function(n, i) {
      return Ht(i, t);
    }, void 0, r);
  },
  getIn: cc,
  groupBy: function(t, r) {
    return yd(this, t, r);
  },
  has: function(t) {
    return this.get(t, W) !== W;
  },
  hasIn: Bd,
  isSubset: function(t) {
    return t = typeof t.includes == "function" ? t : mt(t), this.every(function(r) {
      return t.includes(r);
    });
  },
  isSuperset: function(t) {
    return t = typeof t.isSubset == "function" ? t : mt(t), t.isSubset(this);
  },
  keyOf: function(t) {
    return this.findKey(function(r) {
      return Ht(r, t);
    });
  },
  keySeq: function() {
    return this.toSeq().map(Hd).toIndexedSeq();
  },
  last: function(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function(t) {
    return Vn(this, t);
  },
  maxBy: function(t, r) {
    return Vn(this, r, t);
  },
  min: function(t) {
    return Vn(
      this,
      t ? $a(t) : Ba
    );
  },
  minBy: function(t, r) {
    return Vn(
      this,
      r ? $a(r) : Ba,
      t
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(t) {
    return t === 0 ? this : this.slice(Math.max(0, t));
  },
  skipLast: function(t) {
    return t === 0 ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function(t, r) {
    return st(this, ju(this, t, r, !0));
  },
  skipUntil: function(t, r) {
    return this.skipWhile(Xn(t), r);
  },
  sortBy: function(t, r) {
    return st(this, Or(this, r, t));
  },
  take: function(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function(t, r) {
    return st(this, md(this, t, r));
  },
  takeUntil: function(t, r) {
    return this.takeWhile(Xn(t), r);
  },
  update: function(t) {
    return t(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = Qd(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var At = mt.prototype;
At[Eu] = !0;
At[Pi] = At.values;
At.toJSON = At.toArray;
At.__toStringMapper = on;
At.inspect = At.toSource = function() {
  return this.toString();
};
At.chain = At.flatMap;
At.contains = At.includes;
lr(re, {
  // ### More sequential methods
  flip: function() {
    return st(this, Mu(this));
  },
  mapEntries: function(t, r) {
    var n = this, i = 0;
    return st(
      this,
      this.toSeq().map(function(s, o) {
        return t.call(r, [o, s], i++, n);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(t, r) {
    var n = this;
    return st(
      this,
      this.toSeq().flip().map(function(i, s) {
        return t.call(r, i, s, n);
      }).flip()
    );
  }
});
var wn = re.prototype;
wn[Su] = !0;
wn[Pi] = At.entries;
wn.toJSON = fc;
wn.__toStringMapper = function(e, t) {
  return on(t) + ": " + on(e);
};
lr(fr, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new Di(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(t, r) {
    return st(this, Uu(this, t, r, !1));
  },
  findIndex: function(t, r) {
    var n = this.findEntry(t, r);
    return n ? n[0] : -1;
  },
  indexOf: function(t) {
    var r = this.keyOf(t);
    return r === void 0 ? -1 : r;
  },
  lastIndexOf: function(t) {
    var r = this.lastKeyOf(t);
    return r === void 0 ? -1 : r;
  },
  reverse: function() {
    return st(this, Zs(this, !1));
  },
  slice: function(t, r) {
    return st(this, to(this, t, r, !1));
  },
  splice: function(t, r) {
    var n = arguments.length;
    if (r = Math.max(r || 0, 0), n === 0 || n === 2 && !r)
      return this;
    t = yn(t, t < 0 ? this.count() : this.size);
    var i = this.slice(0, t);
    return st(
      this,
      n === 1 ? i : i.concat(ge(arguments, 2), this.slice(t + r))
    );
  },
  // ### More collection methods
  findLastIndex: function(t, r) {
    var n = this.findLastEntry(t, r);
    return n ? n[0] : -1;
  },
  first: function(t) {
    return this.get(0, t);
  },
  flatten: function(t) {
    return st(this, $u(this, t, !1));
  },
  get: function(t, r) {
    return t = $e(this, t), t < 0 || this.size === 1 / 0 || this.size !== void 0 && t > this.size ? r : this.find(function(n, i) {
      return i === t;
    }, void 0, r);
  },
  has: function(t) {
    return t = $e(this, t), t >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || t < this.size : this.indexOf(t) !== -1);
  },
  interpose: function(t) {
    return st(this, wd(this, t));
  },
  interleave: function() {
    var t = [this].concat(ge(arguments)), r = Yn(this.toSeq(), le.of, t), n = r.flatten(!0);
    return r.size && (n.size = r.size * t.length), st(this, n);
  },
  keySeq: function() {
    return $d(0, this.size);
  },
  last: function(t) {
    return this.get(-1, t);
  },
  skipWhile: function(t, r) {
    return st(this, ju(this, t, r, !1));
  },
  zip: function() {
    var t = [this].concat(ge(arguments));
    return st(this, Yn(this, za, t));
  },
  zipAll: function() {
    var t = [this].concat(ge(arguments));
    return st(this, Yn(this, za, t, !0));
  },
  zipWith: function(t) {
    var r = ge(arguments);
    return r[0] = this, st(this, Yn(this, t, r));
  }
});
var Ur = fr.prototype;
Ur[Ou] = !0;
Ur[Fr] = !0;
lr(xr, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(t, r) {
    return this.has(t) ? t : r;
  },
  includes: function(t) {
    return this.has(t);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var Rr = xr.prototype;
Rr.has = At.includes;
Rr.contains = Rr.includes;
Rr.keys = Rr.values;
lr(Be, wn);
lr(le, Ur);
lr(Nr, Rr);
function ja(e, t, r, n, i, s) {
  return te(e.size), e.__iterate(function(o, a, c) {
    i ? (i = !1, r = o) : r = t.call(n, r, o, a, c);
  }, s), r;
}
function Hd(e, t) {
  return t;
}
function Kd(e, t) {
  return [t, e];
}
function Xn(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function $a(e) {
  return function() {
    return -e.apply(this, arguments);
  };
}
function za() {
  return ge(arguments);
}
function Ba(e, t) {
  return e < t ? 1 : e > t ? -1 : 0;
}
function Qd(e) {
  if (e.size === 1 / 0)
    return 0;
  var t = ce(e), r = dt(e), n = t ? 1 : 0, i = e.__iterate(
    r ? t ? function(s, o) {
      n = 31 * n + Ha(Bt(s), Bt(o)) | 0;
    } : function(s, o) {
      n = n + Ha(Bt(s), Bt(o)) | 0;
    } : t ? function(s) {
      n = 31 * n + Bt(s) | 0;
    } : function(s) {
      n = n + Bt(s) | 0;
    }
  );
  return Gd(i, n);
}
function Gd(e, t) {
  return t = Vr(t, 3432918353), t = Vr(t << 15 | t >>> -15, 461845907), t = Vr(t << 13 | t >>> -13, 5), t = (t + 3864292196 | 0) ^ e, t = Vr(t ^ t >>> 16, 2246822507), t = Vr(t ^ t >>> 13, 3266489909), t = Ti(t ^ t >>> 16), t;
}
function Ha(e, t) {
  return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
}
var ln = /* @__PURE__ */ function(e) {
  function t(r) {
    return r == null ? ks() : sc(r) ? r : ks().withMutations(function(n) {
      var i = xr(r);
      te(i.size), i.forEach(function(s) {
        return n.add(s);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(re(n).keySeq());
  }, t.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, t;
}(xi);
ln.isOrderedSet = sc;
var hr = ln.prototype;
hr[Fr] = !0;
hr.zip = Ur.zip;
hr.zipWith = Ur.zipWith;
hr.zipAll = Ur.zipAll;
hr.__empty = ks;
hr.__make = lc;
function lc(e, t) {
  var r = Object.create(hr);
  return r.size = e ? e.size : 0, r._map = e, r.__ownerID = t, r;
}
var Ka;
function ks() {
  return Ka || (Ka = lc(Xr()));
}
function Vd(e) {
  if (kr(e))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (me(e))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (e === null || typeof e != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var z = function(t, r) {
  var n;
  Vd(t);
  var i = function(a) {
    var c = this;
    if (a instanceof i)
      return a;
    if (!(this instanceof i))
      return new i(a);
    if (!n) {
      n = !0;
      var u = Object.keys(t), f = s._indices = {};
      s._name = r, s._keys = u, s._defaultValues = t;
      for (var l = 0; l < u.length; l++) {
        var d = u[l];
        f[d] = l, s[d] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + wo(this) + ' with property "' + d + '" since that property name is part of the Record API.'
        ) : Yd(s, d);
      }
    }
    return this.__ownerID = void 0, this._values = Ai().withMutations(function(p) {
      p.setSize(c._keys.length), re(a).forEach(function(y, m) {
        p.set(c._indices[m], y === c._defaultValues[m] ? void 0 : y);
      });
    }), this;
  }, s = i.prototype = Object.create(ct);
  return s.constructor = i, r && (i.displayName = r), i;
};
z.prototype.toString = function() {
  for (var t = wo(this) + " { ", r = this._keys, n, i = 0, s = r.length; i !== s; i++)
    n = r[i], t += (i ? ", " : "") + n + ": " + on(this.get(n));
  return t + " }";
};
z.prototype.equals = function(t) {
  return this === t || kr(t) && Tr(this).equals(Tr(t));
};
z.prototype.hashCode = function() {
  return Tr(this).hashCode();
};
z.prototype.has = function(t) {
  return this._indices.hasOwnProperty(t);
};
z.prototype.get = function(t, r) {
  if (!this.has(t))
    return r;
  var n = this._indices[t], i = this._values.get(n);
  return i === void 0 ? this._defaultValues[t] : i;
};
z.prototype.set = function(t, r) {
  if (this.has(t)) {
    var n = this._values.set(
      this._indices[t],
      r === this._defaultValues[t] ? void 0 : r
    );
    if (n !== this._values && !this.__ownerID)
      return bo(this, n);
  }
  return this;
};
z.prototype.remove = function(t) {
  return this.set(t);
};
z.prototype.clear = function() {
  var t = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : bo(this, t);
};
z.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
z.prototype.toSeq = function() {
  return Tr(this);
};
z.prototype.toJS = function() {
  return vi(this);
};
z.prototype.entries = function() {
  return this.__iterator(ee);
};
z.prototype.__iterator = function(t, r) {
  return Tr(this).__iterator(t, r);
};
z.prototype.__iterate = function(t, r) {
  return Tr(this).__iterate(t, r);
};
z.prototype.__ensureOwner = function(t) {
  if (t === this.__ownerID)
    return this;
  var r = this._values.__ensureOwner(t);
  return t ? bo(this, r, t) : (this.__ownerID = t, this._values = r, this);
};
z.isRecord = kr;
z.getDescriptiveName = wo;
var ct = z.prototype;
ct[Cu] = !0;
ct[vn] = ct.remove;
ct.deleteIn = ct.removeIn = so;
ct.getIn = cc;
ct.hasIn = At.hasIn;
ct.merge = Gu;
ct.mergeWith = Vu;
ct.mergeIn = fo;
ct.mergeDeep = Wu;
ct.mergeDeepWith = Ju;
ct.mergeDeepIn = lo;
ct.setIn = io;
ct.update = oo;
ct.updateIn = ao;
ct.withMutations = mn;
ct.asMutable = _n;
ct.asImmutable = bn;
ct[Pi] = ct.entries;
ct.toJSON = ct.toObject = At.toObject;
ct.inspect = ct.toSource = function() {
  return this.toString();
};
function bo(e, t, r) {
  var n = Object.create(Object.getPrototypeOf(e));
  return n._values = t, n.__ownerID = r, n;
}
function wo(e) {
  return e.constructor.displayName || e.constructor.name || "Record";
}
function Tr(e) {
  return Ws(e._keys.map(function(t) {
    return [t, e.get(t)];
  }));
}
function Yd(e, t) {
  try {
    Object.defineProperty(e, t, {
      get: function() {
        return this.get(t);
      },
      set: function(r) {
        no(this.__ownerID, "Cannot set on an immutable record."), this.set(t, r);
      }
    });
  } catch {
  }
}
const Wd = {
  startDate: void 0,
  endDate: void 0,
  userLimit: 0,
  projectLimit: 0,
  isTrial: !1,
  isExpired: !1,
  functionalities: []
};
class yi extends z(Wd, "Subscription") {
  get isValid() {
    return !!this.startDate && !!this.endDate;
  }
  get isActive() {
    return !this.startDate || !this.endDate ? !1 : new yf(this.startDate, this.endDate).contains(or.now());
  }
  get daysLeft() {
    return this.endDate ? this.endDate.getAbsoluteDifferenceInDays(or.now()) : 0;
  }
  hasEndDateIncoming() {
    return this.endDate ? this.endDate.isAfterInDays(or.now()) : !1;
  }
}
class Jd {
  toDomain(t) {
    if (t)
      return t.map((r) => {
        var n;
        return (n = r.id) == null ? void 0 : n.toLowerCase();
      }).filter((r) => !!r) ?? [];
  }
}
const Xd = new Jd();
class Zd {
  toDomain(t) {
    return new yi({
      startDate: or.fromISOStringSafe(t.startDate),
      endDate: or.fromISOStringSafe(t.endDate),
      userLimit: t.limitUsers,
      projectLimit: t.limitProjects,
      isTrial: t.isTrial,
      isExpired: t.isExpired,
      functionalities: Xd.toDomain(t.functionalities)
    });
  }
}
const tp = new Zd();
class ep {
  static async fetchSubscription({ accessToken: t, baseUrl: r }, n) {
    const s = await new Ls({
      token: t,
      baseUrl: r,
      endpoint: `v1/subscriptions/${n}`
    }).get();
    return tp.toDomain(s);
  }
}
function Jp(e, t) {
  const { t: r } = gf(e);
  return {
    getErrorMessage: (n) => {
      let i;
      const s = n.name, o = n.code;
      o ? i = `HTTP_${o}` : i = s;
      const a = r(i);
      return a !== i ? a : r(t);
    }
  };
}
class Xp extends Error {
  constructor() {
    super("Not implemented"), this.name = "NotImplementedError";
  }
}
class Zp extends Error {
  constructor() {
    super("The specified value is not supported"), this.name = "NotSupportedValueError";
  }
}
function hc(e) {
  const t = e;
  return t == null ? void 0 : t.code;
}
const rp = 3;
function np(e, t = rp) {
  return (r, n) => {
    const i = hc(n);
    if (!i)
      return !1;
    let s;
    return Array.isArray(e) ? s = e.includes(i) : s = e === i, r <= t && s;
  };
}
const ys = 3e5, dc = new yi(), ii = gi({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  subscription: dc,
  hasFunctionality: () => !1
}), ip = np(mi.TOO_MANY_REQUESTS), tv = lu(
  ({
    apiConnectionInfo: e,
    children: t,
    hubHashId: r,
    loadingComponent: n,
    errorComponent: i
  }) => {
    const { accessToken: s, baseUrl: o } = e ?? {}, a = async () => {
      if (!e || !r)
        return Promise.resolve(new yi());
      try {
        return await ep.fetchSubscription(e, r);
      } catch (p) {
        if (hc(p) === mi.NOT_FOUND)
          return Promise.resolve(new yi());
        throw p;
      }
    }, { data: c, error: u, refetch: f, status: l } = fu(
      ["fetchSubscription", s, r, o],
      a,
      {
        enabled: !!s && !!o && !!r,
        cacheTime: ys,
        staleTime: ys,
        refetchInterval: ys,
        retry: ip,
        context: $s
      }
    ), d = Ar(() => ({
      isInitialized: !!c,
      isLoading: l === "loading",
      error: u || void 0,
      subscription: c ?? dc,
      retry: async () => {
        await f();
      },
      hasFunctionality: (p) => (c == null ? void 0 : c.functionalities.includes(p.toLowerCase())) ?? !1
    }), [c, u, f, l]);
    return l === "loading" && n ? /* @__PURE__ */ ut.jsx(ii.Provider, { value: d, children: n }) : l === "error" && i ? /* @__PURE__ */ ut.jsx(ii.Provider, { value: d, children: i }) : /* @__PURE__ */ ut.jsx(ii.Provider, { value: d, children: t });
  },
  "SubscriptionProvider"
);
function ev() {
  const { isInitialized: e, isLoading: t, error: r, retry: n, subscription: i, hasFunctionality: s } = dn(ii);
  return {
    isInitialized: e,
    isLoading: t,
    error: r,
    retry: n,
    subscription: i,
    hasFunctionality: s
  };
}
const pc = Dr.createContext({
  i18n: void 0
});
function rv() {
  const { i18n: e } = dn(pc);
  return e;
}
function nv({ children: e, i18n: t }) {
  const { Provider: r } = pc;
  return /* @__PURE__ */ ut.jsx(r, { value: { i18n: t }, children: /* @__PURE__ */ ut.jsx(mf, { i18n: t.wrapped, children: e }) });
}
var vc = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.numeral = r();
  })(Wr, function() {
    var t, r, n = "2.0.6", i = {}, s = {}, o = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, a = {
      currentLocale: o.currentLocale,
      zeroFormat: o.zeroFormat,
      nullFormat: o.nullFormat,
      defaultFormat: o.defaultFormat,
      scalePercentBy100: o.scalePercentBy100
    };
    function c(u, f) {
      this._input = u, this._value = f;
    }
    return t = function(u) {
      var f, l, d, p;
      if (t.isNumeral(u))
        f = u.value();
      else if (u === 0 || typeof u > "u")
        f = 0;
      else if (u === null || r.isNaN(u))
        f = null;
      else if (typeof u == "string")
        if (a.zeroFormat && u === a.zeroFormat)
          f = 0;
        else if (a.nullFormat && u === a.nullFormat || !u.replace(/[^0-9]+/g, "").length)
          f = null;
        else {
          for (l in i)
            if (p = typeof i[l].regexps.unformat == "function" ? i[l].regexps.unformat() : i[l].regexps.unformat, p && u.match(p)) {
              d = i[l].unformat;
              break;
            }
          d = d || t._.stringToNumber, f = d(u);
        }
      else
        f = Number(u) || null;
      return new c(u, f);
    }, t.version = n, t.isNumeral = function(u) {
      return u instanceof c;
    }, t._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(u, f, l) {
        var d = s[t.options.currentLocale], p = !1, y = !1, m = 0, _ = "", b = 1e12, w = 1e9, R = 1e6, A = 1e3, F = "", k = !1, O, x, I, N, H, nt, G;
        if (u = u || 0, x = Math.abs(u), t._.includes(f, "(") ? (p = !0, f = f.replace(/[\(|\)]/g, "")) : (t._.includes(f, "+") || t._.includes(f, "-")) && (H = t._.includes(f, "+") ? f.indexOf("+") : u < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), t._.includes(f, "a") && (O = f.match(/a(k|m|b|t)?/), O = O ? O[1] : !1, t._.includes(f, " a") && (_ = " "), f = f.replace(new RegExp(_ + "a[kmbt]?"), ""), x >= b && !O || O === "t" ? (_ += d.abbreviations.trillion, u = u / b) : x < b && x >= w && !O || O === "b" ? (_ += d.abbreviations.billion, u = u / w) : x < w && x >= R && !O || O === "m" ? (_ += d.abbreviations.million, u = u / R) : (x < R && x >= A && !O || O === "k") && (_ += d.abbreviations.thousand, u = u / A)), t._.includes(f, "[.]") && (y = !0, f = f.replace("[.]", ".")), I = u.toString().split(".")[0], N = f.split(".")[1], nt = f.indexOf(","), m = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, N ? (t._.includes(N, "[") ? (N = N.replace("]", ""), N = N.split("["), F = t._.toFixed(u, N[0].length + N[1].length, l, N[1].length)) : F = t._.toFixed(u, N.length, l), I = F.split(".")[0], t._.includes(F, ".") ? F = d.delimiters.decimal + F.split(".")[1] : F = "", y && Number(F.slice(1)) === 0 && (F = "")) : I = t._.toFixed(u, 0, l), _ && !O && Number(I) >= 1e3 && _ !== d.abbreviations.trillion)
          switch (I = String(Number(I) / 1e3), _) {
            case d.abbreviations.thousand:
              _ = d.abbreviations.million;
              break;
            case d.abbreviations.million:
              _ = d.abbreviations.billion;
              break;
            case d.abbreviations.billion:
              _ = d.abbreviations.trillion;
              break;
          }
        if (t._.includes(I, "-") && (I = I.slice(1), k = !0), I.length < m)
          for (var ft = m - I.length; ft > 0; ft--)
            I = "0" + I;
        return nt > -1 && (I = I.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + d.delimiters.thousands)), f.indexOf(".") === 0 && (I = ""), G = I + F + (_ || ""), p ? G = (p && k ? "(" : "") + G + (p && k ? ")" : "") : H >= 0 ? G = H === 0 ? (k ? "-" : "+") + G : G + (k ? "-" : "+") : k && (G = "-" + G), G;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(u) {
        var f = s[a.currentLocale], l = u, d = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, p, y, m;
        if (a.zeroFormat && u === a.zeroFormat)
          y = 0;
        else if (a.nullFormat && u === a.nullFormat || !u.replace(/[^0-9]+/g, "").length)
          y = null;
        else {
          y = 1, f.delimiters.decimal !== "." && (u = u.replace(/\./g, "").replace(f.delimiters.decimal, "."));
          for (p in d)
            if (m = new RegExp("[^a-zA-Z]" + f.abbreviations[p] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), l.match(m)) {
              y *= Math.pow(10, d[p]);
              break;
            }
          y *= (u.split("-").length + Math.min(u.split("(").length - 1, u.split(")").length - 1)) % 2 ? 1 : -1, u = u.replace(/[^0-9\.]+/g, ""), y *= Number(u);
        }
        return y;
      },
      isNaN: function(u) {
        return typeof u == "number" && isNaN(u);
      },
      includes: function(u, f) {
        return u.indexOf(f) !== -1;
      },
      insert: function(u, f, l) {
        return u.slice(0, l) + f + u.slice(l);
      },
      reduce: function(u, f) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof f != "function")
          throw new TypeError(f + " is not a function");
        var l = Object(u), d = l.length >>> 0, p = 0, y;
        if (arguments.length === 3)
          y = arguments[2];
        else {
          for (; p < d && !(p in l); )
            p++;
          if (p >= d)
            throw new TypeError("Reduce of empty array with no initial value");
          y = l[p++];
        }
        for (; p < d; p++)
          p in l && (y = f(y, l[p], p, l));
        return y;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(u) {
        var f = u.toString().split(".");
        return f.length < 2 ? 1 : Math.pow(10, f[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var u = Array.prototype.slice.call(arguments);
        return u.reduce(function(f, l) {
          var d = r.multiplier(l);
          return f > d ? f : d;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(u, f, l, d) {
        var p = u.toString().split("."), y = f - (d || 0), m, _, b, w;
        return p.length === 2 ? m = Math.min(Math.max(p[1].length, y), f) : m = y, b = Math.pow(10, m), w = (l(u + "e+" + m) / b).toFixed(m), d > f - m && (_ = new RegExp("\\.?0{1," + (d - (f - m)) + "}$"), w = w.replace(_, "")), w;
      }
    }, t.options = a, t.formats = i, t.locales = s, t.locale = function(u) {
      return u && (a.currentLocale = u.toLowerCase()), a.currentLocale;
    }, t.localeData = function(u) {
      if (!u)
        return s[a.currentLocale];
      if (u = u.toLowerCase(), !s[u])
        throw new Error("Unknown locale : " + u);
      return s[u];
    }, t.reset = function() {
      for (var u in o)
        a[u] = o[u];
    }, t.zeroFormat = function(u) {
      a.zeroFormat = typeof u == "string" ? u : null;
    }, t.nullFormat = function(u) {
      a.nullFormat = typeof u == "string" ? u : null;
    }, t.defaultFormat = function(u) {
      a.defaultFormat = typeof u == "string" ? u : "0.0";
    }, t.register = function(u, f, l) {
      if (f = f.toLowerCase(), this[u + "s"][f])
        throw new TypeError(f + " " + u + " already registered.");
      return this[u + "s"][f] = l, l;
    }, t.validate = function(u, f) {
      var l, d, p, y, m, _, b, w;
      if (typeof u != "string" && (u += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", u)), u = u.trim(), u.match(/^\d+$/))
        return !0;
      if (u === "")
        return !1;
      try {
        b = t.localeData(f);
      } catch {
        b = t.localeData(t.locale());
      }
      return p = b.currency.symbol, m = b.abbreviations, l = b.delimiters.decimal, b.delimiters.thousands === "." ? d = "\\." : d = b.delimiters.thousands, w = u.match(/^[^\d]+/), w !== null && (u = u.substr(1), w[0] !== p) || (w = u.match(/[^\d]+$/), w !== null && (u = u.slice(0, -1), w[0] !== m.thousand && w[0] !== m.million && w[0] !== m.billion && w[0] !== m.trillion)) ? !1 : (_ = new RegExp(d + "{2}"), u.match(/[^\d.,]/g) ? !1 : (y = u.split(l), y.length > 2 ? !1 : y.length < 2 ? !!y[0].match(/^\d+.*\d$/) && !y[0].match(_) : y[0].length === 1 ? !!y[0].match(/^\d+$/) && !y[0].match(_) && !!y[1].match(/^\d+$/) : !!y[0].match(/^\d+.*\d$/) && !y[0].match(_) && !!y[1].match(/^\d+$/)));
    }, t.fn = c.prototype = {
      clone: function() {
        return t(this);
      },
      format: function(u, f) {
        var l = this._value, d = u || a.defaultFormat, p, y, m;
        if (f = f || Math.round, l === 0 && a.zeroFormat !== null)
          y = a.zeroFormat;
        else if (l === null && a.nullFormat !== null)
          y = a.nullFormat;
        else {
          for (p in i)
            if (d.match(i[p].regexps.format)) {
              m = i[p].format;
              break;
            }
          m = m || t._.numberToFormat, y = m(l, d, f);
        }
        return y;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(u) {
        return this._value = Number(u), this;
      },
      add: function(u) {
        var f = r.correctionFactor.call(null, this._value, u);
        function l(d, p, y, m) {
          return d + Math.round(f * p);
        }
        return this._value = r.reduce([this._value, u], l, 0) / f, this;
      },
      subtract: function(u) {
        var f = r.correctionFactor.call(null, this._value, u);
        function l(d, p, y, m) {
          return d - Math.round(f * p);
        }
        return this._value = r.reduce([u], l, Math.round(this._value * f)) / f, this;
      },
      multiply: function(u) {
        function f(l, d, p, y) {
          var m = r.correctionFactor(l, d);
          return Math.round(l * m) * Math.round(d * m) / Math.round(m * m);
        }
        return this._value = r.reduce([this._value, u], f, 1), this;
      },
      divide: function(u) {
        function f(l, d, p, y) {
          var m = r.correctionFactor(l, d);
          return Math.round(l * m) / Math.round(d * m);
        }
        return this._value = r.reduce([this._value, u], f), this;
      },
      difference: function(u) {
        return Math.abs(t(this._value).subtract(u).value());
      }
    }, t.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(u) {
        var f = u % 10;
        return ~~(u % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      t.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(u, f, l) {
          var d = t._.includes(f, " BPS") ? " " : "", p;
          return u = u * 1e4, f = f.replace(/\s?BPS/, ""), p = t._.numberToFormat(u, f, l), t._.includes(p, ")") ? (p = p.split(""), p.splice(-1, 0, d + "BPS"), p = p.join("")) : p = p + d + "BPS", p;
        },
        unformat: function(u) {
          return +(t._.stringToNumber(u) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var u = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, f = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, l = u.suffixes.concat(f.suffixes.filter(function(p) {
        return u.suffixes.indexOf(p) < 0;
      })), d = l.join("|");
      d = "(" + d.replace("B", "B(?!PS)") + ")", t.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(d)
        },
        format: function(p, y, m) {
          var _, b = t._.includes(y, "ib") ? f : u, w = t._.includes(y, " b") || t._.includes(y, " ib") ? " " : "", R, A, F;
          for (y = y.replace(/\s?i?b/, ""), R = 0; R <= b.suffixes.length; R++)
            if (A = Math.pow(b.base, R), F = Math.pow(b.base, R + 1), p === null || p === 0 || p >= A && p < F) {
              w += b.suffixes[R], A > 0 && (p = p / A);
              break;
            }
          return _ = t._.numberToFormat(p, y, m), _ + w;
        },
        unformat: function(p) {
          var y = t._.stringToNumber(p), m, _;
          if (y) {
            for (m = u.suffixes.length - 1; m >= 0; m--) {
              if (t._.includes(p, u.suffixes[m])) {
                _ = Math.pow(u.base, m);
                break;
              }
              if (t._.includes(p, f.suffixes[m])) {
                _ = Math.pow(f.base, m);
                break;
              }
            }
            y *= _ || 1;
          }
          return y;
        }
      });
    }(), function() {
      t.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(u, f, l) {
          var d = t.locales[t.options.currentLocale], p = {
            before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, y, m, _;
          for (f = f.replace(/\s?\$\s?/, ""), y = t._.numberToFormat(u, f, l), u >= 0 ? (p.before = p.before.replace(/[\-\(]/, ""), p.after = p.after.replace(/[\-\)]/, "")) : u < 0 && !t._.includes(p.before, "-") && !t._.includes(p.before, "(") && (p.before = "-" + p.before), _ = 0; _ < p.before.length; _++)
            switch (m = p.before[_], m) {
              case "$":
                y = t._.insert(y, d.currency.symbol, _);
                break;
              case " ":
                y = t._.insert(y, " ", _ + d.currency.symbol.length - 1);
                break;
            }
          for (_ = p.after.length - 1; _ >= 0; _--)
            switch (m = p.after[_], m) {
              case "$":
                y = _ === p.after.length - 1 ? y + d.currency.symbol : t._.insert(y, d.currency.symbol, -(p.after.length - (1 + _)));
                break;
              case " ":
                y = _ === p.after.length - 1 ? y + " " : t._.insert(y, " ", -(p.after.length - (1 + _) + d.currency.symbol.length - 1));
                break;
            }
          return y;
        }
      });
    }(), function() {
      t.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(u, f, l) {
          var d, p = typeof u == "number" && !t._.isNaN(u) ? u.toExponential() : "0e+0", y = p.split("e");
          return f = f.replace(/e[\+|\-]{1}0/, ""), d = t._.numberToFormat(Number(y[0]), f, l), d + "e" + y[1];
        },
        unformat: function(u) {
          var f = t._.includes(u, "e+") ? u.split("e+") : u.split("e-"), l = Number(f[0]), d = Number(f[1]);
          d = t._.includes(u, "e-") ? d *= -1 : d;
          function p(y, m, _, b) {
            var w = t._.correctionFactor(y, m), R = y * w * (m * w) / (w * w);
            return R;
          }
          return t._.reduce([l, Math.pow(10, d)], p, 1);
        }
      });
    }(), function() {
      t.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(u, f, l) {
          var d = t.locales[t.options.currentLocale], p, y = t._.includes(f, " o") ? " " : "";
          return f = f.replace(/\s?o/, ""), y += d.ordinal(u), p = t._.numberToFormat(u, f, l), p + y;
        }
      });
    }(), function() {
      t.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(u, f, l) {
          var d = t._.includes(f, " %") ? " " : "", p;
          return t.options.scalePercentBy100 && (u = u * 100), f = f.replace(/\s?\%/, ""), p = t._.numberToFormat(u, f, l), t._.includes(p, ")") ? (p = p.split(""), p.splice(-1, 0, d + "%"), p = p.join("")) : p = p + d + "%", p;
        },
        unformat: function(u) {
          var f = t._.stringToNumber(u);
          return t.options.scalePercentBy100 ? f * 0.01 : f;
        }
      });
    }(), function() {
      t.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(u, f, l) {
          var d = Math.floor(u / 60 / 60), p = Math.floor((u - d * 60 * 60) / 60), y = Math.round(u - d * 60 * 60 - p * 60);
          return d + ":" + (p < 10 ? "0" + p : p) + ":" + (y < 10 ? "0" + y : y);
        },
        unformat: function(u) {
          var f = u.split(":"), l = 0;
          return f.length === 3 ? (l = l + Number(f[0]) * 60 * 60, l = l + Number(f[1]) * 60, l = l + Number(f[2])) : f.length === 2 && (l = l + Number(f[0]) * 60, l = l + Number(f[1])), Number(l);
        }
      });
    }(), t;
  });
})(vc);
var sp = vc.exports;
const op = /* @__PURE__ */ Fs(sp);
function ap(e, t, r) {
  return t === "uppercase" ? e.toUpperCase() : or.isDateTime(e) ? e.formatWithLocale(t, r) : typeof e == "number" ? op(Number(e)).format(t) : e;
}
class hn {
  constructor(t) {
    this.wrappedInstance = t;
  }
  static async createOther(t, r, n, i) {
    const s = hn.buildOptions(t, r, n, i), o = ui.createInstance(s);
    return await o.init(), new hn(o);
  }
  get wrapped() {
    return this.wrappedInstance;
  }
  get language() {
    return this.wrappedInstance.language;
  }
  changeLanguage(t) {
    var r;
    (r = this.wrappedInstance) == null || r.changeLanguage(t);
  }
  static buildOptions(t, r, n, i, s) {
    return {
      returnNull: !1,
      lng: s ?? ui.language,
      supportedLngs: [Ce.EN, Ce.FR],
      nonExplicitSupportedLngs: !0,
      fallbackLng: Ce.EN,
      debug: !1,
      resources: t,
      defaultNS: r,
      fallbackNS: n,
      interpolation: {
        escapeValue: !1,
        // not needed for react
        format: i ?? ap
      },
      react: {
        defaultTransParent: "span"
      },
      detection: {
        order: ["querystring", "localStorage", "navigator", "htmlTag"],
        lookupQuerystring: "lang",
        lookupLocalStorage: "lang",
        caches: ["localStorage"],
        excludeCacheFor: ["cimode"]
      }
    };
  }
}
const Qa = "user_language", up = Ce.EN;
class en extends hn {
  constructor(t, r) {
    super(t), this.storage = r;
  }
  static async createMain(t, r, n, i, s) {
    const o = en.loadLanguage(i) || up;
    en.saveLanguage(o, i);
    const a = hn.buildOptions(t, r, n, s, o);
    return await ui.init(a), new en(ui, i);
  }
  changeLanguage(t) {
    super.changeLanguage(t), en.saveLanguage(t, this.storage);
  }
  static loadLanguage(t) {
    return t == null ? void 0 : t.readString(Qa);
  }
  static saveLanguage(t, r) {
    r == null || r.writeString(Qa, t);
  }
}
var yc = /* @__PURE__ */ ((e) => (e[e.LOCAL = -1] = "LOCAL", e[e.CANADA = 0] = "CANADA", e[e.NORTH_EUROPE = 1] = "NORTH_EUROPE", e[e.EUROPE = 2] = "EUROPE", e[e.USA = 3] = "USA", e))(yc || {});
const cp = {
  id: yc.LOCAL,
  name: ""
};
class fp extends z(cp, "DataCenterAttribute") {
}
const lp = {
  globalId: void 0,
  hashId: "",
  localId: -1,
  name: "",
  creationDate: or.MIN_VALUE,
  demoDaysLeft: void 0,
  owner: "",
  dataCenterInfo: new fp(),
  metrics: void 0,
  projects: [],
  avatarImage: void 0,
  hasAPIAccessToken: !1,
  APIAccessTokenAcceptationTermsDate: void 0,
  isLinkedToOrganization: !1,
  url: "",
  subscription: void 0,
  projectTemplates: void 0,
  bimTrackRegionalApiUrl: void 0
};
class iv extends z(lp, "Hub") {
  /**
   * @deprecated use hashId instead.
   */
  get id() {
    return this.hashId;
  }
  /**
   * @deprecated use dataCenterInfo.id instead.
   */
  get dataCenter() {
    return this.dataCenterInfo.id;
  }
  get avatarImageWithDefault() {
    return this.avatarImage;
  }
  get isSubscriptionExpired() {
    return this.subscription ? this.subscription.isExpired : !1;
  }
  get subscriptionPlanProjectLimit() {
    return this.subscription ? this.subscription.projectLimit : 0;
  }
  is(t) {
    return t ? this.id === t.id && this.localId === t.localId : !1;
  }
}
const hp = {
  totalUsers: void 0
};
class sv extends z(hp, "HubMetrics") {
}
var dp = /* @__PURE__ */ ((e) => (e.PROCORE = "Procore", e))(dp || {}), Wt = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.PREDEFINED = "predefined", e.TITLE = "title", e.DESCRIPTION = "description", e.STATUS = "status", e.TYPE = "type", e.PRIORITY = "priority", e.DISCIPLINE = "discipline", e.ZONE = "zone", e.PHASE = "phase", e.ASSIGNED_TO = "assignedto", e.DUE_DATE = "duedate", e.ISSUE_GROUP = "issuegroup", e.TEAM = "team", e.NOTIFY = "notify", e.CONFIDENTIALITY = "confidentiality", e.VISIBILITY = "visibility", e))(Wt || {}), Eo = /* @__PURE__ */ ((e) => (e.ADMIN = "Admin", e.EDITOR = "Editor", e.READER = "Reader", e))(Eo || {}), gc = /* @__PURE__ */ ((e) => (e[e.ACTIVE = 0] = "ACTIVE", e[e.ON_HOLD = 1] = "ON_HOLD", e[e.COMPLETION_PENDING = 2] = "COMPLETION_PENDING", e[e.COMPLETED = 3] = "COMPLETED", e))(gc || {});
const pp = {
  statuses: [],
  types: [],
  priorities: [],
  zones: [],
  phases: [],
  disciplines: [],
  customAttributes: []
};
class vp extends z(pp, "IssueAttributeOptions") {
}
const yp = {
  id: -1,
  name: "",
  type: Wt.TEXT,
  values: void 0
};
class gp extends z(yp, "ProjectAttribute") {
}
const mp = {
  attributes: [],
  selectedColorAttributeForIssue: new gp(),
  integrations: [],
  issueMandatoryAttributes: []
};
class _p extends z(mp, "ProjectSettings") {
}
const bp = {
  role: Eo.READER,
  teams: [],
  isReviewer: !1
};
class wp extends z(bp, "ProjectUserPermissions") {
}
const Ep = {
  id: -1,
  name: "",
  status: gc.ACTIVE,
  settings: new _p(),
  users: [],
  teams: [],
  requestingUserPermissions: new wp()
};
class ov extends z(Ep, "Project") {
  is(t) {
    return t ? this.id === t.id : !1;
  }
  hasId(t) {
    return t ? this.id === t : !1;
  }
  getIssueGroupsOptions() {
    return this.getOptionsFor(Wt.ISSUE_GROUP);
  }
  getAttributesFor(t) {
    return this.settings.attributes.filter(
      (n) => n.type === t
    ) || [];
  }
  getSortedCustomAttributes() {
    return [
      ...this.getAttributesFor(Wt.TEXT),
      ...this.getAttributesFor(Wt.PREDEFINED)
    ].sort((r, n) => r.id - n.id);
  }
  getOptionsFor(t) {
    const r = this.settings.attributes.find(
      (n) => n.type === t
    );
    return r && r.values ? r.values : [];
  }
  getOptionsForIssue() {
    const t = this.getOptionsFor(Wt.STATUS), r = this.getOptionsFor(Wt.TYPE), n = this.getOptionsFor(Wt.PRIORITY), i = this.getOptionsFor(Wt.ZONE), s = this.getOptionsFor(Wt.PHASE), o = this.getOptionsFor(Wt.DISCIPLINE), a = this.getSortedCustomAttributes();
    return new vp({
      statuses: t,
      types: r,
      priorities: n,
      zones: i,
      phases: s,
      disciplines: o,
      customAttributes: a
    });
  }
  getStatusesBaseOnUser(t, r) {
    const n = t.teams ?? [];
    let i = this.getOptionsFor(Wt.STATUS).filter((s) => {
      const o = s.teams ? s.teams.map((a) => a.id) : [];
      return o.length === 0 || n.some((a) => o.indexOf(a.id) !== -1);
    });
    return i.some((s) => s.id === r.id) || (i = [...i, r].sort((s, o) => s.name.localeCompare(o.name))), i;
  }
  getIntegrationFor(t) {
    return this.settings.integrations.find(
      (r) => r.integration.name.toLowerCase() === t.toLowerCase()
    );
  }
  getIssueMandatoryAttributes() {
    return this.settings.issueMandatoryAttributes;
  }
  getAttributes() {
    return this.settings.attributes;
  }
}
const Sp = {
  id: -1,
  name: ""
};
class av extends z(Sp, "ProjectTemplate") {
}
const Op = {
  id: -1,
  name: ""
};
class uv extends z(Op, "ProjectTeam") {
}
const Ip = {
  id: -1,
  name: "",
  siteUrl: ""
};
class Cp extends z(Ip, "Integration") {
}
const Pp = {
  id: -1,
  name: "",
  color: void 0,
  teams: void 0
};
class cv extends z(Pp, "ProjectAttributeValue") {
}
const Rp = {
  companyId: -1,
  companyName: "",
  projectId: -1,
  projectName: "",
  createRFIComment: !1
};
class fv extends z(Rp, "ProcoreIntegrationData") {
}
const Tp = {
  id: -1,
  integration: new Cp(),
  data: {}
};
class lv extends z(Tp, "ProjectIntegration") {
}
const Dp = {
  id: "",
  name: ""
};
class hv extends z(Dp, "PropertyAttribute") {
}
const Ap = {
  user: void 0,
  hub: void 0,
  project: void 0,
  bimTrackApiUrl: ""
};
class dv extends z(Ap, "Session") {
}
const pv = {
  trial: "ea0b2704-81d5-46e2-b4fd-b21dcbabbbc8"
}, vv = {
  viewer3D: {
    access3dViewer: "DC7C3D37-B1F5-4D37-A845-D0142456C63C"
  },
  email: {
    emailManagement: "F4A0BF34-DBD0-4EB0-9816-2BE2F98FE8D9",
    noDeleteEmail: "C1C96C15-59CD-48F8-9DBF-EFFF5D415784"
  },
  rfi: {
    workflow: "76A6ED51-6F7C-40FE-B61A-09254BA2E217"
  },
  edmsConnector: {
    sharingData: "649BD28E-E95F-4C4A-ADCA-5AC4A7D29297"
  }
};
var mc = /* @__PURE__ */ ((e) => (e.EN_US = "M/D/YYYY h:mm A", e.EN_CA = "YYYY-MM-DD h:mm A", e.FR_CA = "DD/MM/YYYY HH:mm", e))(mc || {}), nn = /* @__PURE__ */ ((e) => (e.GUEST = "Guest", e.ADMIN = "Admin", e))(nn || {}), si = /* @__PURE__ */ ((e) => (e.UTC = "UTC", e.NEW_YORK = "America/New_York", e.DUBAI = "Asia/Asia/Dubai", e))(si || {}), _c = /* @__PURE__ */ ((e) => (e.ACTIVE = "Active", e.INACTIVE = "Inactive", e))(_c || {});
const xp = {
  id: "",
  name: "",
  format: mc.EN_US
};
class kp extends z(xp, "DateFormatAttribute") {
}
const Fp = {
  id: Ce.EN,
  name: ""
};
class Lp extends z(Fp, "LanguageAttribute") {
}
const Np = {
  id: si.NEW_YORK,
  name: si.NEW_YORK,
  nameIana: si.NEW_YORK,
  offset: void 0
};
class Mp extends z(Np, "TimeZoneAttribute") {
}
const qp = {
  firstName: "",
  lastName: "",
  title: "",
  company: "",
  country: void 0,
  industry: void 0,
  jobTitle: "",
  dateFormat: new kp(),
  avatarImage: "",
  language: new Lp(),
  website: void 0,
  timeZone: new Mp()
};
class Up extends z(qp, "UserProfile") {
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  get initials() {
    return this.firstName && this.lastName ? `${Array.from(this.firstName)[0]}${Array.from(this.lastName)[0]}` : "";
  }
  getDateTimeFormat() {
    return this.dateFormat.format;
  }
  getDateFormat() {
    return this.dateFormat.format.replace(/ .*/, "");
  }
  getTimeFormat() {
    return this.dateFormat.format.replace(/([^\s]+) /, "");
  }
}
const jp = {
  id: -1,
  globalId: void 0,
  email: "",
  profile: new Up(),
  status: _c.INACTIVE,
  activationDate: void 0,
  invitationPending: !1,
  isPending: !1,
  lastHubProjectActivity: void 0,
  canResendInvite: void 0,
  hubOwner: !1,
  hubRole: nn.GUEST,
  projectOwner: !1,
  projectReviewer: !1,
  projectRole: void 0,
  projects: [],
  teams: [],
  isProviderExternal: !1
};
class yv extends z(jp, "User") {
  get fullName() {
    return this.isValid() ? this.profile.fullName : `${this.profile.title}`.trim();
  }
  get fullNameAndEmail() {
    return `${this.fullName} (${this.email})`.trim();
  }
  get initials() {
    return this.profile.initials;
  }
  isNew() {
    return this.id === 0;
  }
  isOwner() {
    return this.hubOwner;
  }
  isAdmin() {
    return this.hubRole === nn.ADMIN;
  }
  isGuest() {
    return this.hubRole === nn.GUEST;
  }
  isProjectAdmin() {
    return this.projectRole === Eo.ADMIN;
  }
  isProjectOwner() {
    return this.projectOwner;
  }
  isTeamMember(t) {
    return this.teams.some((r) => r.id === t);
  }
  canEditUser(t) {
    return this.is(t) || this.hubRole === nn.GUEST ? !1 : this.isOwner() || !t.isOwner();
  }
  is(t) {
    return t ? this.id === t.id : !1;
  }
  getDateTimeFormat() {
    return this.profile.getDateTimeFormat();
  }
  getDateFormat() {
    return this.profile.getDateFormat();
  }
  getTimeFormat() {
    return this.profile.getTimeFormat();
  }
  isValid() {
    return this.id > 0;
  }
}
const $p = {
  id: -1,
  name: ""
};
class gv extends z($p, "UserProject") {
  is(t) {
    return t ? this.id === t.id : !1;
  }
  hasId(t) {
    return t ? this.id === t : !1;
  }
}
function mv(e) {
  return Object.keys(e).filter((t) => Number.isNaN(+t));
}
function _v(e) {
  if (e == null)
    throw new Error(`Expected 'val' to be defined, but received ${e}`);
}
function bc(e) {
  if (z.isRecord(e))
    switch (z.getDescriptiveName(e)) {
      case "Session": {
        const { hub: t, project: r } = e;
        return {
          hubHashId: (t == null ? void 0 : t.hashId) ?? null,
          projectId: (r == null ? void 0 : r.id) ?? null
        };
      }
      case "Hub": {
        const t = e;
        return {
          hubHashId: (t == null ? void 0 : t.hashId) ?? null
        };
      }
      case "Project": {
        const t = e;
        return {
          projectId: (t == null ? void 0 : t.id) ?? null
        };
      }
    }
}
function bv(...e) {
  const t = [];
  let r, n = 0;
  typeof e[n] == "string" && t.push(e[n++]), r = e[n++], Array.isArray(r) || (r = [r]);
  for (const i of r)
    t.push(i == null ? void 0 : i.accessToken), t.push(i == null ? void 0 : i.baseUrl);
  for (; n < e.length; ++n) {
    const i = e[n], s = bc(i);
    if (!s) {
      t.push(i);
      continue;
    }
    s.hubHashId !== void 0 && t.push((s == null ? void 0 : s.hubHashId) ?? void 0), s.projectId !== void 0 && t.push(s.projectId ?? void 0);
  }
  return t;
}
function Yr(e) {
  return typeof e == "number" ? !0 : !!e;
}
function wv(...e) {
  let t, r = 0;
  t = e[r++], Array.isArray(t) || (t = [t]);
  for (const n of t)
    if (!Yr(n == null ? void 0 : n.accessToken) || !Yr(n == null ? void 0 : n.baseUrl))
      return !1;
  for (; r < e.length; ++r) {
    const n = e[r], i = bc(n);
    if (!i) {
      if (!Yr(e[r]))
        return !1;
      continue;
    }
    if (i.hubHashId !== void 0 && !Yr(i.hubHashId) || i.projectId !== void 0 && !Yr(i.projectId))
      return !1;
  }
  return !0;
}
class Ev {
  readString(t) {
    const r = localStorage.getItem(t);
    if (r)
      return r;
  }
  readObject(t) {
    const r = this.readString(t);
    if (r)
      return JSON.parse(r);
  }
  writeString(t, r) {
    localStorage.setItem(t, r);
  }
  writeObject(t, r) {
    this.writeString(t, JSON.stringify(r));
  }
  remove(t) {
    localStorage.removeItem(t);
  }
}
var zp = /* @__PURE__ */ ((e) => (e.Ifc = "application/vnd.newforma.viewer.ifc", e.Sheet = "application/vnd.newforma.viewer.pdf", e.SheetImg = "application/vnd.newforma.viewer.pdf.img", e.AnyFile = "application/vnd.newforma.viewer.any", e.IfcError = "application/vnd.newforma.viewer.ifc.err", e.IfcLog = "application/vnd.newforma.viewer.ifc.log", e.IfcSiteOrigin = "application/vnd.newforma.viewer.ifc.site+json", e.IfcBt3d = "application/vnd.newforma.viewer.ifc.bt3d", e.IfcProperty = "application/vnd.newforma.viewer.ifc.property+7zip", e))(zp || {});
export {
  ar as BaseClient,
  Ja as BlobClient,
  jo as BrowserCultureInfo,
  Ls as Client,
  Wa as Credentials,
  yc as DataCenter,
  fp as DataCenterAttribute,
  mc as DateFormat,
  kp as DateFormatAttribute,
  Vf as FederatedComponent,
  vv as Functionalities,
  tl as GainSightGate,
  Wf as GainSightProvider,
  Rf as HeadClient,
  Ne as HttpMethod,
  iv as Hub,
  sv as HubMetrics,
  nn as HubUserRole,
  hn as I18n,
  en as I18nMain,
  nv as I18nProvider,
  Cp as Integration,
  dp as IntegrationName,
  vp as IssueAttributeOptions,
  Ce as Language,
  Lp as LanguageAttribute,
  Yp as LaunchDarklyProvider,
  Ev as LocalStorageService,
  el as LocaleSetup,
  rp as MAX_RETRY_COUNT,
  pv as Modules,
  Xp as NotImplementedError,
  Zp as NotSupportedValueError,
  fv as ProcoreIntegrationData,
  ov as Project,
  gp as ProjectAttribute,
  Wt as ProjectAttributeType,
  cv as ProjectAttributeValue,
  lv as ProjectIntegration,
  _p as ProjectSettings,
  gc as ProjectStatus,
  uv as ProjectTeam,
  av as ProjectTemplate,
  wp as ProjectUserPermissions,
  Eo as ProjectUserRole,
  hv as PropertyAttribute,
  br as RemoteModuleStatus,
  bf as RequestCanceledError,
  _f as RequestTimeoutError,
  dv as Session,
  yi as Subscription,
  ep as SubscriptionApi,
  tp as SubscriptionAssembler,
  Xd as SubscriptionFunctionalityAssembler,
  tv as SubscriptionProvider,
  Pf as TIMEOUT_IN_MILLIS,
  si as TimeZone,
  Mp as TimeZoneAttribute,
  yv as User,
  Up as UserProfile,
  gv as UserProject,
  _c as UserStatus,
  zp as ViewerMimeTypes,
  _v as assertIsDefined,
  bv as buildFetchKeys,
  np as canRetryQuery,
  cp as dataCenterAttributeDefaultProps,
  xp as dateFormatAttributeDefaultProps,
  ap as defaultFormatter,
  mv as enumKeys,
  hc as getHttpErrorCode,
  lp as hubDefaultProps,
  hp as hubMetricsDefaultProps,
  Ip as integrationDefaultProps,
  wv as isReadyToFetch,
  pp as issueAttributeOptionsDefaultProps,
  Fp as languageAttributeDefaultProps,
  kf as loadRemoteModule,
  xf as loadRemoteScript,
  Rp as procoreIntegrationDataDefaultProps,
  yp as projectAttributeDefaultProps,
  Pp as projectAttributeValueDefaultProps,
  Ep as projectDefaultProps,
  Tp as projectIntegrationDefaultProps,
  mp as projectSettingsDefaultProps,
  Op as projectTeamDefaultProps,
  Sp as projectTemplateDefaultProps,
  bp as projectUserPermissionsDefaultProps,
  Dp as propertyAttributeDefaultProps,
  Vp as resetRemoteModuleCache,
  Ap as sessionDefaultProps,
  Wd as subscriptionDefaultProps,
  Np as timeZoneAttributeDefaultProps,
  Jp as useErrorMapper,
  Zf as useGainSight,
  rv as useI18n,
  Wp as useLaunchDarkly,
  Ff as useRemoteModule,
  ev as useSubscription,
  qp as userDefaultProfileProps,
  jp as userDefaultProps,
  $p as userDefaultUserProject
};
